// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
  urlSearchParamsBodySerializer,
} from "./client";
import { client } from "./client.gen";
import type {
  AcceptTenantInvitationData,
  AcceptTenantInvitationResponses,
  ActivateDeploymentData,
  ActivateDeploymentErrors,
  ActivateDeploymentResponses,
  ActivateDevLicenseData,
  ActivateDevLicenseResponses,
  ActivateProviderData,
  ActivateProviderErrors,
  ActivateProviderResponses,
  ActivateTenantData,
  ActivateTenantErrors,
  ActivateTenantResponses,
  AddAdminMessageData,
  AddAdminMessageErrors,
  AddAdminMessageResponses,
  AddAssistantData,
  AddAssistantErrors,
  AddAssistantResponses,
  AddColumnData,
  AddColumnErrors,
  AddColumnResponses,
  AddCsatResponseData,
  AddCsatResponseErrors,
  AddCsatResponseResponses,
  AddImageData,
  AddImageErrors,
  AddImageResponses,
  AddKnowledgeBaseDocumentData,
  AddKnowledgeBaseDocumentErrors,
  AddKnowledgeBaseDocumentResponses,
  AddKnowledgeBaseV2Data,
  AddKnowledgeBaseV2Errors,
  AddKnowledgeBaseV2Responses,
  AddLimitData,
  AddLimitErrors,
  AddLimitResponses,
  AddMessageData,
  AddMessageErrors,
  AddMessageFeedbackData,
  AddMessageFeedbackErrors,
  AddMessageFeedbackResponses,
  AddMessageResponses,
  AddProviderRegionData,
  AddProviderRegionErrors,
  AddProviderRegionResponses,
  AddPublicImageData,
  AddPublicImageErrors,
  AddPublicImageResponses,
  AddUserData,
  AddUserErrors,
  AddUserResponses,
  AddUserToGroupData,
  AddUserToGroupErrors,
  AddUserToGroupResponses,
  AddWorkflowData,
  AddWorkflowErrors,
  AddWorkflowResponses,
  AdminCreateTenantData,
  AdminCreateTenantErrors,
  AdminCreateTenantResponses,
  AdminInviteUserData,
  AdminInviteUserErrors,
  AdminInviteUserResponses,
  AdminJoinTenantData,
  AdminJoinTenantErrors,
  AdminJoinTenantResponses,
  AdminKbChaosData,
  AdminKbChaosErrors,
  AdminKbChaosResponses,
  AdminResumeRunData,
  AdminResumeRunErrors,
  AdminResumeRunResponses,
  AdminStopRunData,
  AdminStopRunErrors,
  AdminStopRunResponses,
  AdminUnjoinTenantData,
  AdminUnjoinTenantResponses,
  ApplyAssistantCapabilityUpdatesData,
  ApplyAssistantCapabilityUpdatesErrors,
  ApplyAssistantCapabilityUpdatesResponses,
  ApplyLocalTestPresetData,
  ApplyLocalTestPresetResponses,
  AssignGroupUserRoleData,
  AssignGroupUserRoleErrors,
  AssignGroupUserRoleResponses,
  AssignLabellingTaskData,
  AssignLabellingTaskErrors,
  AssignLabellingTaskResponses,
  AssignUserRoleData,
  AssignUserRoleErrors,
  AssignUserRoleResponses,
  AuthBootstrapStatusData,
  AuthBootstrapStatusResponses,
  AuthorizeEmbedData,
  AuthorizeEmbedErrors,
  AuthorizeEmbedResponses,
  AuthRuntimeData,
  AuthRuntimeResponses,
  BatchGetNodeConfigData,
  BatchGetNodeConfigErrors,
  BatchGetNodeConfigResponses,
  BillingRectificationCorrectPricesData,
  BillingRectificationCorrectPricesErrors,
  BillingRectificationCorrectPricesResponses,
  BillingRectificationDeduplicateData,
  BillingRectificationDeduplicateErrors,
  BillingRectificationDeduplicateResponses,
  BillingRectificationEventsData,
  BillingRectificationEventsErrors,
  BillingRectificationEventsResponses,
  BillingRectificationSummaryData,
  BillingRectificationSummaryErrors,
  BillingRectificationSummaryResponses,
  BulkDeleteConversationsData,
  BulkDeleteConversationsErrors,
  BulkDeleteConversationsResponses,
  BulkDeleteData,
  BulkDeleteErrors,
  BulkDeleteKnowledgeBaseDocumentsData,
  BulkDeleteKnowledgeBaseDocumentsErrors,
  BulkDeleteKnowledgeBaseDocumentsResponses,
  BulkDeleteResponses,
  BulkDeleteRowsData,
  BulkDeleteRowsErrors,
  BulkDeleteRowsResponses,
  BulkDuplicateRowsData,
  BulkDuplicateRowsErrors,
  BulkDuplicateRowsResponses,
  BulkExportConversationsCsvData,
  BulkExportConversationsCsvErrors,
  BulkExportConversationsCsvResponses,
  BulkExportFeedbackCsvData,
  BulkExportFeedbackCsvErrors,
  BulkExportFeedbackCsvResponses,
  BulkExportRunsCsvData,
  BulkExportRunsCsvErrors,
  BulkExportRunsCsvResponses,
  BulkRerunData,
  BulkRerunErrors,
  BulkRerunResponses,
  BulkResumeData,
  BulkResumeErrors,
  BulkResumeResponses,
  BulkRetryData,
  BulkRetryErrors,
  BulkRetryResponses,
  BulkSetDisabledData,
  BulkSetDisabledErrors,
  BulkSetDisabledResponses,
  BulkStopData,
  BulkStopErrors,
  BulkStopResponses,
  BulkTagEntitiesData,
  BulkTagEntitiesErrors,
  BulkTagEntitiesResponses,
  CancelEvaluationRunData,
  CancelEvaluationRunErrors,
  CancelEvaluationRunResponses,
  CancelSubscriptionCancelationData,
  CancelSubscriptionCancelationResponses,
  ChangeAuthRuntimeData,
  ChangeAuthRuntimeErrors,
  ChangeAuthRuntimeResponses,
  ChangeColumnTypeData,
  ChangeColumnTypeErrors,
  ChangeColumnTypeResponses,
  ChaosTestEnabledData,
  ChaosTestEnabledErrors,
  ChaosTestEnabledResponses,
  ChaosTestLinksData,
  ChaosTestLinksErrors,
  ChaosTestLinksResponses,
  CheckAuthorizedData,
  CheckAuthorizedResponses,
  CheckDomainReservationData,
  CheckDomainReservationErrors,
  CheckDomainReservationResponses,
  CheckEmailVerificationData,
  CheckEmailVerificationErrors,
  CheckEmailVerificationResponses,
  CheckPrefixData,
  CheckPrefixErrors,
  CheckPrefixResponses,
  CheckSlugData,
  CheckSlugErrors,
  CheckSlugResponses,
  ClearRowsData,
  ClearRowsErrors,
  ClearRowsResponses,
  ClientAuthorizeData,
  ClientAuthorizeErrors,
  ClientAuthorizeResponses,
  ClientTokenData,
  ClientTokenErrors,
  ClientTokenResponses,
  CloneCaseData,
  CloneCaseErrors,
  CloneCaseResponses,
  CompleteCliponeIntegrationData,
  CompleteCliponeIntegrationErrors,
  CompleteCliponeIntegrationResponses,
  CompleteConfluenceIntegrationData,
  CompleteConfluenceIntegrationErrors,
  CompleteConfluenceIntegrationResponses,
  CompleteIntegrationData,
  CompleteIntegrationErrors,
  CompleteIntegrationResponses,
  CompleteOdooIntegrationData,
  CompleteOdooIntegrationErrors,
  CompleteOdooIntegrationResponses,
  CompletePaypayIntegrationData,
  CompletePaypayIntegrationErrors,
  CompletePaypayIntegrationResponses,
  CompletePersonaIntegrationData,
  CompletePersonaIntegrationErrors,
  CompletePersonaIntegrationResponses,
  CompleteRapydIntegrationData,
  CompleteRapydIntegrationErrors,
  CompleteRapydIntegrationResponses,
  CompleteTelegramIntegrationData,
  CompleteTelegramIntegrationErrors,
  CompleteTelegramIntegrationResponses,
  CompleteThomIntegrationData,
  CompleteThomIntegrationErrors,
  CompleteThomIntegrationResponses,
  ConnectionConfigData,
  ConnectionConfigErrors,
  ConnectionConfigResponses,
  ConnectionSendersData,
  ConnectionSendersErrors,
  ConnectionSendersResponses,
  ConversationEventsData,
  ConversationEventsErrors,
  ConversationEventsResponses,
  ConvertPlaywrightCodeData,
  ConvertPlaywrightCodeErrors,
  ConvertPlaywrightCodeResponses,
  CreateAgentTestSuiteData,
  CreateAgentTestSuiteErrors,
  CreateAgentTestSuiteResponses,
  CreateApiKeyData,
  CreateApiKeyErrors,
  CreateApiKeyResponses,
  CreateAssistantVersionData,
  CreateAssistantVersionErrors,
  CreateAssistantVersionResponses,
  CreateBillingPortalSessionData,
  CreateBillingPortalSessionResponses,
  CreateCaseData,
  CreateCaseErrors,
  CreateCaseResponses,
  CreateCheckoutSessionData,
  CreateCheckoutSessionErrors,
  CreateCheckoutSessionResponses,
  CreateConnectionData,
  CreateConnectionErrors,
  CreateConnectionResponses,
  CreateConversationData,
  CreateConversationErrors,
  CreateConversationResponses,
  CreateCustomModelConfigurationData,
  CreateCustomModelConfigurationErrors,
  CreateCustomModelConfigurationResponses,
  CreateDeploymentData,
  CreateDeploymentErrors,
  CreateDeploymentResponses,
  CreateErrorHandlerForWorkflowData,
  CreateErrorHandlerForWorkflowErrors,
  CreateErrorHandlerForWorkflowResponses,
  CreateEvaluatorData,
  CreateEvaluatorErrors,
  CreateEvaluatorResponses,
  CreateGroupData,
  CreateGroupErrors,
  CreateGroupResponses,
  CreateGroupRoleData,
  CreateGroupRoleErrors,
  CreateGroupRoleResponses,
  CreateGroupVariableData,
  CreateGroupVariableErrors,
  CreateGroupVariableResponses,
  CreateInboxData,
  CreateInboxErrors,
  CreateInboxFieldData,
  CreateInboxFieldErrors,
  CreateInboxFieldResponses,
  CreateInboxResponses,
  CreateKbTestSuiteData,
  CreateKbTestSuiteErrors,
  CreateKbTestSuiteResponses,
  CreatePayasyougoCheckoutSessionData,
  CreatePayasyougoCheckoutSessionResponses,
  CreatePeriodicTaskData,
  CreatePeriodicTaskErrors,
  CreatePeriodicTaskResponses,
  CreatePluginData,
  CreatePluginErrors,
  CreatePluginResponses,
  CreatePresetData,
  CreatePresetErrors,
  CreatePresetResponses,
  CreateProviderData,
  CreateProviderErrors,
  CreateProviderLinkData,
  CreateProviderLinkErrors,
  CreateProviderLinkResponses,
  CreateProviderResponses,
  CreateSpecCaseData,
  CreateSpecCaseErrors,
  CreateSpecCaseResponses,
  CreateSpecNodeData,
  CreateSpecNodeErrors,
  CreateSpecNodeResponses,
  CreateStripeCustomerData,
  CreateStripeCustomerResponses,
  CreateTableData,
  CreateTableErrors,
  CreateTableResponses,
  CreateTagData,
  CreateTagErrors,
  CreateTagResponses,
  CreateTenantRoleData,
  CreateTenantRoleErrors,
  CreateTenantRoleResponses,
  CreateTestCaseData,
  CreateTestCaseErrors,
  CreateTestCaseFromMessageData,
  CreateTestCaseFromMessageErrors,
  CreateTestCaseFromMessageResponses,
  CreateTestCaseFromRunData,
  CreateTestCaseFromRunErrors,
  CreateTestCaseFromRunResponses,
  CreateTestCaseResponses,
  CreateTriggerData,
  CreateTriggerErrors,
  CreateTriggerResponses,
  CreateUserData,
  CreateUserErrors,
  CreateUserResponses,
  CreateWorkflowFromTemplateData,
  CreateWorkflowFromTemplateErrors,
  CreateWorkflowFromTemplateResponses,
  CreateWorkflowTestSuiteData,
  CreateWorkflowTestSuiteErrors,
  CreateWorkflowTestSuiteResponses,
  CreateWorkflowVariableData,
  CreateWorkflowVariableErrors,
  CreateWorkflowVariableResponses,
  CreateWorkflowVersionData,
  CreateWorkflowVersionErrors,
  CreateWorkflowVersionResponses,
  CustomMcpConnectWithHeadersData,
  CustomMcpConnectWithHeadersErrors,
  CustomMcpConnectWithHeadersResponses,
  CustomMcpStartData,
  CustomMcpStartErrors,
  CustomMcpStartResponses,
  DatabaseLocksData,
  DatabaseLocksErrors,
  DatabaseLocksResponses,
  DeactivateDeploymentData,
  DeactivateDeploymentErrors,
  DeactivateDeploymentResponses,
  DeactivateProviderData,
  DeactivateProviderErrors,
  DeactivateProviderResponses,
  DebugRecomputeInsightsData,
  DebugRecomputeInsightsErrors,
  DebugRecomputeInsightsResponses,
  DeferCsatResponseData,
  DeferCsatResponseErrors,
  DeferCsatResponseResponses,
  DeleteAllCasesData,
  DeleteAllCasesErrors,
  DeleteAllCasesResponses,
  DeleteApiKeyData,
  DeleteApiKeyErrors,
  DeleteApiKeyResponses,
  DeleteAssistantData,
  DeleteAssistantErrors,
  DeleteAssistantResponses,
  DeleteCachePatternData,
  DeleteCachePatternErrors,
  DeleteCachePatternResponses,
  DeleteCaseData,
  DeleteCaseErrors,
  DeleteCaseResponses,
  DeleteConnectionData,
  DeleteConnectionErrors,
  DeleteConnectionResponses,
  DeleteConversationData,
  DeleteConversationErrors,
  DeleteConversationResponses,
  DeleteCredentialEndpointData,
  DeleteCredentialEndpointErrors,
  DeleteCredentialEndpointResponses,
  DeleteCustomModelConfigurationData,
  DeleteCustomModelConfigurationErrors,
  DeleteCustomModelConfigurationResponses,
  DeleteDeploymentData,
  DeleteDeploymentErrors,
  DeleteDeploymentResponses,
  DeleteEntityGrantsData,
  DeleteEntityGrantsErrors,
  DeleteEntityGrantsResponses,
  DeleteEvaluatorData,
  DeleteEvaluatorErrors,
  DeleteEvaluatorResponses,
  DeleteGroupData,
  DeleteGroupErrors,
  DeleteGroupResponses,
  DeleteGroupRoleData,
  DeleteGroupRoleErrors,
  DeleteGroupRoleResponses,
  DeleteGroupVariableData,
  DeleteGroupVariableErrors,
  DeleteGroupVariableResponses,
  DeleteInboxData,
  DeleteInboxErrors,
  DeleteInboxFieldData,
  DeleteInboxFieldErrors,
  DeleteInboxFieldResponses,
  DeleteInboxResponses,
  DeleteKnowledgeBaseDocumentData,
  DeleteKnowledgeBaseDocumentErrors,
  DeleteKnowledgeBaseDocumentResponses,
  DeleteKnowledgeBaseV2Data,
  DeleteKnowledgeBaseV2Errors,
  DeleteKnowledgeBaseV2Responses,
  DeleteLimitData,
  DeleteLimitErrors,
  DeleteLimitResponses,
  DeleteMeData,
  DeleteMeErrors,
  DeleteMeResponses,
  DeletePeriodicTaskData,
  DeletePeriodicTaskErrors,
  DeletePeriodicTaskResponses,
  DeletePluginData,
  DeletePluginErrors,
  DeletePluginResponses,
  DeletePresetData,
  DeletePresetErrors,
  DeletePresetResponses,
  DeleteProviderConfigEndpointData,
  DeleteProviderConfigEndpointErrors,
  DeleteProviderConfigEndpointResponses,
  DeleteProviderData,
  DeleteProviderErrors,
  DeleteProviderLinkData,
  DeleteProviderLinkErrors,
  DeleteProviderLinkResponses,
  DeleteProviderResponses,
  DeleteRowData,
  DeleteRowErrors,
  DeleteRowResponses,
  DeleteSpecCaseData,
  DeleteSpecCaseErrors,
  DeleteSpecCaseResponses,
  DeleteSpecNodeData,
  DeleteSpecNodeErrors,
  DeleteSpecNodeResponses,
  DeleteTableData,
  DeleteTableErrors,
  DeleteTableResponses,
  DeleteTagData,
  DeleteTagErrors,
  DeleteTagResponses,
  DeleteTemplateData,
  DeleteTemplateErrors,
  DeleteTemplateResponses,
  DeleteTenantData,
  DeleteTenantErrors,
  DeleteTenantResponses,
  DeleteTenantRoleData,
  DeleteTenantRoleErrors,
  DeleteTenantRoleResponses,
  DeleteTestCaseData,
  DeleteTestCaseErrors,
  DeleteTestCaseResponses,
  DeleteTestSuiteData,
  DeleteTestSuiteErrors,
  DeleteTestSuiteResponses,
  DeleteTriggersData,
  DeleteTriggersErrors,
  DeleteTriggersResponses,
  DeleteUserData,
  DeleteUserErrors,
  DeleteUserProfileData,
  DeleteUserProfileErrors,
  DeleteUserProfileResponses,
  DeleteUserResponses,
  DeleteWorkflowData,
  DeleteWorkflowErrors,
  DeleteWorkflowResponses,
  DeleteWorkflowVariableData,
  DeleteWorkflowVariableErrors,
  DeleteWorkflowVariableResponses,
  DeployInboxTemplateData,
  DeployInboxTemplateErrors,
  DeployInboxTemplateResponses,
  DeployTemplateV2Data,
  DeployTemplateV2Errors,
  DeployTemplateV2Responses,
  DictateAudioData,
  DictateAudioErrors,
  DictateAudioResponses,
  DisableKbSyncData,
  DisableKbSyncErrors,
  DisableKbSyncResponses,
  DisconnectCliponeData,
  DisconnectCliponeErrors,
  DisconnectCliponeResponses,
  DisconnectConfluenceData,
  DisconnectConfluenceErrors,
  DisconnectConfluenceResponses,
  DisconnectIntegration2Data,
  DisconnectIntegration2Errors,
  DisconnectIntegration2Responses,
  DisconnectIntegrationData,
  DisconnectIntegrationErrors,
  DisconnectIntegrationResponses,
  DisconnectOauthCredentialData,
  DisconnectOauthCredentialErrors,
  DisconnectOauthCredentialResponses,
  DisconnectOdooData,
  DisconnectOdooErrors,
  DisconnectOdooResponses,
  DisconnectPaypayData,
  DisconnectPaypayErrors,
  DisconnectPaypayResponses,
  DisconnectPersonaData,
  DisconnectPersonaErrors,
  DisconnectPersonaResponses,
  DisconnectRapydData,
  DisconnectRapydErrors,
  DisconnectRapydResponses,
  DisconnectTelegramData,
  DisconnectTelegramErrors,
  DisconnectTelegramResponses,
  DisconnectThomData,
  DisconnectThomErrors,
  DisconnectThomResponses,
  DismissKnowledgeBaseDocumentData,
  DismissKnowledgeBaseDocumentErrors,
  DismissKnowledgeBaseDocumentResponses,
  DismissKnowledgeBaseRunData,
  DismissKnowledgeBaseRunErrors,
  DismissKnowledgeBaseRunResponses,
  DownloadAuditData,
  DownloadAuditErrors,
  DownloadAuditResponses,
  DownloadRunDebugExportData,
  DownloadRunDebugExportErrors,
  DownloadRunDebugExportResponses,
  DropColumnData,
  DropColumnErrors,
  DropColumnResponses,
  DryRunData,
  DryRunErrors,
  DryRunResponses,
  DuplicateAssistantData,
  DuplicateAssistantErrors,
  DuplicateAssistantResponses,
  DuplicateTestCaseData,
  DuplicateTestCaseErrors,
  DuplicateTestCaseResponses,
  DuplicateWorkflowData,
  DuplicateWorkflowErrors,
  DuplicateWorkflowResponses,
  EditGroupData,
  EditGroupErrors,
  EditGroupResponses,
  EditUserData,
  EditUserErrors,
  EditUserResponses,
  EditUserRoleForGroupData,
  EditUserRoleForGroupErrors,
  EditUserRoleForGroupResponses,
  EmailConfigData,
  EmailConfigResponses,
  EnableKbSyncData,
  EnableKbSyncErrors,
  EnableKbSyncResponses,
  EncryptProviderKeysData,
  EncryptProviderKeysResponses,
  EvaluatePromptHeuristicsData,
  EvaluatePromptHeuristicsErrors,
  EvaluatePromptHeuristicsJobData,
  EvaluatePromptHeuristicsJobErrors,
  EvaluatePromptHeuristicsJobResponses,
  EvaluatePromptHeuristicsResponses,
  EventsSchemaStubData,
  EventsSchemaStubResponses,
  EvictSandboxAllocationData,
  EvictSandboxAllocationErrors,
  EvictSandboxAllocationResponses,
  ExchangeEmbedSessionData,
  ExchangeEmbedSessionErrors,
  ExchangeEmbedSessionResponses,
  ExportAssistantData,
  ExportAssistantErrors,
  ExportAssistantPreviewData,
  ExportAssistantPreviewErrors,
  ExportAssistantPreviewResponses,
  ExportAssistantResponses,
  ExportInboxData,
  ExportInboxErrors,
  ExportInboxPreviewData,
  ExportInboxPreviewErrors,
  ExportInboxPreviewResponses,
  ExportInboxResponses,
  ExportKnowledgeBaseV2Data,
  ExportKnowledgeBaseV2Errors,
  ExportKnowledgeBaseV2Responses,
  ExportQueryCsvData,
  ExportQueryCsvErrors,
  ExportQueryCsvResponses,
  ExportTableCsvData,
  ExportTableCsvErrors,
  ExportTableCsvResponses,
  ExportWorkflowData,
  ExportWorkflowErrors,
  ExportWorkflowPreviewData,
  ExportWorkflowPreviewErrors,
  ExportWorkflowPreviewResponses,
  ExportWorkflowResponses,
  ExtractDocumentData,
  ExtractDocumentErrors,
  ExtractDocumentResponses,
  FetchKnowledgeBaseCustomTypesData,
  FetchKnowledgeBaseCustomTypesResponses,
  ForceKbSyncData,
  ForceKbSyncErrors,
  ForceKbSyncResponses,
  ForceRefreshCredentialData,
  ForceRefreshCredentialErrors,
  ForceRefreshCredentialResponses,
  ForgotPasswordData,
  ForgotPasswordErrors,
  ForgotPasswordResponses,
  GenerateAnswerQualityDatasetData,
  GenerateAnswerQualityDatasetErrors,
  GenerateAnswerQualityDatasetResponses,
  GenerateCodeData,
  GenerateCodeErrors,
  GenerateCodeResponses,
  GenerateJwtData,
  GenerateJwtErrors,
  GenerateJwtResponses,
  GenerateKbSyntheticDatasetData,
  GenerateKbSyntheticDatasetErrors,
  GenerateKbSyntheticDatasetResponses,
  GenerateKnowledgeBaseSummaryData,
  GenerateKnowledgeBaseSummaryErrors,
  GenerateKnowledgeBaseSummaryResponses,
  GenerateTableSqlData,
  GenerateTableSqlErrors,
  GenerateTableSqlResponses,
  GenericTrainKnowledgeBaseData,
  GenericTrainKnowledgeBaseErrors,
  GenericTrainKnowledgeBaseResponses,
  GetAdminStatsData,
  GetAdminStatsResponses,
  GetAdminTenantData,
  GetAdminTenantErrors,
  GetAdminTenantResponses,
  GetAgentCoworkerToolFormData,
  GetAgentCoworkerToolFormResponses,
  GetAgentEvaluatorDefinitionsData,
  GetAgentEvaluatorDefinitionsResponses,
  GetAgentFormData,
  GetAgentFormResponses,
  GetAgentToolFormData,
  GetAgentToolFormErrors,
  GetAgentToolFormResponses,
  GetAiSafetyDataData,
  GetAiSafetyDataResponses,
  GetAllFeatureFlagsData,
  GetAllFeatureFlagsResponses,
  GetAllGroupsData,
  GetAllGroupsErrors,
  GetAllGroupsResponses,
  GetAllInvoicesData,
  GetAllInvoicesResponses,
  GetAnonymousUserData,
  GetAnonymousUserResponses,
  GetAnswerQualitySummaryData,
  GetAnswerQualitySummaryErrors,
  GetAnswerQualitySummaryResponses,
  GetApiAnalyticsData,
  GetApiAnalyticsErrors,
  GetApiAnalyticsItemsData,
  GetApiAnalyticsItemsResponses,
  GetApiAnalyticsResponses,
  GetApiKeyData,
  GetApiKeyErrors,
  GetApiKeyResponses,
  GetApiKeysData,
  GetApiKeysErrors,
  GetApiKeysResponses,
  GetApiKeysSetData,
  GetApiKeysSetResponses,
  GetAppConfigData,
  GetAppConfigErrors,
  GetAppConfigResponses,
  GetArtifactStatusData,
  GetArtifactStatusErrors,
  GetArtifactStatusResponses,
  GetAssistantAnalyticsData,
  GetAssistantAnalyticsErrors,
  GetAssistantAnalyticsResponses,
  GetAssistantCapabilitiesData,
  GetAssistantCapabilitiesErrors,
  GetAssistantCapabilitiesResponses,
  GetAssistantCapabilityUpdatesData,
  GetAssistantCapabilityUpdatesErrors,
  GetAssistantCapabilityUpdatesResponses,
  GetAssistantData,
  GetAssistantErrors,
  GetAssistantPublicData,
  GetAssistantPublicErrors,
  GetAssistantPublicResponses,
  GetAssistantResponses,
  GetAssistantsData,
  GetAssistantsErrors,
  GetAssistantsResponses,
  GetAssistantTriggerConfigData,
  GetAssistantTriggerConfigErrors,
  GetAssistantTriggerConfigResponses,
  GetAssistantTriggerCustomizationData,
  GetAssistantTriggerCustomizationErrors,
  GetAssistantTriggerCustomizationResponses,
  GetAssistantVersionData,
  GetAssistantVersionErrors,
  GetAssistantVersionResponses,
  GetAssistantVersionsData,
  GetAssistantVersionsErrors,
  GetAssistantVersionsResponses,
  GetAssistantVersionUsagesData,
  GetAssistantVersionUsagesErrors,
  GetAssistantVersionUsagesResponses,
  GetAuditLogsStorageData,
  GetAuditLogsStorageResponses,
  GetAuth0UsersData,
  GetAuth0UsersResponses,
  GetAuthConfigData,
  GetAuthConfigResponses,
  GetAuthorizationContextData,
  GetAuthorizationContextErrors,
  GetAuthorizationContextResponses,
  GetAvailableIntegrationsData,
  GetAvailableIntegrationsErrors,
  GetAvailableIntegrationsResponses,
  GetAvailableTriggersData,
  GetAvailableTriggersErrors,
  GetAvailableTriggersResponses,
  GetBaseIntegrationConfigData,
  GetBaseIntegrationConfigErrors,
  GetBaseIntegrationConfigResponses,
  GetBetaFeatureStatesData,
  GetBetaFeatureStatesResponses,
  GetBillingAnalyticsItemsData,
  GetBillingAnalyticsItemsResponses,
  GetBillingCurrencyData,
  GetBillingCurrencyResponses,
  GetBillingInformationData,
  GetBillingInformationErrors,
  GetBillingInformationResponses,
  GetBootstrapStatusData,
  GetBootstrapStatusErrors,
  GetBootstrapStatusResponses,
  GetBuildVersionData,
  GetBuildVersionResponses,
  GetCacheStatsData,
  GetCacheStatsResponses,
  GetCalculatingInsightsData,
  GetCalculatingInsightsErrors,
  GetCalculatingInsightsResponses,
  GetCaseData,
  GetCaseErrors,
  GetCaseResponses,
  GetChangelogData,
  GetChangelogResponses,
  GetChaosTestingConfigData,
  GetChaosTestingConfigResponses,
  GetChatAnalyticsItemsData,
  GetChatAnalyticsItemsResponses,
  GetCombinedReportData,
  GetCombinedReportErrors,
  GetCombinedReportResponses,
  GetCompatibleMimeTypesData,
  GetCompatibleMimeTypesErrors,
  GetCompatibleMimeTypesResponses,
  GetConfigData,
  GetConfigErrors,
  GetConfigResponses,
  GetConnectionData,
  GetConnectionErrors,
  GetConnectionResponses,
  GetConnectionsData,
  GetConnectionsResponses,
  GetControlCenterAnalyticsItemsData,
  GetControlCenterAnalyticsItemsResponses,
  GetConversationCostSummaryData,
  GetConversationCostSummaryErrors,
  GetConversationCostSummaryResponses,
  GetConversationData,
  GetConversationErrors,
  GetConversationExecutionLogsData,
  GetConversationExecutionLogsErrors,
  GetConversationExecutionLogsResponses,
  GetConversationFunnelData,
  GetConversationFunnelErrors,
  GetConversationFunnelResponses,
  GetConversationResponses,
  GetConversationSpansData,
  GetConversationSpansErrors,
  GetConversationSpansResponses,
  GetCoworkerFormData,
  GetCoworkerFormErrors,
  GetCoworkerFormResponses,
  GetCredentialPayloadData,
  GetCredentialPayloadErrors,
  GetCredentialPayloadResponses,
  GetCsatScoreData,
  GetCsatScoreErrors,
  GetCsatScoreResponses,
  GetCustomInsightsData,
  GetCustomInsightsErrors,
  GetCustomInsightsResponses,
  GetDataMessageSchemasData,
  GetDataMessageSchemasResponses,
  GetDecisionModelsData,
  GetDecisionModelsErrors,
  GetDecisionModelsResponses,
  GetDeploymentAppByAliasData,
  GetDeploymentAppByAliasErrors,
  GetDeploymentAppByAliasResponses,
  GetDeploymentAppData,
  GetDeploymentAppErrors,
  GetDeploymentAppResponses,
  GetDeploymentConfigData,
  GetDeploymentConfigErrors,
  GetDeploymentConfigResponses,
  GetDeploymentData,
  GetDeploymentErrors,
  GetDeploymentEventsData,
  GetDeploymentEventsErrors,
  GetDeploymentEventsResponses,
  GetDeploymentResponses,
  GetDisabledAgentToolsData,
  GetDisabledAgentToolsResponses,
  GetDocsInformationData,
  GetDocsInformationErrors,
  GetDocsInformationResponses,
  GetDriveTokenData,
  GetDriveTokenErrors,
  GetDriveTokenResponses,
  GetEmbeddingsData,
  GetEmbeddingsErrors,
  GetEmbeddingsResponses,
  GetEnabledBetaFeaturesData,
  GetEnabledBetaFeaturesResponses,
  GetEntitiesByTagData,
  GetEntitiesByTagErrors,
  GetEntitiesByTagResponses,
  GetEntityTagsData,
  GetEntityTagsErrors,
  GetEntityTagsResponses,
  GetEvaluationResultData,
  GetEvaluationResultDetailData,
  GetEvaluationResultDetailErrors,
  GetEvaluationResultDetailResponses,
  GetEvaluationResultErrors,
  GetEvaluationResultResponses,
  GetEvaluationRunReportData,
  GetEvaluationRunReportErrors,
  GetEvaluationRunReportResponses,
  GetEvaluatorData,
  GetEvaluatorDefinitionsData,
  GetEvaluatorDefinitionsResponses,
  GetEvaluatorErrors,
  GetEvaluatorResponses,
  GetFeatureFlagsData,
  GetFeatureFlagsResponses,
  GetGdriveFilesData,
  GetGdriveFilesErrors,
  GetGdriveFilesResponses,
  GetGdriveSourcesData,
  GetGdriveSourcesErrors,
  GetGdriveSourcesResponses,
  GetGroupData,
  GetGroupErrors,
  GetGroupResponses,
  GetGroupRoleData,
  GetGroupRoleErrors,
  GetGroupRoleResponses,
  GetGroupTriggerEventsData,
  GetGroupTriggerEventsErrors,
  GetGroupTriggerEventsResponses,
  GetGroupVariableSourcesData,
  GetGroupVariableSourcesErrors,
  GetGroupVariableSourcesResponses,
  GetHealthData,
  GetHealthErrors,
  GetHealthResponses,
  GetImageData,
  GetImageErrors,
  GetImageMetadataData,
  GetImageMetadataErrors,
  GetImageMetadataResponses,
  GetImageModelsData,
  GetImageModelsErrors,
  GetImageModelsResponses,
  GetImageResponses,
  GetInboxData,
  GetInboxErrors,
  GetInboxResponses,
  GetInboxTemplateConfigData,
  GetInboxTemplateConfigErrors,
  GetInboxTemplateConfigResponses,
  GetInfrastructureAnalyticsData,
  GetInfrastructureAnalyticsErrors,
  GetInfrastructureAnalyticsItemsData,
  GetInfrastructureAnalyticsItemsResponses,
  GetInfrastructureAnalyticsResponses,
  GetInsightConversationsData,
  GetInsightConversationsErrors,
  GetInsightConversationsResponses,
  GetInsightsConfigData,
  GetInsightsConfigResponses,
  GetIntegrationConfigData,
  GetIntegrationConfigErrors,
  GetIntegrationConfigResponses,
  GetIntegrationEnabledData,
  GetIntegrationEnabledErrors,
  GetIntegrationEnabledResponses,
  GetIntegrationScopesEndpointData,
  GetIntegrationScopesEndpointErrors,
  GetIntegrationScopesEndpointResponses,
  GetIntegrationSettingsEndpointData,
  GetIntegrationSettingsEndpointErrors,
  GetIntegrationSettingsEndpointResponses,
  GetIntegrationStatusData,
  GetIntegrationStatusErrors,
  GetIntegrationStatusResponses,
  GetIsValidAssistantData,
  GetIsValidAssistantErrors,
  GetIsValidAssistantResponses,
  GetIsValidWorkflowData,
  GetIsValidWorkflowErrors,
  GetIsValidWorkflowFromDefinitionData,
  GetIsValidWorkflowFromDefinitionErrors,
  GetIsValidWorkflowFromDefinitionResponses,
  GetIsValidWorkflowResponses,
  GetIsValidWorkflowV2FromDefinitionData,
  GetIsValidWorkflowV2FromDefinitionErrors,
  GetIsValidWorkflowV2FromDefinitionResponses,
  GetJwksData,
  GetJwksResponses,
  GetKbAnalyticsData,
  GetKbAnalyticsErrors,
  GetKbAnalyticsItemsData,
  GetKbAnalyticsItemsResponses,
  GetKbAnalyticsResponses,
  GetKbEvaluationComparisonData,
  GetKbEvaluationComparisonErrors,
  GetKbEvaluationComparisonResponses,
  GetKbFormData,
  GetKbFormResponses,
  GetKnowledgeBaseDocumentData,
  GetKnowledgeBaseDocumentErrors,
  GetKnowledgeBaseDocumentResponses,
  GetKnowledgeBaseDocumentsData,
  GetKnowledgeBaseDocumentsErrors,
  GetKnowledgeBaseDocumentsResponses,
  GetKnowledgeBaseEvaluatorDefinitionsData,
  GetKnowledgeBaseEvaluatorDefinitionsResponses,
  GetKnowledgeBaseIngestionJobsData,
  GetKnowledgeBaseIngestionJobsErrors,
  GetKnowledgeBaseIngestionJobsResponses,
  GetKnowledgeBaseIngestionRunsData,
  GetKnowledgeBaseIngestionRunsErrors,
  GetKnowledgeBaseIngestionRunsResponses,
  GetKnowledgeBaseRunningJobsData,
  GetKnowledgeBaseRunningJobsErrors,
  GetKnowledgeBaseRunningJobsResponses,
  GetKnowledgeBasesV2Data,
  GetKnowledgeBasesV2Errors,
  GetKnowledgeBasesV2Responses,
  GetKnowledgeBaseV2Data,
  GetKnowledgeBaseV2Errors,
  GetKnowledgeBaseV2Responses,
  GetLabellingTasksData,
  GetLabellingTasksErrors,
  GetLabellingTasksResponses,
  GetLicenseDataData,
  GetLicenseDataResponses,
  GetLifecycleConfigData,
  GetLifecycleConfigResponses,
  GetLifecycleStatusData,
  GetLifecycleStatusResponses,
  GetLimitProvidersData,
  GetLimitProvidersResponses,
  GetLimitsData,
  GetLimitsResponses,
  GetLimitUsageData,
  GetLimitUsageErrors,
  GetLimitUsageResponses,
  GetLlmsData,
  GetLlmsErrors,
  GetLlmsResponses,
  GetLogoData,
  GetLogoErrors,
  GetLogoResponses,
  GetMcpIdentityData,
  GetMcpIdentityErrors,
  GetMcpIdentityResponses,
  GetMeData,
  GetMeResponses,
  GetMessageCostBreakdownData,
  GetMessageCostBreakdownErrors,
  GetMessageCostBreakdownResponses,
  GetMessageDebugInfoData,
  GetMessageDebugInfoErrors,
  GetMessageDebugInfoResponses,
  GetMyGroupPermissionsData,
  GetMyGroupPermissionsErrors,
  GetMyGroupPermissionsResponses,
  GetMyGroupsData,
  GetMyGroupsErrors,
  GetMyGroupsResponses,
  GetMyPermissionsData,
  GetMyPermissionsErrors,
  GetMyPermissionsResponses,
  GetNodeConfigData,
  GetNodeConfigErrors,
  GetNodeConfigResponses,
  GetNodeConfigV2Data,
  GetNodeConfigV2Errors,
  GetNodeConfigV2Responses,
  GetNodeDisplayData,
  GetNodeDisplayResponses,
  GetNodeLastInputsData,
  GetNodeLastInputsErrors,
  GetNodeLastInputsResponses,
  GetNodesData,
  GetNodesErrors,
  GetNodesResponses,
  GetNoticedData,
  GetNoticedErrors,
  GetNoticedResponses,
  GetNoxusProviderConfigData,
  GetNoxusProviderConfigResponses,
  GetOidcSyncStatusData,
  GetOidcSyncStatusResponses,
  GetOnedriveDocsInformationData,
  GetOnedriveDocsInformationErrors,
  GetOnedriveDocsInformationResponses,
  GetOnedriveDriveFilesData,
  GetOnedriveDriveFilesErrors,
  GetOnedriveDriveFilesResponses,
  GetOnedriveUserInformationData,
  GetOnedriveUserInformationErrors,
  GetOnedriveUserInformationResponses,
  GetOrCreateGenieAssistantData,
  GetOrCreateGenieAssistantErrors,
  GetOrCreateGenieAssistantResponses,
  GetPaymentsData,
  GetPaymentsResponses,
  GetPendingInviteData,
  GetPendingInviteResponses,
  GetPiiSafetyDataData,
  GetPiiSafetyDataErrors,
  GetPiiSafetyDataResponses,
  GetPluginData,
  GetPluginErrors,
  GetPluginLogsData,
  GetPluginLogsErrors,
  GetPluginLogsResponses,
  GetPluginLogStatsData,
  GetPluginLogStatsErrors,
  GetPluginLogStatsResponses,
  GetPluginResponses,
  GetPresetByHandleData,
  GetPresetByHandleErrors,
  GetPresetByHandleResponses,
  GetPresetConfigFormData,
  GetPresetConfigFormErrors,
  GetPresetConfigFormResponses,
  GetProductSpecData,
  GetProductSpecResponses,
  GetPromptJobStatusData,
  GetPromptJobStatusErrors,
  GetPromptJobStatusResponses,
  GetProviderConfigSchemaData,
  GetProviderConfigSchemaErrors,
  GetProviderConfigSchemaResponses,
  GetProviderData,
  GetProviderErrors,
  GetProviderResponses,
  GetPublicImageData,
  GetPublicImageErrors,
  GetPublicImageResponses,
  GetRateLimitsData,
  GetRateLimitsResponses,
  GetRatingDriversData,
  GetRatingDriversErrors,
  GetRatingDriversResponses,
  GetRecoveryStatsData,
  GetRecoveryStatsErrors,
  GetRecoveryStatsResponses,
  GetRedirectUrlData,
  GetRedirectUrlResponses,
  GetRerankersData,
  GetRerankersErrors,
  GetRerankersResponses,
  GetRunByIdData,
  GetRunByIdErrors,
  GetRunByIdResponses,
  GetRunData,
  GetRunDataIndexStatsData,
  GetRunDataIndexStatsResponses,
  GetRunErrors,
  GetRunExecutionLogsData,
  GetRunExecutionLogsErrors,
  GetRunExecutionLogsResponses,
  GetRunIoData,
  GetRunIoErrors,
  GetRunIoResponses,
  GetRunLogsData,
  GetRunLogsErrors,
  GetRunLogsResponses,
  GetRunningWorkersData,
  GetRunningWorkersResponses,
  GetRunResponses,
  GetRunsData,
  GetRunsErrors,
  GetRunSpansData,
  GetRunSpansErrors,
  GetRunSpansResponses,
  GetRunsResponses,
  GetRunStateData,
  GetRunStateErrors,
  GetRunStateResponses,
  GetRunSubflowIterationData,
  GetRunSubflowIterationErrors,
  GetRunSubflowIterationResponses,
  GetSecuritySettingsData,
  GetSecuritySettingsResponses,
  GetSentimentOverTimeData,
  GetSentimentOverTimeErrors,
  GetSentimentOverTimeResponses,
  GetServerSettingsData,
  GetServerSettingsResponses,
  GetServiceMetricsData,
  GetServiceMetricsErrors,
  GetServiceMetricsResponses,
  GetSharepointDocsInformationData,
  GetSharepointDocsInformationErrors,
  GetSharepointDocsInformationResponses,
  GetSharepointDriveFilesData,
  GetSharepointDriveFilesErrors,
  GetSharepointDriveFilesResponses,
  GetSharepointSiteDrivesData,
  GetSharepointSiteDrivesErrors,
  GetSharepointSiteDrivesResponses,
  GetSharepointSitesData,
  GetSharepointSitesErrors,
  GetSharepointSitesResponses,
  GetSharepointSubsitesData,
  GetSharepointSubsitesErrors,
  GetSharepointSubsitesResponses,
  GetSlackInformationData,
  GetSlackInformationErrors,
  GetSlackInformationResponses,
  GetSpecNodeHistoryData,
  GetSpecNodeHistoryErrors,
  GetSpecNodeHistoryResponses,
  GetSpreadsheetInformationData,
  GetSpreadsheetInformationErrors,
  GetSpreadsheetInformationResponses,
  GetSubTopicsData,
  GetSubTopicsErrors,
  GetSubTopicsResponses,
  GetSuiteEvaluationResultsData,
  GetSuiteEvaluationResultsErrors,
  GetSuiteEvaluationResultsResponses,
  GetTableData,
  GetTableErrors,
  GetTableResponses,
  GetTableStatsData,
  GetTableStatsErrors,
  GetTableStatsResponses,
  GetTagData,
  GetTagErrors,
  GetTagResponses,
  GetTaskData,
  GetTaskErrors,
  GetTaskResponses,
  GetTemplateAsWorkflowData,
  GetTemplateAsWorkflowErrors,
  GetTemplateAsWorkflowResponses,
  GetTemplateCategoriesData,
  GetTemplateCategoriesErrors,
  GetTemplateCategoriesResponses,
  GetTemplateData,
  GetTemplateErrors,
  GetTemplateResponses,
  GetTemplatesData,
  GetTemplatesErrors,
  GetTemplatesResponses,
  GetTemplatesV2Data,
  GetTemplatesV2Errors,
  GetTemplatesV2Responses,
  GetTemplateV2ConfigData,
  GetTemplateV2ConfigErrors,
  GetTemplateV2ConfigResponses,
  GetTemplateV2Data,
  GetTemplateV2Errors,
  GetTemplateV2Responses,
  GetTenantAnalyticsData,
  GetTenantAnalyticsErrors,
  GetTenantAnalyticsItemsData,
  GetTenantAnalyticsItemsResponses,
  GetTenantAnalyticsResponses,
  GetTenantAuditLogFacetsData,
  GetTenantAuditLogFacetsErrors,
  GetTenantAuditLogFacetsResponses,
  GetTenantAuditLogsData,
  GetTenantAuditLogsErrors,
  GetTenantAuditLogsResponses,
  GetTenantData,
  GetTenantFeatureFlagsData,
  GetTenantFeatureFlagsErrors,
  GetTenantFeatureFlagsResponses,
  GetTenantResponses,
  GetTenantRoleData,
  GetTenantRoleErrors,
  GetTenantRoleResponses,
  GetTestCaseData,
  GetTestCaseErrors,
  GetTestCaseResponses,
  GetTestCaseRunsData,
  GetTestCaseRunsErrors,
  GetTestCaseRunsResponses,
  GetTestSuiteData,
  GetTestSuiteErrors,
  GetTestSuiteResponses,
  GetTmpKnowledgeBaseData,
  GetTmpKnowledgeBaseErrors,
  GetTmpKnowledgeBaseResponses,
  GetToolDisplaysData,
  GetToolDisplaysResponses,
  GetToolMetadataSchemasData,
  GetToolMetadataSchemasResponses,
  GetTopTopicsData,
  GetTopTopicsErrors,
  GetTopTopicsResponses,
  GetTrendingTemplatesData,
  GetTrendingTemplatesErrors,
  GetTrendingTemplatesResponses,
  GetTriggerConfigData,
  GetTriggerConfigErrors,
  GetTriggerConfigResponses,
  GetTriggerData,
  GetTriggerErrors,
  GetTriggerEventsData,
  GetTriggerEventsErrors,
  GetTriggerEventsResponses,
  GetTriggerResponses,
  GetTriggersCompatibilityData,
  GetTriggersCompatibilityErrors,
  GetTriggersCompatibilityResponses,
  GetTriggersData,
  GetTriggersErrors,
  GetTriggersResponses,
  GetTypesData,
  GetTypesResponses,
  GetUserDetailsData,
  GetUserDetailsErrors,
  GetUserDetailsResponses,
  GetUserEffectivePermissionsData,
  GetUserEffectivePermissionsErrors,
  GetUserEffectivePermissionsResponses,
  GetUserProfileByIdData,
  GetUserProfileByIdErrors,
  GetUserProfileByIdResponses,
  GetUserProfileData,
  GetUserProfileErrors,
  GetUserProfileResponses,
  GetVoiceModelsData,
  GetVoiceModelsErrors,
  GetVoiceModelsResponses,
  GetVoiceModelVoicesData,
  GetVoiceModelVoicesErrors,
  GetVoiceModelVoicesResponses,
  GetWelcomeAuthConfigData,
  GetWelcomeAuthConfigResponses,
  GetWorkerLogsData,
  GetWorkerLogsErrors,
  GetWorkerLogsResponses,
  GetWorkflowAnalyticsData,
  GetWorkflowAnalyticsErrors,
  GetWorkflowAnalyticsItemsData,
  GetWorkflowAnalyticsItemsResponses,
  GetWorkflowAnalyticsResponses,
  GetWorkflowCsvFileData,
  GetWorkflowCsvFileErrors,
  GetWorkflowCsvFileResponses,
  GetWorkflowData,
  GetWorkflowDependenciesData,
  GetWorkflowDependenciesErrors,
  GetWorkflowDependenciesResponses,
  GetWorkflowErrors,
  GetWorkflowEvaluatorDefinitionsData,
  GetWorkflowEvaluatorDefinitionsResponses,
  GetWorkflowForRunData,
  GetWorkflowForRunErrors,
  GetWorkflowForRunResponses,
  GetWorkflowHandledByData,
  GetWorkflowHandledByErrors,
  GetWorkflowHandledByResponses,
  GetWorkflowInputsData,
  GetWorkflowInputsErrors,
  GetWorkflowInputsResponses,
  GetWorkflowJsonFileData,
  GetWorkflowJsonFileErrors,
  GetWorkflowJsonFileResponses,
  GetWorkflowLogColumnsData,
  GetWorkflowLogColumnsErrors,
  GetWorkflowLogColumnsResponses,
  GetWorkflowNodeDependenciesData,
  GetWorkflowNodeDependenciesErrors,
  GetWorkflowNodeDependenciesResponses,
  GetWorkflowNodeInputsData,
  GetWorkflowNodeInputsErrors,
  GetWorkflowNodeInputsResponses,
  GetWorkflowResponses,
  GetWorkflowRunsData,
  GetWorkflowRunsErrors,
  GetWorkflowRunsResponses,
  GetWorkflowsData,
  GetWorkflowsErrors,
  GetWorkflowsResponses,
  GetWorkflowVersionData,
  GetWorkflowVersionErrors,
  GetWorkflowVersionResponses,
  GetWorkflowVersionsData,
  GetWorkflowVersionsErrors,
  GetWorkflowVersionsResponses,
  GetWorkflowVersionUsagesData,
  GetWorkflowVersionUsagesErrors,
  GetWorkflowVersionUsagesResponses,
  GetWorkshopRecentData,
  GetWorkshopRecentErrors,
  GetWorkshopRecentResponses,
  GetWorkspaceAnalyticsItemsData,
  GetWorkspaceAnalyticsItemsResponses,
  GoToLinkData,
  GoToLinkErrors,
  GoToLinkResponses,
  HealthData,
  HealthResponses,
  ImportCsvData,
  ImportCsvErrors,
  ImportCsvIntoTableData,
  ImportCsvIntoTableErrors,
  ImportCsvIntoTableResponses,
  ImportCsvResponses,
  ImportCsvRowsData,
  ImportCsvRowsErrors,
  ImportCsvRowsResponses,
  ImportInboxData,
  ImportInboxErrors,
  ImportInboxResponses,
  ImportPlanData,
  ImportPlanErrors,
  ImportPlanResponses,
  ImportPreviewData,
  ImportPreviewErrors,
  ImportPreviewResponses,
  ImportWorkflowData,
  ImportWorkflowErrors,
  ImportWorkflowResponses,
  ImprovePromptData,
  ImprovePromptErrors,
  ImprovePromptResponses,
  ImprovePromptWithHeuristicsData,
  ImprovePromptWithHeuristicsErrors,
  ImprovePromptWithHeuristicsJobData,
  ImprovePromptWithHeuristicsJobErrors,
  ImprovePromptWithHeuristicsJobResponses,
  ImprovePromptWithHeuristicsResponses,
  InsertRowData,
  InsertRowErrors,
  InsertRowResponses,
  InterpretTableFiltersData,
  InterpretTableFiltersErrors,
  InterpretTableFiltersResponses,
  InvalidateCacheData,
  InvalidateCacheResponses,
  InvalidateCacheTagData,
  InvalidateCacheTagErrors,
  InvalidateCacheTagResponses,
  IssueRecordWsAuthData,
  IssueRecordWsAuthErrors,
  IssueRecordWsAuthResponses,
  KbHealthManifestData,
  KbHealthManifestErrors,
  KbHealthManifestResponses,
  LegacyAuthUsersData,
  LegacyAuthUsersResponses,
  LinkConversationToCaseData,
  LinkConversationToCaseErrors,
  LinkConversationToCaseResponses,
  ListAgentTestSuitesData,
  ListAgentTestSuitesErrors,
  ListAgentTestSuitesResponses,
  ListAllWorkspaceRolesData,
  ListAllWorkspaceRolesErrors,
  ListAllWorkspaceRolesResponses,
  ListAppsData,
  ListAppsErrors,
  ListAppsResponses,
  ListAssistantToolsData,
  ListAssistantToolsErrors,
  ListAssistantToolsResponses,
  ListCasesData,
  ListCasesErrors,
  ListCasesResponses,
  ListChannelsData,
  ListChannelsResponses,
  ListClientsData,
  ListClientsResponses,
  ListComponentsAdminData,
  ListComponentsAdminResponses,
  ListConnectionsData,
  ListConnectionsResponses,
  ListConversationCostsData,
  ListConversationCostsErrors,
  ListConversationCostsResponses,
  ListConversationsData,
  ListConversationsErrors,
  ListConversationsResponses,
  ListDecisionModelConfigurationsData,
  ListDecisionModelConfigurationsErrors,
  ListDecisionModelConfigurationsResponses,
  ListDeploymentsData,
  ListDeploymentsErrors,
  ListDeploymentsResponses,
  ListEmbeddingConfigurationsData,
  ListEmbeddingConfigurationsErrors,
  ListEmbeddingConfigurationsResponses,
  ListEntityGrantsData,
  ListEntityGrantsErrors,
  ListEntityGrantsResponses,
  ListEvaluationRunsData,
  ListEvaluationRunsErrors,
  ListEvaluationRunsResponses,
  ListEvaluatorsData,
  ListEvaluatorsErrors,
  ListEvaluatorsResponses,
  ListGroupRolesAsPlatformAdminData,
  ListGroupRolesAsPlatformAdminErrors,
  ListGroupRolesAsPlatformAdminResponses,
  ListGroupRolesData,
  ListGroupRolesErrors,
  ListGroupRolesResponses,
  ListGroupUsersData,
  ListGroupUsersErrors,
  ListGroupUsersResponses,
  ListGroupVariablesData,
  ListGroupVariablesErrors,
  ListGroupVariablesResponses,
  ListInboxesData,
  ListInboxesErrors,
  ListInboxesResponses,
  ListInboxTemplatesData,
  ListInboxTemplatesErrors,
  ListInboxTemplatesResponses,
  ListIntegrationsAdminData,
  ListIntegrationsAdminResponses,
  ListKbSyncsData,
  ListKbSyncsErrors,
  ListKbSyncsResponses,
  ListKbTestSuitesData,
  ListKbTestSuitesErrors,
  ListKbTestSuitesResponses,
  ListMarketplacePluginsData,
  ListMarketplacePluginsErrors,
  ListMarketplacePluginsResponses,
  ListModelConfigurationsData,
  ListModelConfigurationsErrors,
  ListModelConfigurationsResponses,
  ListPeriodicTasksData,
  ListPeriodicTasksErrors,
  ListPeriodicTasksResponses,
  ListPluginCatalogData,
  ListPluginCatalogErrors,
  ListPluginCatalogResponses,
  ListPluginsData,
  ListPluginsErrors,
  ListPluginsResponses,
  ListPresetsData,
  ListPresetsErrors,
  ListPresetsResponses,
  ListPriceReferencesData,
  ListPriceReferencesErrors,
  ListPriceReferencesResponses,
  ListProviderDefinitionsData,
  ListProviderDefinitionsErrors,
  ListProviderDefinitionsResponses,
  ListProvidersData,
  ListProvidersErrors,
  ListProvidersResponses,
  ListRatedMessagesData,
  ListRatedMessagesErrors,
  ListRatedMessagesResponses,
  ListReposData,
  ListReposErrors,
  ListReposResponses,
  ListRerankerConfigurationsData,
  ListRerankerConfigurationsErrors,
  ListRerankerConfigurationsResponses,
  ListRowsData,
  ListRowsErrors,
  ListRowsResponses,
  ListRunsData,
  ListRunsErrors,
  ListRunsResponses,
  ListTablesData,
  ListTablesErrors,
  ListTablesResponses,
  ListTagsData,
  ListTagsErrors,
  ListTagsResponses,
  ListTasksData,
  ListTasksErrors,
  ListTasksResponses,
  ListTenantGroupsAsPlatformAdminData,
  ListTenantGroupsAsPlatformAdminErrors,
  ListTenantGroupsAsPlatformAdminResponses,
  ListTenantRolesAsPlatformAdminData,
  ListTenantRolesAsPlatformAdminErrors,
  ListTenantRolesAsPlatformAdminResponses,
  ListTenantRolesData,
  ListTenantRolesErrors,
  ListTenantRolesResponses,
  ListTenantsData,
  ListTenantsErrors,
  ListTenantsResponses,
  ListTestCasesData,
  ListTestCasesErrors,
  ListTestCasesResponses,
  ListUsersData,
  ListUsersErrors,
  ListUsersResponses,
  ListVoiceModelConfigurationsData,
  ListVoiceModelConfigurationsErrors,
  ListVoiceModelConfigurationsResponses,
  ListWorkflowTestSuitesData,
  ListWorkflowTestSuitesErrors,
  ListWorkflowTestSuitesResponses,
  ListWorkflowVariablesData,
  ListWorkflowVariablesErrors,
  ListWorkflowVariablesResponses,
  LoginData,
  LoginErrors,
  LoginResponses,
  MakeTemplateData,
  MakeTemplateErrors,
  MakeTemplateResponses,
  MergeTenantData,
  MergeTenantErrors,
  MergeTenantResponses,
  MigrateGoogleCredentialsData,
  MigrateGoogleCredentialsResponses,
  MigrateLegacyCredentialsData,
  MigrateLegacyCredentialsResponses,
  MigrationConnectionsData,
  MigrationConnectionsResponses,
  MigrationIdentityData,
  MigrationIdentityResponses,
  MoveCaseData,
  MoveCaseErrors,
  MoveCaseResponses,
  MoveSpecNodeData,
  MoveSpecNodeErrors,
  MoveSpecNodeResponses,
  OauthCallbackData,
  OauthCallbackResponses,
  OauthStartData,
  OauthStartErrors,
  OauthStartResponses,
  OpenStripeBillingPortalData,
  OpenStripeBillingPortalResponses,
  PatchSpecCaseData,
  PatchSpecCaseErrors,
  PatchSpecCaseResponses,
  PatchSpecNodeData,
  PatchSpecNodeErrors,
  PatchSpecNodeResponses,
  PatchUserProfileData,
  PatchUserProfileErrors,
  PatchUserProfileResponses,
  PauseTeamsAppData,
  PauseTeamsAppErrors,
  PauseTeamsAppResponses,
  PlatformStatusData,
  PlatformStatusResponses,
  PollDeviceAuthData,
  PollDeviceAuthErrors,
  PollDeviceAuthResponses,
  PreviewAssistantChangesData,
  PreviewAssistantChangesErrors,
  PreviewAssistantChangesResponses,
  PreviewNewAssistantChangesData,
  PreviewNewAssistantChangesErrors,
  PreviewNewAssistantChangesResponses,
  PullOneArtifactData,
  PullOneArtifactErrors,
  PullOneArtifactResponses,
  PushOneArtifactData,
  PushOneArtifactErrors,
  PushOneArtifactResponses,
  PutConfigData,
  PutConfigErrors,
  PutConfigResponses,
  QueryTablesData,
  QueryTablesErrors,
  QueryTablesResponses,
  ReadItemData,
  ReadItemResponses,
  ReceiveEmailData,
  ReceiveEmailErrors,
  ReceiveEmailResponses,
  RecordChatTimingData,
  RecordChatTimingErrors,
  RecordChatTimingResponses,
  RedisConnData,
  RedisConnResponses,
  RefineTextData,
  RefineTextErrors,
  RefineTextResponses,
  RefreshAuth0UsersData,
  RefreshAuth0UsersResponses,
  RefreshEmbedSessionData,
  RefreshEmbedSessionErrors,
  RefreshEmbedSessionResponses,
  RefreshMessageData,
  RefreshMessageErrors,
  RefreshMessageResponses,
  RejectTenantInvitationData,
  RejectTenantInvitationResponses,
  ReloadPluginData,
  ReloadPluginErrors,
  ReloadPluginResponses,
  RemigrateSecretAuthCredentialsData,
  RemigrateSecretAuthCredentialsResponses,
  RemoveErrorHandlerForWorkflowData,
  RemoveErrorHandlerForWorkflowErrors,
  RemoveErrorHandlerForWorkflowResponses,
  RemoveMessageFeedbackData,
  RemoveMessageFeedbackErrors,
  RemoveMessageFeedbackResponses,
  RemoveQueuedSandboxRequestData,
  RemoveQueuedSandboxRequestErrors,
  RemoveQueuedSandboxRequestResponses,
  RemoveUserFromGroupData,
  RemoveUserFromGroupErrors,
  RemoveUserFromGroupResponses,
  RenameColumnData,
  RenameColumnErrors,
  RenameColumnResponses,
  RenameCredentialData,
  RenameCredentialErrors,
  RenameCredentialResponses,
  RenameInboxGroupData,
  RenameInboxGroupErrors,
  RenameInboxGroupResponses,
  RenameTenantData,
  RenameTenantErrors,
  RenameTenantResponses,
  ReorderColumnsData,
  ReorderColumnsErrors,
  ReorderColumnsResponses,
  RepairKbHealthData,
  RepairKbHealthErrors,
  RepairKbHealthResponses,
  RepairKnowledgeBaseV2Data,
  RepairKnowledgeBaseV2Errors,
  RepairKnowledgeBaseV2Responses,
  RepairNoxusLinksData,
  RepairNoxusLinksResponses,
  ReplayTriggerEventData,
  ReplayTriggerEventErrors,
  ReplayTriggerEventResponses,
  RepriceCustomModelUsageData,
  RepriceCustomModelUsageErrors,
  RepriceCustomModelUsageResponses,
  ReprobeToolsData,
  ReprobeToolsErrors,
  ReprobeToolsResponses,
  ReprocessCaseData,
  ReprocessCaseErrors,
  ReprocessCaseResponses,
  ResendEmailData,
  ResendEmailErrors,
  ResendEmailResponses,
  ResetPresetToDefaultData,
  ResetPresetToDefaultErrors,
  ResetPresetToDefaultResponses,
  RestoreAssistantData,
  RestoreAssistantErrors,
  RestoreAssistantResponses,
  RestoreAssistantVersionData,
  RestoreAssistantVersionErrors,
  RestoreAssistantVersionResponses,
  RestoreWorkflowData,
  RestoreWorkflowErrors,
  RestoreWorkflowFromRunData,
  RestoreWorkflowFromRunErrors,
  RestoreWorkflowFromRunResponses,
  RestoreWorkflowResponses,
  RestoreWorkflowVersionData,
  RestoreWorkflowVersionErrors,
  RestoreWorkflowVersionResponses,
  ResumeQueuedData,
  ResumeQueuedErrors,
  ResumeQueuedResponses,
  ResumeRecent2Data,
  ResumeRecent2Errors,
  ResumeRecent2Responses,
  ResumeRecentData,
  ResumeRecentErrors,
  ResumeRecentResponses,
  ResumeRunData,
  ResumeRunErrors,
  ResumeRunResponses,
  ResumeTeamsAppData,
  ResumeTeamsAppErrors,
  ResumeTeamsAppResponses,
  RetrieveWorkflowLogsData,
  RetrieveWorkflowLogsErrors,
  RetrieveWorkflowLogsResponses,
  RetryDocumentIngestionData,
  RetryDocumentIngestionErrors,
  RetryDocumentIngestionResponses,
  RetryTeamsAppData,
  RetryTeamsAppErrors,
  RetryTeamsAppResponses,
  RetryTrainKnowledgeBaseData,
  RetryTrainKnowledgeBaseErrors,
  RetryTrainKnowledgeBaseResponses,
  ReviewAuth0EmailsData,
  ReviewAuth0EmailsResponses,
  RevokeAllClientsData,
  RevokeAllClientsResponses,
  RevokeClientData,
  RevokeClientErrors,
  RevokeClientResponses,
  RevokeEmbedSessionsData,
  RevokeEmbedSessionsErrors,
  RevokeEmbedSessionsResponses,
  RunEventsData,
  RunEventsErrors,
  RunEventsResponses,
  RunHealthChecksData,
  RunHealthChecksErrors,
  RunHealthChecksResponses,
  RunInsightsAggregatesData,
  RunInsightsAggregatesResponses,
  RunInsightsAnalysisData,
  RunInsightsAnalysisResponses,
  RunKbHealthData,
  RunKbHealthErrors,
  RunKbHealthResponses,
  RunLifecycleHealthChecksData,
  RunLifecycleHealthChecksResponses,
  SandboxAllocationsData,
  SandboxAllocationsResponses,
  SaveProviderConfigEndpointData,
  SaveProviderConfigEndpointErrors,
  SaveProviderConfigEndpointResponses,
  SaveWorkflowData,
  SaveWorkflowErrors,
  SaveWorkflowResponses,
  SearchGroupRunsData,
  SearchGroupRunsErrors,
  SearchGroupRunsResponses,
  SearchKnowledgeBaseData,
  SearchKnowledgeBaseErrors,
  SearchKnowledgeBaseResponses,
  SearchWorkflowRunsData,
  SearchWorkflowRunsErrors,
  SearchWorkflowRunsResponses,
  SendAuthEmailData,
  SendAuthEmailResponses,
  SendRunLogsToSupportData,
  SendRunLogsToSupportErrors,
  SendRunLogsToSupportResponses,
  SendVerificationEmailData,
  SendVerificationEmailResponses,
  SetApiKeysData,
  SetApiKeysErrors,
  SetApiKeysResponses,
  SetBetaFeatureData,
  SetBetaFeatureErrors,
  SetBetaFeatureResponses,
  SetChaosTestingConfigData,
  SetChaosTestingConfigErrors,
  SetChaosTestingConfigResponses,
  SetComponentEnabledData,
  SetComponentEnabledErrors,
  SetComponentEnabledResponses,
  SetConnectionEnabledData,
  SetConnectionEnabledErrors,
  SetConnectionEnabledResponses,
  SetEmailDeliveryData,
  SetEmailDeliveryErrors,
  SetEmailDeliveryResponses,
  SetEntityGrantsData,
  SetEntityGrantsErrors,
  SetEntityGrantsResponses,
  SetGroupUserPermissionsData,
  SetGroupUserPermissionsErrors,
  SetGroupUserPermissionsResponses,
  SetIntegrationEnabledData,
  SetIntegrationEnabledErrors,
  SetIntegrationEnabledResponses,
  SetIntegrationScopesEndpointData,
  SetIntegrationScopesEndpointErrors,
  SetIntegrationScopesEndpointResponses,
  SetNoxusProviderConfigData,
  SetNoxusProviderConfigErrors,
  SetNoxusProviderConfigResponses,
  SetTestSuiteBaselineData,
  SetTestSuiteBaselineErrors,
  SetTestSuiteBaselineResponses,
  SetupIntegrationData,
  SetupIntegrationErrors,
  SetupIntegrationResponses,
  SetUserAdminStatusData,
  SetUserAdminStatusErrors,
  SetUserAdminStatusResponses,
  SetUserPermissionsData,
  SetUserPermissionsErrors,
  SetUserPermissionsResponses,
  SignupData,
  SignupErrors,
  SignupResponses,
  SimulateEmailData,
  SimulateEmailErrors,
  SimulateEmailResponses,
  StartDeviceAuthData,
  StartDeviceAuthErrors,
  StartDeviceAuthResponses,
  StartEvaluationRunData,
  StartEvaluationRunErrors,
  StartEvaluationRunResponses,
  StartKbEvaluationRunData,
  StartKbEvaluationRunErrors,
  StartKbEvaluationRunResponses,
  StopConversationData,
  StopConversationErrors,
  StopConversationResponses,
  StopRunData,
  StopRunErrors,
  StopRunResponses,
  StorageStatusData,
  StorageStatusResponses,
  StreamKbHealthData,
  StreamKbHealthErrors,
  StreamKbHealthResponses,
  StreamTestBatchData,
  StreamTestBatchErrors,
  StreamTestBatchResponses,
  SubmitQuestionnaireData,
  SubmitQuestionnaireErrors,
  SubmitQuestionnaireResponses,
  SummarizeTableWriteData,
  SummarizeTableWriteErrors,
  SummarizeTableWriteResponses,
  SuspendTenantData,
  SuspendTenantErrors,
  SuspendTenantResponses,
  SyncOidcConnectionData,
  SyncOidcConnectionResponses,
  SyncSpreadsheetLogsData,
  SyncSpreadsheetLogsErrors,
  SyncSpreadsheetLogsResponses,
  TagEntityData,
  TagEntityErrors,
  TagEntityResponses,
  TerminateDatabaseBackendData,
  TerminateDatabaseBackendErrors,
  TerminateDatabaseBackendResponses,
  TestAllModelsData,
  TestAllModelsErrors,
  TestAllModelsResponses,
  TestConnectionData,
  TestConnectionErrors,
  TestConnectionResponses,
  TestProviderConnectionData,
  TestProviderConnectionErrors,
  TestProviderConnectionResponses,
  TestProviderLinkData,
  TestProviderLinkErrors,
  TestProviderLinkResponses,
  TestRedisConnData,
  TestRedisConnResponses,
  TestVaultReference2Data,
  TestVaultReference2Errors,
  TestVaultReference2Responses,
  TestVaultReferenceData,
  TestVaultReferenceErrors,
  TestVaultReferenceResponses,
  ToggleLifecyclePauseData,
  ToggleLifecyclePauseResponses,
  TopupCreditsData,
  TopupCreditsErrors,
  TopupCreditsResponses,
  TranslateTextData,
  TranslateTextErrors,
  TranslateTextResponses,
  TriggerCsatDebugData,
  TriggerCsatDebugErrors,
  TriggerCsatDebugResponses,
  TriggerInsightsBootstrapData,
  TriggerInsightsBootstrapErrors,
  TriggerInsightsBootstrapResponses,
  TriggerRunData,
  TriggerRunDataBackfillData,
  TriggerRunDataBackfillErrors,
  TriggerRunDataBackfillResponses,
  TriggerRunErrors,
  TriggerRunResponses,
  UnsyncKbDocumentData,
  UnsyncKbDocumentErrors,
  UnsyncKbDocumentResponses,
  UnsyncSpreadsheetLogsData,
  UnsyncSpreadsheetLogsErrors,
  UnsyncSpreadsheetLogsResponses,
  UntagEntityData,
  UntagEntityErrors,
  UntagEntityResponses,
  UpdateAssistantData,
  UpdateAssistantErrors,
  UpdateAssistantResponses,
  UpdateAssistantVersionData,
  UpdateAssistantVersionErrors,
  UpdateAssistantVersionResponses,
  UpdateAuth0EmailsData,
  UpdateAuth0EmailsErrors,
  UpdateAuth0EmailsResponses,
  UpdateAuthConfigData,
  UpdateAuthConfigErrors,
  UpdateAuthConfigResponses,
  UpdateCaseData,
  UpdateCaseErrors,
  UpdateCaseResponses,
  UpdateColumnLabelData,
  UpdateColumnLabelErrors,
  UpdateColumnLabelResponses,
  UpdateConnectionData,
  UpdateConnectionErrors,
  UpdateConnectionResponses,
  UpdateConversationData,
  UpdateConversationErrors,
  UpdateConversationResponses,
  UpdateCredentialData,
  UpdateCredentialErrors,
  UpdateCredentialResponses,
  UpdateCredentialSettingsData,
  UpdateCredentialSettingsErrors,
  UpdateCredentialSettingsResponses,
  UpdateCustomModelConfigurationData,
  UpdateCustomModelConfigurationErrors,
  UpdateCustomModelConfigurationResponses,
  UpdateDeploymentData,
  UpdateDeploymentErrors,
  UpdateDeploymentResponses,
  UpdateEmbeddingConfigurationData,
  UpdateEmbeddingConfigurationErrors,
  UpdateEmbeddingConfigurationResponses,
  UpdateEnabledToolsData,
  UpdateEnabledToolsErrors,
  UpdateEnabledToolsResponses,
  UpdateEvaluatorData,
  UpdateEvaluatorErrors,
  UpdateEvaluatorResponses,
  UpdateFeatureFlagsData,
  UpdateFeatureFlagsErrors,
  UpdateFeatureFlagsResponses,
  UpdateGroupRoleData,
  UpdateGroupRoleErrors,
  UpdateGroupRoleResponses,
  UpdateGroupVariableData,
  UpdateGroupVariableErrors,
  UpdateGroupVariableResponses,
  UpdateInboxCaseLayoutData,
  UpdateInboxCaseLayoutErrors,
  UpdateInboxCaseLayoutResponses,
  UpdateInboxData,
  UpdateInboxErrors,
  UpdateInboxFieldData,
  UpdateInboxFieldErrors,
  UpdateInboxFieldResponses,
  UpdateInboxResponses,
  UpdateInsightsConfigData,
  UpdateInsightsConfigErrors,
  UpdateInsightsConfigResponses,
  UpdateIntegrationSettingsEndpointData,
  UpdateIntegrationSettingsEndpointErrors,
  UpdateIntegrationSettingsEndpointResponses,
  UpdateKbSyncData,
  UpdateKbSyncErrors,
  UpdateKbSyncResponses,
  UpdateKnowledgeBaseDocumentData,
  UpdateKnowledgeBaseDocumentErrors,
  UpdateKnowledgeBaseDocumentResponses,
  UpdateKnowledgeBaseV2Data,
  UpdateKnowledgeBaseV2Errors,
  UpdateKnowledgeBaseV2Responses,
  UpdateLabellingTaskData,
  UpdateLabellingTaskErrors,
  UpdateLabellingTaskResponses,
  UpdateLifecycleConfigData,
  UpdateLifecycleConfigErrors,
  UpdateLifecycleConfigResponses,
  UpdateLimitData,
  UpdateLimitErrors,
  UpdateLimitResponses,
  UpdateMeData,
  UpdateMeErrors,
  UpdateMeResponses,
  UpdateModelConfigurationData,
  UpdateModelConfigurationErrors,
  UpdateModelConfigurationResponses,
  UpdatePeriodicTaskData,
  UpdatePeriodicTaskErrors,
  UpdatePeriodicTaskResponses,
  UpdatePluginConfigData,
  UpdatePluginConfigErrors,
  UpdatePluginConfigResponses,
  UpdatePresetData,
  UpdatePresetErrors,
  UpdatePresetResponses,
  UpdateProviderData,
  UpdateProviderErrors,
  UpdateProviderLinkData,
  UpdateProviderLinkErrors,
  UpdateProviderLinkResponses,
  UpdateProviderResponses,
  UpdateRateLimitsData,
  UpdateRateLimitsErrors,
  UpdateRateLimitsResponses,
  UpdateRowData,
  UpdateRowErrors,
  UpdateRowResponses,
  UpdateSecuritySettingsData,
  UpdateSecuritySettingsErrors,
  UpdateSecuritySettingsResponses,
  UpdateServerSettingsData,
  UpdateServerSettingsErrors,
  UpdateServerSettingsResponses,
  UpdateSubscriptionPlanData,
  UpdateSubscriptionPlanErrors,
  UpdateSubscriptionPlanResponses,
  UpdateTableData,
  UpdateTableErrors,
  UpdateTableResponses,
  UpdateTagData,
  UpdateTagErrors,
  UpdateTagResponses,
  UpdateTaskData,
  UpdateTaskErrors,
  UpdateTaskResponses,
  UpdateTenantData,
  UpdateTenantErrors,
  UpdateTenantResponses,
  UpdateTenantRoleData,
  UpdateTenantRoleErrors,
  UpdateTenantRoleResponses,
  UpdateTestCaseData,
  UpdateTestCaseErrors,
  UpdateTestCaseResponses,
  UpdateTestSuiteData,
  UpdateTestSuiteErrors,
  UpdateTestSuiteResponses,
  UpdateTriggersData,
  UpdateTriggersErrors,
  UpdateTriggersResponses,
  UpdateUserMetadataData,
  UpdateUserMetadataErrors,
  UpdateUserMetadataResponses,
  UpdateWorkflowData,
  UpdateWorkflowErrors,
  UpdateWorkflowResponses,
  UpdateWorkflowVariableData,
  UpdateWorkflowVariableErrors,
  UpdateWorkflowVariableResponses,
  UpdateWorkflowVersionData,
  UpdateWorkflowVersionErrors,
  UpdateWorkflowVersionResponses,
  UpgradeCredentialsToNcsData,
  UpgradeCredentialsToNcsResponses,
  UpgradeTenantSubscriptionData,
  UpgradeTenantSubscriptionErrors,
  UpgradeTenantSubscriptionResponses,
  UploadTrainKnowledgeBaseData,
  UploadTrainKnowledgeBaseErrors,
  UploadTrainKnowledgeBaseResponses,
  V0CreateRunData,
  V0CreateRunErrors,
  V0CreateRunResponses,
  V0GetRunData,
  V0GetRunErrors,
  V0GetRunResponses,
  ValidatePluginConfigData,
  ValidatePluginConfigErrors,
  ValidatePluginConfigResponses,
  ValidateRecaptchaTokenData,
  ValidateRecaptchaTokenErrors,
  ValidateRecaptchaTokenResponses,
  ValidateWorkflowV2EndpointData,
  ValidateWorkflowV2EndpointErrors,
  ValidateWorkflowV2EndpointResponses,
  VercelEventsData,
  VercelEventsErrors,
  VercelEventsResponses,
  VercelEventsResumeData,
  VercelEventsResumeErrors,
  VercelEventsResumeResponses,
  VerifyRunOwnerData,
  VerifyRunOwnerErrors,
  VerifyRunOwnerResponses,
  WatchKbHealthRepairData,
  WatchKbHealthRepairErrors,
  WatchKbHealthRepairResponses,
  WebhookCheckoutCompletedData,
  WebhookCheckoutCompletedResponses,
  WebhookSubscriptionUpdatedData,
  WebhookSubscriptionUpdatedErrors,
  WebhookSubscriptionUpdatedResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, true> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export class WorkflowService {
  /**
   * Get Workflows
   */
  public static getWorkflows(options: Options<GetWorkflowsData, true>) {
    return (options.client ?? client).get<
      GetWorkflowsResponses,
      GetWorkflowsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows",
      ...options,
    });
  }

  /**
   * Add Workflow
   */
  public static addWorkflow(options: Options<AddWorkflowData, true>) {
    return (options.client ?? client).post<
      AddWorkflowResponses,
      AddWorkflowErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Import Workflow
   */
  public static importWorkflow(options: Options<ImportWorkflowData, true>) {
    return (options.client ?? client).post<
      ImportWorkflowResponses,
      ImportWorkflowErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/import",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Workflow
   */
  public static deleteWorkflow(options: Options<DeleteWorkflowData, true>) {
    return (options.client ?? client).delete<
      DeleteWorkflowResponses,
      DeleteWorkflowErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Workflow
   */
  public static getWorkflow(options: Options<GetWorkflowData, true>) {
    return (options.client ?? client).get<
      GetWorkflowResponses,
      GetWorkflowErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}",
      ...options,
    });
  }

  /**
   * Update Workflow
   */
  public static updateWorkflow(options: Options<UpdateWorkflowData, true>) {
    return (options.client ?? client).patch<
      UpdateWorkflowResponses,
      UpdateWorkflowErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Remove Error Handler For Workflow
   */
  public static removeErrorHandlerForWorkflow(
    options: Options<RemoveErrorHandlerForWorkflowData, true>
  ) {
    return (options.client ?? client).delete<
      RemoveErrorHandlerForWorkflowResponses,
      RemoveErrorHandlerForWorkflowErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/error_handler",
      ...options,
    });
  }

  /**
   * Create Error Handler For Workflow
   */
  public static createErrorHandlerForWorkflow(
    options: Options<CreateErrorHandlerForWorkflowData, true>
  ) {
    return (options.client ?? client).post<
      CreateErrorHandlerForWorkflowResponses,
      CreateErrorHandlerForWorkflowErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/error_handler",
      ...options,
    });
  }

  /**
   * Validate Workflow V2 Endpoint
   *
   * Validate a V2 workflow (the four rules) and return per-node field/node
   * errors so the editor can highlight fields, badge nodes, and gate Run.
   */
  public static validateWorkflowV2Endpoint(
    options: Options<ValidateWorkflowV2EndpointData, true>
  ) {
    return (options.client ?? client).post<
      ValidateWorkflowV2EndpointResponses,
      ValidateWorkflowV2EndpointErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/validate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Workflow Dependencies
   */
  public static getWorkflowDependencies(
    options: Options<GetWorkflowDependenciesData, true>
  ) {
    return (options.client ?? client).post<
      GetWorkflowDependenciesResponses,
      GetWorkflowDependenciesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/dependencies",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Workflow Inputs
   */
  public static getWorkflowInputs(
    options: Options<GetWorkflowInputsData, true>
  ) {
    return (options.client ?? client).post<
      GetWorkflowInputsResponses,
      GetWorkflowInputsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/inputs",
      ...options,
    });
  }

  /**
   * Get Workflow Node Dependencies
   */
  public static getWorkflowNodeDependencies(
    options: Options<GetWorkflowNodeDependenciesData, true>
  ) {
    return (options.client ?? client).post<
      GetWorkflowNodeDependenciesResponses,
      GetWorkflowNodeDependenciesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/nodes/{node_id}/dependencies",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Workflow Node Inputs
   */
  public static getWorkflowNodeInputs(
    options: Options<GetWorkflowNodeInputsData, true>
  ) {
    return (options.client ?? client).post<
      GetWorkflowNodeInputsResponses,
      GetWorkflowNodeInputsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/nodes/{node_id}/inputs",
      ...options,
    });
  }

  /**
   * Get Node Last Inputs
   *
   * Get the last available inputs for a specific node from the most recent run that includes this node.
   * Returns None if no run data is available.
   *
   * Efficiently queries only the last 30 runs to find data for this node.
   */
  public static getNodeLastInputs(
    options: Options<GetNodeLastInputsData, true>
  ) {
    return (options.client ?? client).get<
      GetNodeLastInputsResponses,
      GetNodeLastInputsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/nodes/{node_id}/last-inputs",
      ...options,
    });
  }

  /**
   * Save Workflow
   */
  public static saveWorkflow(options: Options<SaveWorkflowData, true>) {
    return (options.client ?? client).post<
      SaveWorkflowResponses,
      SaveWorkflowErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/save",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Is Valid Workflow
   */
  public static getIsValidWorkflow(
    options: Options<GetIsValidWorkflowData, true>
  ) {
    return (options.client ?? client).get<
      GetIsValidWorkflowResponses,
      GetIsValidWorkflowErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/valid",
      ...options,
    });
  }

  /**
   * Get Is Valid Workflow From Definition
   */
  public static getIsValidWorkflowFromDefinition(
    options: Options<GetIsValidWorkflowFromDefinitionData, true>
  ) {
    return (options.client ?? client).post<
      GetIsValidWorkflowFromDefinitionResponses,
      GetIsValidWorkflowFromDefinitionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/valid",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Is Valid Workflow V2 From Definition
   */
  public static getIsValidWorkflowV2FromDefinition(
    options: Options<GetIsValidWorkflowV2FromDefinitionData, true>
  ) {
    return (options.client ?? client).post<
      GetIsValidWorkflowV2FromDefinitionResponses,
      GetIsValidWorkflowV2FromDefinitionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/valid/v2",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Duplicate Workflow
   */
  public static duplicateWorkflow(
    options: Options<DuplicateWorkflowData, true>
  ) {
    return (options.client ?? client).post<
      DuplicateWorkflowResponses,
      DuplicateWorkflowErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/duplicate",
      ...options,
    });
  }

  /**
   * Export Workflow Preview
   *
   * Preview what will be exported for a workflow.
   *
   * Returns a list of entities that would be exported along with any warnings
   * (e.g., KBs that are too large).
   */
  public static exportWorkflowPreview(
    options: Options<ExportWorkflowPreviewData, true>
  ) {
    return (options.client ?? client).get<
      ExportWorkflowPreviewResponses,
      ExportWorkflowPreviewErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/export/preview",
      ...options,
    });
  }

  /**
   * Export Workflow
   */
  public static exportWorkflow(options: Options<ExportWorkflowData, true>) {
    return (options.client ?? client).post<
      ExportWorkflowResponses,
      ExportWorkflowErrors,
      true
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/export",
      ...options,
    });
  }

  /**
   * Get Workflow Handled By
   */
  public static getWorkflowHandledBy(
    options: Options<GetWorkflowHandledByData, true>
  ) {
    return (options.client ?? client).get<
      GetWorkflowHandledByResponses,
      GetWorkflowHandledByErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/handled-workflow",
      ...options,
    });
  }

  /**
   * Restore Workflow
   */
  public static restoreWorkflow(options: Options<RestoreWorkflowData, true>) {
    return (options.client ?? client).post<
      RestoreWorkflowResponses,
      RestoreWorkflowErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/restore",
      ...options,
    });
  }

  /**
   * Get Workflow Log Columns
   */
  public static getWorkflowLogColumns(
    options: Options<GetWorkflowLogColumnsData, true>
  ) {
    return (options.client ?? client).get<
      GetWorkflowLogColumnsResponses,
      GetWorkflowLogColumnsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/logs/details",
      ...options,
    });
  }

  /**
   * Get Workflow Csv File
   */
  public static getWorkflowCsvFile(
    options: Options<GetWorkflowCsvFileData, true>
  ) {
    return (options.client ?? client).get<
      GetWorkflowCsvFileResponses,
      GetWorkflowCsvFileErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/logs/csv",
      ...options,
    });
  }

  /**
   * Get Workflow Json File
   */
  public static getWorkflowJsonFile(
    options: Options<GetWorkflowJsonFileData, true>
  ) {
    return (options.client ?? client).get<
      GetWorkflowJsonFileResponses,
      GetWorkflowJsonFileErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/logs/json",
      ...options,
    });
  }

  /**
   * Retrieve Workflow Logs
   */
  public static retrieveWorkflowLogs(
    options: Options<RetrieveWorkflowLogsData, true>
  ) {
    return (options.client ?? client).get<
      RetrieveWorkflowLogsResponses,
      RetrieveWorkflowLogsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/logs",
      ...options,
    });
  }

  /**
   * Sync Spreadsheet Logs
   */
  public static syncSpreadsheetLogs(
    options: Options<SyncSpreadsheetLogsData, true>
  ) {
    return (options.client ?? client).post<
      SyncSpreadsheetLogsResponses,
      SyncSpreadsheetLogsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/logs/spreadsheet/sync",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Unsync Spreadsheet Logs
   */
  public static unsyncSpreadsheetLogs(
    options: Options<UnsyncSpreadsheetLogsData, true>
  ) {
    return (options.client ?? client).post<
      UnsyncSpreadsheetLogsResponses,
      UnsyncSpreadsheetLogsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/logs/spreadsheet/unsync",
      ...options,
    });
  }

  /**
   * Get Workshop Recent
   */
  public static getWorkshopRecent(
    options: Options<GetWorkshopRecentData, true>
  ) {
    return (options.client ?? client).get<
      GetWorkshopRecentResponses,
      GetWorkshopRecentErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workshop",
      ...options,
    });
  }

  /**
   * Get Workflow Versions
   */
  public static getWorkflowVersions(
    options: Options<GetWorkflowVersionsData, true>
  ) {
    return (options.client ?? client).get<
      GetWorkflowVersionsResponses,
      GetWorkflowVersionsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/versions",
      ...options,
    });
  }

  /**
   * Create Workflow Version
   */
  public static createWorkflowVersion(
    options: Options<CreateWorkflowVersionData, true>
  ) {
    return (options.client ?? client).post<
      CreateWorkflowVersionResponses,
      CreateWorkflowVersionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/versions",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Workflow Version
   */
  public static getWorkflowVersion(
    options: Options<GetWorkflowVersionData, true>
  ) {
    return (options.client ?? client).get<
      GetWorkflowVersionResponses,
      GetWorkflowVersionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/versions/{version_id}",
      ...options,
    });
  }

  /**
   * Update Workflow Version
   */
  public static updateWorkflowVersion(
    options: Options<UpdateWorkflowVersionData, true>
  ) {
    return (options.client ?? client).patch<
      UpdateWorkflowVersionResponses,
      UpdateWorkflowVersionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/versions/{version_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Workflow Version Usages
   */
  public static getWorkflowVersionUsages(
    options: Options<GetWorkflowVersionUsagesData, true>
  ) {
    return (options.client ?? client).get<
      GetWorkflowVersionUsagesResponses,
      GetWorkflowVersionUsagesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/versions/{version_id}/usages",
      ...options,
    });
  }

  /**
   * Restore Workflow Version
   */
  public static restoreWorkflowVersion(
    options: Options<RestoreWorkflowVersionData, true>
  ) {
    return (options.client ?? client).post<
      RestoreWorkflowVersionResponses,
      RestoreWorkflowVersionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/versions/{version_id}/restore",
      ...options,
    });
  }

  /**
   * Restore Workflow From Run
   *
   * Restore a workflow to the definition captured in a specific run.
   */
  public static restoreWorkflowFromRun(
    options: Options<RestoreWorkflowFromRunData, true>
  ) {
    return (options.client ?? client).post<
      RestoreWorkflowFromRunResponses,
      RestoreWorkflowFromRunErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/runs/{run_id}/restore",
      ...options,
    });
  }
}

export class WorkflowVariablesService {
  /**
   * List Workflow Variables
   */
  public static listWorkflowVariables(
    options: Options<ListWorkflowVariablesData, true>
  ) {
    return (options.client ?? client).get<
      ListWorkflowVariablesResponses,
      ListWorkflowVariablesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/variables",
      ...options,
    });
  }

  /**
   * Create Workflow Variable
   */
  public static createWorkflowVariable(
    options: Options<CreateWorkflowVariableData, true>
  ) {
    return (options.client ?? client).post<
      CreateWorkflowVariableResponses,
      CreateWorkflowVariableErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/variables",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Workflow Variable
   */
  public static deleteWorkflowVariable(
    options: Options<DeleteWorkflowVariableData, true>
  ) {
    return (options.client ?? client).delete<
      DeleteWorkflowVariableResponses,
      DeleteWorkflowVariableErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/variables/{variable_id}",
      ...options,
    });
  }

  /**
   * Update Workflow Variable
   */
  public static updateWorkflowVariable(
    options: Options<UpdateWorkflowVariableData, true>
  ) {
    return (options.client ?? client).patch<
      UpdateWorkflowVariableResponses,
      UpdateWorkflowVariableErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/variables/{variable_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Test Vault Reference
   *
   * Verify that a vault reference resolves — never returns the plaintext.
   */
  public static testVaultReference(
    options: Options<TestVaultReferenceData, true>
  ) {
    return (options.client ?? client).post<
      TestVaultReferenceResponses,
      TestVaultReferenceErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/variables/test-vault",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class WorkspaceVariablesService {
  /**
   * List Group Variables
   */
  public static listGroupVariables(
    options: Options<ListGroupVariablesData, true>
  ) {
    return (options.client ?? client).get<
      ListGroupVariablesResponses,
      ListGroupVariablesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/variables",
      ...options,
    });
  }

  /**
   * Create Group Variable
   */
  public static createGroupVariable(
    options: Options<CreateGroupVariableData, true>
  ) {
    return (options.client ?? client).post<
      CreateGroupVariableResponses,
      CreateGroupVariableErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/variables",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Group Variable Sources
   */
  public static getGroupVariableSources(
    options: Options<GetGroupVariableSourcesData, true>
  ) {
    return (options.client ?? client).get<
      GetGroupVariableSourcesResponses,
      GetGroupVariableSourcesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/variables/sources",
      ...options,
    });
  }

  /**
   * Delete Group Variable
   */
  public static deleteGroupVariable(
    options: Options<DeleteGroupVariableData, true>
  ) {
    return (options.client ?? client).delete<
      DeleteGroupVariableResponses,
      DeleteGroupVariableErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/variables/{variable_id}",
      ...options,
    });
  }

  /**
   * Update Group Variable
   */
  public static updateGroupVariable(
    options: Options<UpdateGroupVariableData, true>
  ) {
    return (options.client ?? client).patch<
      UpdateGroupVariableResponses,
      UpdateGroupVariableErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/variables/{variable_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Test Vault Reference
   *
   * Verify that a vault reference resolves — never returns the plaintext.
   */
  public static testVaultReference(
    options: Options<TestVaultReference2Data, true>
  ) {
    return (options.client ?? client).post<
      TestVaultReference2Responses,
      TestVaultReference2Errors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/variables/test-vault",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class UsersService {
  /**
   * Create User
   */
  public static createUser(options: Options<CreateUserData, true>) {
    return (options.client ?? client).post<
      CreateUserResponses,
      CreateUserErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/users",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Check Domain Reservation
   *
   * Check if an email's domain is reserved by an existing organization.
   */
  public static checkDomainReservation(
    options: Options<CheckDomainReservationData, true>
  ) {
    return (options.client ?? client).get<
      CheckDomainReservationResponses,
      CheckDomainReservationErrors,
      true
    >({
      responseType: "json",
      url: "/users/check-domain-reservation",
      ...options,
    });
  }

  /**
   * Check Authorized
   */
  public static checkAuthorized(options?: Options<CheckAuthorizedData, true>) {
    return (options?.client ?? client).post<
      CheckAuthorizedResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/users/me/is-authorized",
      ...options,
    });
  }

  /**
   * Delete Me
   */
  public static deleteMe(options: Options<DeleteMeData, true>) {
    return (options.client ?? client).delete<
      DeleteMeResponses,
      DeleteMeErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/users/me",
      ...options,
    });
  }

  /**
   * Get Me
   */
  public static getMe(options?: Options<GetMeData, true>) {
    return (options?.client ?? client).get<GetMeResponses, unknown, true>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/users/me",
      ...options,
    });
  }

  /**
   * Update Me
   */
  public static updateMe(options: Options<UpdateMeData, true>) {
    return (options.client ?? client).patch<
      UpdateMeResponses,
      UpdateMeErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/users/me",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Anonymous User
   */
  public static getAnonymousUser(
    options?: Options<GetAnonymousUserData, true>
  ) {
    return (options?.client ?? client).get<
      GetAnonymousUserResponses,
      unknown,
      true
    >({
      responseType: "json",
      url: "/users/anonymous",
      ...options,
    });
  }

  /**
   * Get Pending Invite
   */
  public static getPendingInvite(
    options?: Options<GetPendingInviteData, true>
  ) {
    return (options?.client ?? client).get<
      GetPendingInviteResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenant/invitation",
      ...options,
    });
  }

  /**
   * Accept Tenant Invitation
   */
  public static acceptTenantInvitation(
    options?: Options<AcceptTenantInvitationData, true>
  ) {
    return (options?.client ?? client).post<
      AcceptTenantInvitationResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenant/invitation/accept",
      ...options,
    });
  }

  /**
   * Reject Tenant Invitation
   */
  public static rejectTenantInvitation(
    options?: Options<RejectTenantInvitationData, true>
  ) {
    return (options?.client ?? client).post<
      RejectTenantInvitationResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenant/invitation/reject",
      ...options,
    });
  }

  /**
   * Get Tenant
   */
  public static getTenant(options?: Options<GetTenantData, true>) {
    return (options?.client ?? client).get<GetTenantResponses, unknown, true>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenant/me",
      ...options,
    });
  }

  /**
   * Update Tenant
   */
  public static updateTenant(options: Options<UpdateTenantData, true>) {
    return (options.client ?? client).patch<
      UpdateTenantResponses,
      UpdateTenantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenant/me",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Submit Questionnaire
   *
   * Submit onboarding questionnaire and update tenant metadata
   */
  public static submitQuestionnaire(
    options: Options<SubmitQuestionnaireData, true>
  ) {
    return (options.client ?? client).post<
      SubmitQuestionnaireResponses,
      SubmitQuestionnaireErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenant/questionnaire",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete User
   */
  public static deleteUser(options: Options<DeleteUserData, true>) {
    return (options.client ?? client).delete<
      DeleteUserResponses,
      DeleteUserErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenant/users/{user_id}",
      ...options,
    });
  }

  /**
   * Get User Details
   */
  public static getUserDetails(options: Options<GetUserDetailsData, true>) {
    return (options.client ?? client).get<
      GetUserDetailsResponses,
      GetUserDetailsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenant/users/{user_id}",
      ...options,
    });
  }

  /**
   * Edit User
   */
  public static editUser(options: Options<EditUserData, true>) {
    return (options.client ?? client).patch<
      EditUserResponses,
      EditUserErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenant/users/{user_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Users
   */
  public static listUsers(options?: Options<ListUsersData, true>) {
    return (options?.client ?? client).get<
      ListUsersResponses,
      ListUsersErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenant/users",
      ...options,
    });
  }

  /**
   * Add User
   */
  public static addUser(options: Options<AddUserData, true>) {
    return (options.client ?? client).post<
      AddUserResponses,
      AddUserErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenant/users",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Update User Metadata
   *
   * Update custom key-value metadata on a user record.
   */
  public static updateUserMetadata(
    options: Options<UpdateUserMetadataData, true>
  ) {
    return (options.client ?? client).patch<
      UpdateUserMetadataResponses,
      UpdateUserMetadataErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenant/users/{user_id}/metadata",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Resend Email
   */
  public static resendEmail(options: Options<ResendEmailData, true>) {
    return (options.client ?? client).post<
      ResendEmailResponses,
      ResendEmailErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenant/users/{user_id}/email-resend",
      ...options,
    });
  }

  /**
   * Send Verification Email
   */
  public static sendVerificationEmail(
    options?: Options<SendVerificationEmailData, true>
  ) {
    return (options?.client ?? client).post<
      SendVerificationEmailResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/users/auth0/verification-email",
      ...options,
    });
  }

  /**
   * Validate Recaptcha Token
   */
  public static validateRecaptchaToken(
    options: Options<ValidateRecaptchaTokenData, true>
  ) {
    return (options.client ?? client).post<
      ValidateRecaptchaTokenResponses,
      ValidateRecaptchaTokenErrors,
      true
    >({
      responseType: "json",
      url: "/users/recaptcha",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get All Groups
   */
  public static getAllGroups(options?: Options<GetAllGroupsData, true>) {
    return (options?.client ?? client).get<
      GetAllGroupsResponses,
      GetAllGroupsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups",
      ...options,
    });
  }

  /**
   * Create Group
   */
  public static createGroup(options: Options<CreateGroupData, true>) {
    return (options.client ?? client).post<
      CreateGroupResponses,
      CreateGroupErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get My Groups
   */
  public static getMyGroups(options?: Options<GetMyGroupsData, true>) {
    return (options?.client ?? client).get<
      GetMyGroupsResponses,
      GetMyGroupsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/me",
      ...options,
    });
  }

  /**
   * Delete Group
   */
  public static deleteGroup(options: Options<DeleteGroupData, true>) {
    return (options.client ?? client).delete<
      DeleteGroupResponses,
      DeleteGroupErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}",
      ...options,
    });
  }

  /**
   * Get Group
   */
  public static getGroup(options: Options<GetGroupData, true>) {
    return (options.client ?? client).get<
      GetGroupResponses,
      GetGroupErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}",
      ...options,
    });
  }

  /**
   * Edit Group
   */
  public static editGroup(options: Options<EditGroupData, true>) {
    return (options.client ?? client).patch<
      EditGroupResponses,
      EditGroupErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Group Users
   */
  public static listGroupUsers(options: Options<ListGroupUsersData, true>) {
    return (options.client ?? client).get<
      ListGroupUsersResponses,
      ListGroupUsersErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/users",
      ...options,
    });
  }

  /**
   * Add User To Group
   */
  public static addUserToGroup(options: Options<AddUserToGroupData, true>) {
    return (options.client ?? client).post<
      AddUserToGroupResponses,
      AddUserToGroupErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/users",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Remove User From Group
   */
  public static removeUserFromGroup(
    options: Options<RemoveUserFromGroupData, true>
  ) {
    return (options.client ?? client).delete<
      RemoveUserFromGroupResponses,
      RemoveUserFromGroupErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/users/{user_id}",
      ...options,
    });
  }

  /**
   * Edit User Role For Group
   */
  public static editUserRoleForGroup(
    options: Options<EditUserRoleForGroupData, true>
  ) {
    return (options.client ?? client).patch<
      EditUserRoleForGroupResponses,
      EditUserRoleForGroupErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/users/{user_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Api Keys
   */
  public static getApiKeys(options: Options<GetApiKeysData, true>) {
    return (options.client ?? client).get<
      GetApiKeysResponses,
      GetApiKeysErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/users/api-keys",
      ...options,
    });
  }

  /**
   * Create Api Key
   */
  public static createApiKey(options: Options<CreateApiKeyData, true>) {
    return (options.client ?? client).post<
      CreateApiKeyResponses,
      CreateApiKeyErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/users/api-keys",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Api Key
   */
  public static deleteApiKey(options: Options<DeleteApiKeyData, true>) {
    return (options.client ?? client).delete<
      DeleteApiKeyResponses,
      DeleteApiKeyErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/users/api-keys/{api_key_id}",
      ...options,
    });
  }

  /**
   * Get Api Key
   */
  public static getApiKey(options: Options<GetApiKeyData, true>) {
    return (options.client ?? client).get<
      GetApiKeyResponses,
      GetApiKeyErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/users/api-keys/{api_key_id}",
      ...options,
    });
  }

  /**
   * Download Audit
   */
  public static downloadAudit(options?: Options<DownloadAuditData, true>) {
    return (options?.client ?? client).post<
      DownloadAuditResponses,
      DownloadAuditErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/audit/download",
      ...options,
    });
  }

  /**
   * Get Authorization Context
   *
   * A page's first load in one request instead of eight: the same
   * values /users/me, /tenant/me, /groups/{id}, /groups/me, /me/permissions,
   * /tenant/feature-flags, /beta-features and /status/storage answer.
   */
  public static getAuthorizationContext(
    options?: Options<GetAuthorizationContextData, true>
  ) {
    return (options?.client ?? client).get<
      GetAuthorizationContextResponses,
      GetAuthorizationContextErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/authorization-context",
      ...options,
    });
  }
}

export class RolesService {
  /**
   * List Tenant Roles
   *
   * List all tenant roles: default templates (from code) OR all DB roles (migration compat).
   */
  public static listTenantRoles(options: Options<ListTenantRolesData, true>) {
    return (options.client ?? client).get<
      ListTenantRolesResponses,
      ListTenantRolesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}/roles",
      ...options,
    });
  }

  /**
   * Create Tenant Role
   *
   * Create a new tenant role.
   */
  public static createTenantRole(options: Options<CreateTenantRoleData, true>) {
    return (options.client ?? client).post<
      CreateTenantRoleResponses,
      CreateTenantRoleErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}/roles",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Tenant Roles As Platform Admin
   *
   * Platform-admin variant of list_tenant_roles: allows listing roles of any
   * tenant. Used by the auth-config UI when a noxus-internal admin configures
   * the autojoin tenant for a tenant they don't belong to.
   */
  public static listTenantRolesAsPlatformAdmin(
    options: Options<ListTenantRolesAsPlatformAdminData, true>
  ) {
    return (options.client ?? client).get<
      ListTenantRolesAsPlatformAdminResponses,
      ListTenantRolesAsPlatformAdminErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/platform/tenants/{tenant_id}/roles",
      ...options,
    });
  }

  /**
   * Delete Tenant Role
   *
   * Delete a tenant role.
   */
  public static deleteTenantRole(options: Options<DeleteTenantRoleData, true>) {
    return (options.client ?? client).delete<
      DeleteTenantRoleResponses,
      DeleteTenantRoleErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/roles/{role_id}",
      ...options,
    });
  }

  /**
   * Get Tenant Role
   *
   * Get a specific tenant role.
   */
  public static getTenantRole(options: Options<GetTenantRoleData, true>) {
    return (options.client ?? client).get<
      GetTenantRoleResponses,
      GetTenantRoleErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/roles/{role_id}",
      ...options,
    });
  }

  /**
   * Update Tenant Role
   *
   * Update a tenant role.
   */
  public static updateTenantRole(options: Options<UpdateTenantRoleData, true>) {
    return (options.client ?? client).put<
      UpdateTenantRoleResponses,
      UpdateTenantRoleErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/roles/{role_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Group Roles
   *
   * List all group roles: default templates (from code) OR all DB roles (migration compat).
   */
  public static listGroupRoles(options: Options<ListGroupRolesData, true>) {
    return (options.client ?? client).get<
      ListGroupRolesResponses,
      ListGroupRolesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/roles",
      ...options,
    });
  }

  /**
   * Create Group Role
   *
   * Create a new group role.
   */
  public static createGroupRole(options: Options<CreateGroupRoleData, true>) {
    return (options.client ?? client).post<
      CreateGroupRoleResponses,
      CreateGroupRoleErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/roles",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Tenant Groups As Platform Admin
   *
   * Platform-admin variant: list workspaces (groups) of any tenant. Used by
   * the auth-config UI when a noxus-internal admin configures the autojoin
   * tenant for a tenant they don't belong to.
   */
  public static listTenantGroupsAsPlatformAdmin(
    options: Options<ListTenantGroupsAsPlatformAdminData, true>
  ) {
    return (options.client ?? client).get<
      ListTenantGroupsAsPlatformAdminResponses,
      ListTenantGroupsAsPlatformAdminErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/platform/tenants/{tenant_id}/groups",
      ...options,
    });
  }

  /**
   * List Group Roles As Platform Admin
   *
   * Platform-admin variant of list_group_roles: looks up the group's tenant
   * from the DB rather than the calling user, so it works cross-tenant.
   */
  public static listGroupRolesAsPlatformAdmin(
    options: Options<ListGroupRolesAsPlatformAdminData, true>
  ) {
    return (options.client ?? client).get<
      ListGroupRolesAsPlatformAdminResponses,
      ListGroupRolesAsPlatformAdminErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/platform/groups/{group_id}/roles",
      ...options,
    });
  }

  /**
   * List All Workspace Roles
   *
   * List all workspace roles across all workspaces for a tenant.
   */
  public static listAllWorkspaceRoles(
    options: Options<ListAllWorkspaceRolesData, true>
  ) {
    return (options.client ?? client).get<
      ListAllWorkspaceRolesResponses,
      ListAllWorkspaceRolesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}/workspace-roles",
      ...options,
    });
  }

  /**
   * Delete Group Role
   *
   * Delete a group role.
   */
  public static deleteGroupRole(options: Options<DeleteGroupRoleData, true>) {
    return (options.client ?? client).delete<
      DeleteGroupRoleResponses,
      DeleteGroupRoleErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/roles/{role_id}",
      ...options,
    });
  }

  /**
   * Get Group Role
   *
   * Get a specific group role.
   */
  public static getGroupRole(options: Options<GetGroupRoleData, true>) {
    return (options.client ?? client).get<
      GetGroupRoleResponses,
      GetGroupRoleErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/roles/{role_id}",
      ...options,
    });
  }

  /**
   * Update Group Role
   *
   * Update a group role.
   */
  public static updateGroupRole(options: Options<UpdateGroupRoleData, true>) {
    return (options.client ?? client).put<
      UpdateGroupRoleResponses,
      UpdateGroupRoleErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/roles/{role_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Assign User Role
   *
   * Assign a role to a user.
   */
  public static assignUserRole(options: Options<AssignUserRoleData, true>) {
    return (options.client ?? client).put<
      AssignUserRoleResponses,
      AssignUserRoleErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/users/{user_id}/role",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Set User Permissions
   *
   * Set permissions for a user. In full roles mode:
   * - If user has a custom role (not system), updates that role
   * - If user has a system role, creates a new custom role and assigns it
   */
  public static setUserPermissions(
    options: Options<SetUserPermissionsData, true>
  ) {
    return (options.client ?? client).put<
      SetUserPermissionsResponses,
      SetUserPermissionsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/users/{user_id}/permissions",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get User Effective Permissions
   *
   * Get effective permissions for a user.
   */
  public static getUserEffectivePermissions(
    options: Options<GetUserEffectivePermissionsData, true>
  ) {
    return (options.client ?? client).get<
      GetUserEffectivePermissionsResponses,
      GetUserEffectivePermissionsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/users/{user_id}/effective-permissions",
      ...options,
    });
  }

  /**
   * Assign Group User Role
   *
   * Assign a role to a user in a group.
   */
  public static assignGroupUserRole(
    options: Options<AssignGroupUserRoleData, true>
  ) {
    return (options.client ?? client).put<
      AssignGroupUserRoleResponses,
      AssignGroupUserRoleErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/users/{user_id}/role",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Set Group User Permissions
   *
   * Set custom permission overrides for a user in a group.
   */
  public static setGroupUserPermissions(
    options: Options<SetGroupUserPermissionsData, true>
  ) {
    return (options.client ?? client).put<
      SetGroupUserPermissionsResponses,
      SetGroupUserPermissionsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/users/{user_id}/permissions",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class EntityGrantsService {
  /**
   * Delete Entity Grants
   *
   * Remove all grants for a principal on an entity.
   */
  public static deleteEntityGrants(
    options: Options<DeleteEntityGrantsData, true>
  ) {
    return (options.client ?? client).delete<
      DeleteEntityGrantsResponses,
      DeleteEntityGrantsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/entities/{entity_type}/{entity_id}/grants",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Entity Grants
   *
   * List all permission grants for an entity.
   */
  public static listEntityGrants(options: Options<ListEntityGrantsData, true>) {
    return (options.client ?? client).get<
      ListEntityGrantsResponses,
      ListEntityGrantsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/entities/{entity_type}/{entity_id}/grants",
      ...options,
    });
  }

  /**
   * Set Entity Grants
   *
   * Set permission grants for a principal on an entity (replaces existing).
   */
  public static setEntityGrants(options: Options<SetEntityGrantsData, true>) {
    return (options.client ?? client).post<
      SetEntityGrantsResponses,
      SetEntityGrantsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/entities/{entity_type}/{entity_id}/grants",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class PermissionsService {
  /**
   * Get My Permissions
   *
   * Get current user's effective permissions at tenant and optionally group level.
   */
  public static getMyPermissions(
    options?: Options<GetMyPermissionsData, true>
  ) {
    return (options?.client ?? client).get<
      GetMyPermissionsResponses,
      GetMyPermissionsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/me/permissions",
      ...options,
    });
  }

  /**
   * Get My Group Permissions
   *
   * Get current user's effective permissions in a specific group.
   */
  public static getMyGroupPermissions(
    options: Options<GetMyGroupPermissionsData, true>
  ) {
    return (options.client ?? client).get<
      GetMyGroupPermissionsResponses,
      GetMyGroupPermissionsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/me/permissions",
      ...options,
    });
  }
}

export class TemplatesService {
  /**
   * Get Templates
   */
  public static getTemplates(options?: Options<GetTemplatesData, true>) {
    return (options?.client ?? client).get<
      GetTemplatesResponses,
      GetTemplatesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/templates",
      ...options,
    });
  }

  /**
   * Get Template Categories
   */
  public static getTemplateCategories(
    options?: Options<GetTemplateCategoriesData, true>
  ) {
    return (options?.client ?? client).get<
      GetTemplateCategoriesResponses,
      GetTemplateCategoriesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/templates/categories",
      ...options,
    });
  }

  /**
   * Get Trending Templates
   */
  public static getTrendingTemplates(
    options?: Options<GetTrendingTemplatesData, true>
  ) {
    return (options?.client ?? client).get<
      GetTrendingTemplatesResponses,
      GetTrendingTemplatesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/templates/trending",
      ...options,
    });
  }

  /**
   * Delete Template
   */
  public static deleteTemplate(options: Options<DeleteTemplateData, true>) {
    return (options.client ?? client).delete<
      DeleteTemplateResponses,
      DeleteTemplateErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/templates/{template_id}",
      ...options,
    });
  }

  /**
   * Get Template
   */
  public static getTemplate(options: Options<GetTemplateData, true>) {
    return (options.client ?? client).get<
      GetTemplateResponses,
      GetTemplateErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/templates/{template_id}",
      ...options,
    });
  }

  /**
   * Get Template As Workflow
   */
  public static getTemplateAsWorkflow(
    options: Options<GetTemplateAsWorkflowData, true>
  ) {
    return (options.client ?? client).get<
      GetTemplateAsWorkflowResponses,
      GetTemplateAsWorkflowErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/templates/{template_id}/as-workflow",
      ...options,
    });
  }

  /**
   * Create Workflow From Template
   */
  public static createWorkflowFromTemplate(
    options: Options<CreateWorkflowFromTemplateData, true>
  ) {
    return (options.client ?? client).post<
      CreateWorkflowFromTemplateResponses,
      CreateWorkflowFromTemplateErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/templates/{template_id}/workflow",
      ...options,
    });
  }

  /**
   * Get Templates V2
   */
  public static getTemplatesV2(options: Options<GetTemplatesV2Data, true>) {
    return (options.client ?? client).get<
      GetTemplatesV2Responses,
      GetTemplatesV2Errors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/v2/templates",
      ...options,
    });
  }

  /**
   * Get Template V2
   */
  public static getTemplateV2(options: Options<GetTemplateV2Data, true>) {
    return (options.client ?? client).get<
      GetTemplateV2Responses,
      GetTemplateV2Errors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/v2/templates/{template_id}",
      ...options,
    });
  }

  /**
   * Get Template V2 Config
   */
  public static getTemplateV2Config(
    options: Options<GetTemplateV2ConfigData, true>
  ) {
    return (options.client ?? client).post<
      GetTemplateV2ConfigResponses,
      GetTemplateV2ConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/v2/templates/{template_id}/config",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Deploy Template V2
   */
  public static deployTemplateV2(options: Options<DeployTemplateV2Data, true>) {
    return (options.client ?? client).post<
      DeployTemplateV2Responses,
      DeployTemplateV2Errors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/v2/templates/{template_id}/deploy",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class TriggersService {
  /**
   * Get Triggers
   */
  public static getTriggers(options: Options<GetTriggersData, true>) {
    return (options.client ?? client).get<
      GetTriggersResponses,
      GetTriggersErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/triggers",
      ...options,
    });
  }

  /**
   * Create Trigger
   */
  public static createTrigger(options: Options<CreateTriggerData, true>) {
    return (options.client ?? client).post<
      CreateTriggerResponses,
      CreateTriggerErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/triggers",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Triggers Compatibility
   *
   * One pure comparison per trigger, no credentials or validation run: the
   * editor re-queries this after every save.
   */
  public static getTriggersCompatibility(
    options: Options<GetTriggersCompatibilityData, true>
  ) {
    return (options.client ?? client).get<
      GetTriggersCompatibilityResponses,
      GetTriggersCompatibilityErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/triggers/compatibility",
      ...options,
    });
  }

  /**
   * Delete Triggers
   */
  public static deleteTriggers(options: Options<DeleteTriggersData, true>) {
    return (options.client ?? client).delete<
      DeleteTriggersResponses,
      DeleteTriggersErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/triggers/{trigger_id}",
      ...options,
    });
  }

  /**
   * Get Trigger
   */
  public static getTrigger(options: Options<GetTriggerData, true>) {
    return (options.client ?? client).get<
      GetTriggerResponses,
      GetTriggerErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/triggers/{trigger_id}",
      ...options,
    });
  }

  /**
   * Update Triggers
   */
  public static updateTriggers(options: Options<UpdateTriggersData, true>) {
    return (options.client ?? client).patch<
      UpdateTriggersResponses,
      UpdateTriggersErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/triggers/{trigger_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Trigger Events
   */
  public static getTriggerEvents(options: Options<GetTriggerEventsData, true>) {
    return (options.client ?? client).get<
      GetTriggerEventsResponses,
      GetTriggerEventsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/triggers/{trigger_id}/events",
      ...options,
    });
  }

  /**
   * Replay Trigger Event
   */
  public static replayTriggerEvent(
    options: Options<ReplayTriggerEventData, true>
  ) {
    return (options.client ?? client).post<
      ReplayTriggerEventResponses,
      ReplayTriggerEventErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/triggers/{trigger_id}/events/{event_id}/replay",
      ...options,
    });
  }

  /**
   * Get Group Trigger Events
   *
   * Return all trigger events for a group, across all triggers.
   */
  public static getGroupTriggerEvents(
    options: Options<GetGroupTriggerEventsData, true>
  ) {
    return (options.client ?? client).get<
      GetGroupTriggerEventsResponses,
      GetGroupTriggerEventsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/triggers/events",
      ...options,
    });
  }
}

export class PlaybookService {
  /**
   * Convert Playwright Code
   */
  public static convertPlaywrightCode(
    options: Options<ConvertPlaywrightCodeData, true>
  ) {
    return (options.client ?? client).post<
      ConvertPlaywrightCodeResponses,
      ConvertPlaywrightCodeErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/playbook/convert-playwright",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Issue Record Ws Auth
   */
  public static issueRecordWsAuth(
    options: Options<IssueRecordWsAuthData, true>
  ) {
    return (options.client ?? client).post<
      IssueRecordWsAuthResponses,
      IssueRecordWsAuthErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/playbook/record/auth",
      ...options,
    });
  }

  /**
   * Schema-only endpoint for RecordingEvent type-gen
   *
   * Exists purely so openapi-ts generates the RecordingEvent TypeScript union from the backend schema.  Clients never call this endpoint; the response is a placeholder event.
   */
  public static eventsSchemaStub(
    options?: Options<EventsSchemaStubData, true>
  ) {
    return (options?.client ?? client).get<
      EventsSchemaStubResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/playbook/record/events/_schema",
      ...options,
    });
  }
}

export class PlaybookService2 {
  /**
   * Convert Playwright Code
   */
  public static convertPlaywrightCode(
    options: Options<ConvertPlaywrightCodeData, true>
  ) {
    return (options.client ?? client).post<
      ConvertPlaywrightCodeResponses,
      ConvertPlaywrightCodeErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/playbook/convert-playwright",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Issue Record Ws Auth
   */
  public static issueRecordWsAuth(
    options: Options<IssueRecordWsAuthData, true>
  ) {
    return (options.client ?? client).post<
      IssueRecordWsAuthResponses,
      IssueRecordWsAuthErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/playbook/record/auth",
      ...options,
    });
  }

  /**
   * Schema-only endpoint for RecordingEvent type-gen
   *
   * Exists purely so openapi-ts generates the RecordingEvent TypeScript union from the backend schema.  Clients never call this endpoint; the response is a placeholder event.
   */
  public static eventsSchemaStub(
    options?: Options<EventsSchemaStubData, true>
  ) {
    return (options?.client ?? client).get<
      EventsSchemaStubResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/playbook/record/events/_schema",
      ...options,
    });
  }
}

export class InternalService {
  /**
   * Get Changelog
   */
  public static getChangelog(options?: Options<GetChangelogData, true>) {
    return (options?.client ?? client).get<
      GetChangelogResponses,
      unknown,
      true
    >({
      responseType: "json",
      url: "/changelog",
      ...options,
    });
  }

  /**
   * Get Nodes
   */
  public static getNodes(options?: Options<GetNodesData, true>) {
    return (options?.client ?? client).get<
      GetNodesResponses,
      GetNodesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/nodes",
      ...options,
    });
  }

  /**
   * Get Node Display
   *
   * How each available node is labelled, without its configuration schema.
   */
  public static getNodeDisplay(options?: Options<GetNodeDisplayData, true>) {
    return (options?.client ?? client).get<
      GetNodeDisplayResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/nodes/display",
      ...options,
    });
  }

  /**
   * Get Data Message Schemas
   */
  public static getDataMessageSchemas(
    options?: Options<GetDataMessageSchemasData, true>
  ) {
    return (options?.client ?? client).get<
      GetDataMessageSchemasResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/data-message-schemas",
      ...options,
    });
  }

  /**
   * Get Tool Metadata Schemas
   */
  public static getToolMetadataSchemas(
    options?: Options<GetToolMetadataSchemasData, true>
  ) {
    return (options?.client ?? client).get<
      GetToolMetadataSchemasResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tool-metadata",
      ...options,
    });
  }

  /**
   * Get Tool Displays
   *
   * The built-in tools with display names + lucide icons — the vocabulary
   * the agent Display tab's hidden-tools picker offers.
   */
  public static getToolDisplays(options?: Options<GetToolDisplaysData, true>) {
    return (options?.client ?? client).get<
      GetToolDisplaysResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tool-displays",
      ...options,
    });
  }

  /**
   * Get Llms
   *
   * Endpoint used by the model picker to get model definitions.
   *
   * Returns:
   * List of model definitions filtered by the specified capabilities and provider.
   */
  public static getLlms(options: Options<GetLlmsData, true>) {
    return (options.client ?? client).get<
      GetLlmsResponses,
      GetLlmsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/llms",
      ...options,
    });
  }

  /**
   * Get Rerankers
   *
   * Endpoint used by the reranker picker in KB retrieval settings.
   */
  public static getRerankers(options: Options<GetRerankersData, true>) {
    return (options.client ?? client).get<
      GetRerankersResponses,
      GetRerankersErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/rerankers",
      ...options,
    });
  }

  /**
   * Get Decision Models
   */
  public static getDecisionModels(
    options: Options<GetDecisionModelsData, true>
  ) {
    return (options.client ?? client).get<
      GetDecisionModelsResponses,
      GetDecisionModelsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/decision-models",
      ...options,
    });
  }

  /**
   * Get Voice Models
   */
  public static getVoiceModels(options: Options<GetVoiceModelsData, true>) {
    return (options.client ?? client).get<
      GetVoiceModelsResponses,
      GetVoiceModelsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/voice-models",
      ...options,
    });
  }

  /**
   * Get Voice Model Voices
   */
  public static getVoiceModelVoices(
    options: Options<GetVoiceModelVoicesData, true>
  ) {
    return (options.client ?? client).get<
      GetVoiceModelVoicesResponses,
      GetVoiceModelVoicesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/voice-models/{slug}/voices",
      ...options,
    });
  }

  /**
   * Dictate Audio
   */
  public static dictateAudio(options: Options<DictateAudioData, true>) {
    return (options.client ?? client).post<
      DictateAudioResponses,
      DictateAudioErrors,
      true
    >({
      ...formDataBodySerializer,
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/voice/dictation",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });
  }

  /**
   * Get Embeddings
   *
   * Endpoint used by the model picker to get model definitions.
   *
   * Returns:
   * List of model definitions filtered by the specified capabilities and provider.
   */
  public static getEmbeddings(options: Options<GetEmbeddingsData, true>) {
    return (options.client ?? client).get<
      GetEmbeddingsResponses,
      GetEmbeddingsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/embeddings",
      ...options,
    });
  }

  /**
   * Get Image Models
   */
  public static getImageModels(options?: Options<GetImageModelsData, true>) {
    return (options?.client ?? client).get<
      GetImageModelsResponses,
      GetImageModelsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/models/image",
      ...options,
    });
  }

  /**
   * Get Types
   */
  public static getTypes(options?: Options<GetTypesData, true>) {
    return (options?.client ?? client).get<GetTypesResponses, unknown, true>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/types",
      ...options,
    });
  }

  /**
   * Get Logo
   */
  public static getLogo(options: Options<GetLogoData, true>) {
    return (options.client ?? client).get<
      GetLogoResponses,
      GetLogoErrors,
      true
    >({
      responseType: "json",
      url: "/logo/{url}",
      ...options,
    });
  }

  /**
   * Improve Prompt
   */
  public static improvePrompt(options: Options<ImprovePromptData, true>) {
    return (options.client ?? client).post<
      ImprovePromptResponses,
      ImprovePromptErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/prompts/improvement",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Evaluate Prompt Heuristics
   *
   * Evaluate prompt quality using heuristic scorers.
   *
   * Dispatches to Celery worker for LLM execution.
   * Run is created in the worker to avoid DB replication lag race conditions.
   */
  public static evaluatePromptHeuristics(
    options: Options<EvaluatePromptHeuristicsData, true>
  ) {
    return (options.client ?? client).post<
      EvaluatePromptHeuristicsResponses,
      EvaluatePromptHeuristicsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/prompts/heuristics",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Improve Prompt With Heuristics
   *
   * Improve or generate a prompt using heuristic-driven optimization.
   *
   * Dispatches to Celery worker for LLM execution.
   * Run is created in the worker to avoid DB replication lag race conditions.
   */
  public static improvePromptWithHeuristics(
    options: Options<ImprovePromptWithHeuristicsData, true>
  ) {
    return (options.client ?? client).post<
      ImprovePromptWithHeuristicsResponses,
      ImprovePromptWithHeuristicsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/prompts/heuristic-improvement",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Evaluate Prompt Heuristics Job
   *
   * Async variant of prompts/heuristics: returns a job handle immediately.
   */
  public static evaluatePromptHeuristicsJob(
    options: Options<EvaluatePromptHeuristicsJobData, true>
  ) {
    return (options.client ?? client).post<
      EvaluatePromptHeuristicsJobResponses,
      EvaluatePromptHeuristicsJobErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/prompts/heuristics/jobs",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Improve Prompt With Heuristics Job
   *
   * Async variant of prompts/heuristic-improvement: returns a job handle.
   */
  public static improvePromptWithHeuristicsJob(
    options: Options<ImprovePromptWithHeuristicsJobData, true>
  ) {
    return (options.client ?? client).post<
      ImprovePromptWithHeuristicsJobResponses,
      ImprovePromptWithHeuristicsJobErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/prompts/heuristic-improvement/jobs",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Prompt Job Status
   */
  public static getPromptJobStatus(
    options: Options<GetPromptJobStatusData, true>
  ) {
    return (options.client ?? client).get<
      GetPromptJobStatusResponses,
      GetPromptJobStatusErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/prompts/jobs/{job_id}",
      ...options,
    });
  }

  /**
   * Generate Code
   */
  public static generateCode(options: Options<GenerateCodeData, true>) {
    return (options.client ?? client).post<
      GenerateCodeResponses,
      GenerateCodeErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/code/generation",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Refine Text
   */
  public static refineText(options: Options<RefineTextData, true>) {
    return (options.client ?? client).post<
      RefineTextResponses,
      RefineTextErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/text/refine",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Translate Text
   */
  public static translateText(options: Options<TranslateTextData, true>) {
    return (options.client ?? client).post<
      TranslateTextResponses,
      TranslateTextErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/text/translate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Generate Table Sql
   */
  public static generateTableSql(options: Options<GenerateTableSqlData, true>) {
    return (options.client ?? client).post<
      GenerateTableSqlResponses,
      GenerateTableSqlErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tables/sql/generate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Interpret Table Filters
   */
  public static interpretTableFilters(
    options: Options<InterpretTableFiltersData, true>
  ) {
    return (options.client ?? client).post<
      InterpretTableFiltersResponses,
      InterpretTableFiltersErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tables/filters/interpret",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class McpConnectionsService {
  /**
   * Update Enabled Tools
   */
  public static updateEnabledTools(
    options: Options<UpdateEnabledToolsData, true>
  ) {
    return (options.client ?? client).patch<
      UpdateEnabledToolsResponses,
      UpdateEnabledToolsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/credentials/{credential_id}/mcp/tools",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Reprobe Tools
   */
  public static reprobeTools(options: Options<ReprobeToolsData, true>) {
    return (options.client ?? client).post<
      ReprobeToolsResponses,
      ReprobeToolsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/credentials/{credential_id}/mcp/reprobe",
      ...options,
    });
  }

  /**
   * Custom Mcp Start
   */
  public static customMcpStart(options: Options<CustomMcpStartData, true>) {
    return (options.client ?? client).post<
      CustomMcpStartResponses,
      CustomMcpStartErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/mcp/custom/start",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Custom Mcp Connect With Headers
   *
   * Connect a custom MCP server using user-supplied headers as auth.
   *
   * Skips OAuth discovery entirely — for servers that authenticate purely via
   * static headers (API key, proxy auth, …). The headers are sent on the
   * initial probe and persisted in the encrypted credential payload for use
   * on every subsequent MCP request.
   */
  public static customMcpConnectWithHeaders(
    options: Options<CustomMcpConnectWithHeadersData, true>
  ) {
    return (options.client ?? client).post<
      CustomMcpConnectWithHeadersResponses,
      CustomMcpConnectWithHeadersErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/mcp/custom/connect",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Jwks
   */
  public static getJwks(options?: Options<GetJwksData, true>) {
    return (options?.client ?? client).get<GetJwksResponses, unknown, true>({
      responseType: "json",
      url: "/.well-known/jwks.json",
      ...options,
    });
  }

  /**
   * Get Mcp Identity
   */
  public static getMcpIdentity(options: Options<GetMcpIdentityData, true>) {
    return (options.client ?? client).get<
      GetMcpIdentityResponses,
      GetMcpIdentityErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/credentials/{credential_id}/mcp/identity",
      ...options,
    });
  }
}

export class GitSyncService {
  /**
   * Get Config
   */
  public static getConfig(options: Options<GetConfigData, true>) {
    return (options.client ?? client).get<
      GetConfigResponses,
      GetConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/git-sync/config",
      ...options,
    });
  }

  /**
   * Put Config
   */
  public static putConfig(options: Options<PutConfigData, true>) {
    return (options.client ?? client).put<
      PutConfigResponses,
      PutConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/git-sync/config",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Test Connection
   */
  public static testConnection(options: Options<TestConnectionData, true>) {
    return (options.client ?? client).post<
      TestConnectionResponses,
      TestConnectionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/git-sync/test",
      ...options,
    });
  }

  /**
   * Get Health
   */
  public static getHealth(options: Options<GetHealthData, true>) {
    return (options.client ?? client).get<
      GetHealthResponses,
      GetHealthErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/git-sync/health",
      ...options,
    });
  }

  /**
   * Dry Run
   */
  public static dryRun(options: Options<DryRunData, true>) {
    return (options.client ?? client).post<DryRunResponses, DryRunErrors, true>(
      {
        responseType: "json",
        security: [{ scheme: "bearer", type: "http" }],
        url: "/groups/{group_id}/git-sync/dry-run",
        ...options,
      }
    );
  }

  /**
   * List Repos
   */
  public static listRepos(options: Options<ListReposData, true>) {
    return (options.client ?? client).get<
      ListReposResponses,
      ListReposErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/git-sync/repos",
      ...options,
    });
  }

  /**
   * Trigger Run
   */
  public static triggerRun(options: Options<TriggerRunData, true>) {
    return (options.client ?? client).post<
      TriggerRunResponses,
      TriggerRunErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/git-sync/run",
      ...options,
    });
  }

  /**
   * List Runs
   */
  public static listRuns(options: Options<ListRunsData, true>) {
    return (options.client ?? client).get<
      ListRunsResponses,
      ListRunsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/git-sync/runs",
      ...options,
    });
  }

  /**
   * Get Run
   */
  public static getRun(options: Options<GetRunData, true>) {
    return (options.client ?? client).get<GetRunResponses, GetRunErrors, true>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/git-sync/runs/{run_id}",
      ...options,
    });
  }

  /**
   * Get Artifact Status
   */
  public static getArtifactStatus(
    options: Options<GetArtifactStatusData, true>
  ) {
    return (options.client ?? client).get<
      GetArtifactStatusResponses,
      GetArtifactStatusErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/git-sync/artifacts/{kind}/{artifact_id}",
      ...options,
    });
  }

  /**
   * Push One Artifact
   */
  public static pushOneArtifact(options: Options<PushOneArtifactData, true>) {
    return (options.client ?? client).post<
      PushOneArtifactResponses,
      PushOneArtifactErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/git-sync/artifacts/{kind}/{artifact_id}/push",
      ...options,
    });
  }

  /**
   * Pull One Artifact
   */
  public static pullOneArtifact(options: Options<PullOneArtifactData, true>) {
    return (options.client ?? client).post<
      PullOneArtifactResponses,
      PullOneArtifactErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/git-sync/artifacts/{kind}/{artifact_id}/pull",
      ...options,
    });
  }
}

export class RunsService {
  /**
   * Verify Run Owner
   */
  public static verifyRunOwner(options: Options<VerifyRunOwnerData, true>) {
    return (options.client ?? client).get<
      VerifyRunOwnerResponses,
      VerifyRunOwnerErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/{run_id}/verify_user",
      ...options,
    });
  }

  /**
   * Get Workflow Runs
   */
  public static getWorkflowRuns(options: Options<GetWorkflowRunsData, true>) {
    return (options.client ?? client).get<
      GetWorkflowRunsResponses,
      GetWorkflowRunsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/runs",
      ...options,
    });
  }

  /**
   * V0 Create Run
   */
  public static v0CreateRun(options: Options<V0CreateRunData, true>) {
    return (options.client ?? client).post<
      V0CreateRunResponses,
      V0CreateRunErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/runs",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * V0 Get Run
   */
  public static v0GetRun(options: Options<V0GetRunData, true>) {
    return (options.client ?? client).get<
      V0GetRunResponses,
      V0GetRunErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/runs/{run_id}",
      ...options,
    });
  }

  /**
   * Get Run By Id
   */
  public static getRunById(options: Options<GetRunByIdData, true>) {
    return (options.client ?? client).get<
      GetRunByIdResponses,
      GetRunByIdErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/{run_id}",
      ...options,
    });
  }

  /**
   * Get Workflow For Run
   */
  public static getWorkflowForRun(
    options: Options<GetWorkflowForRunData, true>
  ) {
    return (options.client ?? client).get<
      GetWorkflowForRunResponses,
      GetWorkflowForRunErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/{run_id}/workflow",
      ...options,
    });
  }

  /**
   * Get Run State
   */
  public static getRunState(options: Options<GetRunStateData, true>) {
    return (options.client ?? client).get<
      GetRunStateResponses,
      GetRunStateErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/{run_id}/state",
      ...options,
    });
  }

  /**
   * Get Run Subflow Iteration
   *
   * Fetch one subflow iteration body that was spilled out of the window.
   *
   * ``path`` is the iteration's full execution path (``outer::it3::inner::it1``),
   * which is what makes an arbitrarily deep drill-in addressable: the same
   * subflow node recurs under every parent iteration, so a bare node id is not
   * unique within a run.
   */
  public static getRunSubflowIteration(
    options: Options<GetRunSubflowIterationData, true>
  ) {
    return (options.client ?? client).get<
      GetRunSubflowIterationResponses,
      GetRunSubflowIterationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/{run_id}/subflow-iterations/{path}",
      ...options,
    });
  }

  /**
   * Get Run Io
   */
  public static getRunIo(options: Options<GetRunIoData, true>) {
    return (options.client ?? client).get<
      GetRunIoResponses,
      GetRunIoErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/{run_id}/io/{node_id}/{it}",
      ...options,
    });
  }

  /**
   * Get Run Logs
   */
  public static getRunLogs(options: Options<GetRunLogsData, true>) {
    return (options.client ?? client).get<
      GetRunLogsResponses,
      GetRunLogsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/{run_id}/logs/{node_id}/{it}",
      ...options,
    });
  }

  /**
   * Get Run Execution Logs
   *
   * Get full execution logs (worker STDOUT/STDERR) for a run.
   *
   * Uses unified archive_get_run_logs which checks Redis first,
   * then falls back to S3/Minio cold storage.
   *
   * Access restricted to platform admins or on-prem deployments.
   */
  public static getRunExecutionLogs(
    options: Options<GetRunExecutionLogsData, true>
  ) {
    return (options.client ?? client).get<
      GetRunExecutionLogsResponses,
      GetRunExecutionLogsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/{run_id}/execution-logs",
      ...options,
    });
  }

  /**
   * Get Run Spans
   *
   * Get OTel span data for a run from Liquid Storage.
   *
   * Access restricted to platform admins or on-prem deployments.
   */
  public static getRunSpans(options: Options<GetRunSpansData, true>) {
    return (options.client ?? client).get<
      GetRunSpansResponses,
      GetRunSpansErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/{run_id}/spans",
      ...options,
    });
  }

  /**
   * Stop Run
   */
  public static stopRun(options: Options<StopRunData, true>) {
    return (options.client ?? client).post<
      StopRunResponses,
      StopRunErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/runs/{run_id}/stop",
      ...options,
    });
  }

  /**
   * Resume Run
   */
  public static resumeRun(options: Options<ResumeRunData, true>) {
    return (options.client ?? client).post<
      ResumeRunResponses,
      ResumeRunErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/runs/{run_id}/resume",
      ...options,
    });
  }

  /**
   * Get Runs
   */
  public static getRuns(options: Options<GetRunsData, true>) {
    return (options.client ?? client).get<
      GetRunsResponses,
      GetRunsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs",
      ...options,
    });
  }

  /**
   * Search Workflow Runs
   */
  public static searchWorkflowRuns(
    options: Options<SearchWorkflowRunsData, true>
  ) {
    return (options.client ?? client).post<
      SearchWorkflowRunsResponses,
      SearchWorkflowRunsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflow/{workflow_id}/runs/search",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Search Group Runs
   *
   * Search across all runs in a group without requiring a workflow_id.
   */
  public static searchGroupRuns(options: Options<SearchGroupRunsData, true>) {
    return (options.client ?? client).post<
      SearchGroupRunsResponses,
      SearchGroupRunsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/search",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Run Events
   */
  public static runEvents(options: Options<RunEventsData, true>) {
    return (options.client ?? client).get<
      RunEventsResponses,
      RunEventsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/{run_id}/events",
      ...options,
    });
  }

  /**
   * Bulk Rerun
   */
  public static bulkRerun(options: Options<BulkRerunData, true>) {
    return (options.client ?? client).post<
      BulkRerunResponses,
      BulkRerunErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/bulk/rerun",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Bulk Retry
   */
  public static bulkRetry(options: Options<BulkRetryData, true>) {
    return (options.client ?? client).post<
      BulkRetryResponses,
      BulkRetryErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/bulk/retry",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Bulk Stop
   */
  public static bulkStop(options: Options<BulkStopData, true>) {
    return (options.client ?? client).post<
      BulkStopResponses,
      BulkStopErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/bulk/stop",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Bulk Resume
   */
  public static bulkResume(options: Options<BulkResumeData, true>) {
    return (options.client ?? client).post<
      BulkResumeResponses,
      BulkResumeErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/bulk/resume",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Bulk Delete
   */
  public static bulkDelete(options: Options<BulkDeleteData, true>) {
    return (options.client ?? client).post<
      BulkDeleteResponses,
      BulkDeleteErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/bulk/delete",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Bulk Export Runs Csv
   */
  public static bulkExportRunsCsv(
    options: Options<BulkExportRunsCsvData, true>
  ) {
    return (options.client ?? client).post<
      BulkExportRunsCsvResponses,
      BulkExportRunsCsvErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/bulk/export",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Download Run Debug Export
   */
  public static downloadRunDebugExport(
    options: Options<DownloadRunDebugExportData, true>
  ) {
    return (options.client ?? client).get<
      DownloadRunDebugExportResponses,
      DownloadRunDebugExportErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/{run_id}/debug-export",
      ...options,
    });
  }
}

export class KnowledgeBasesV2Service {
  /**
   * Get Compatible Mime Types
   *
   * Get supported MIME types for a specific entity type
   */
  public static getCompatibleMimeTypes(
    options: Options<GetCompatibleMimeTypesData, true>
  ) {
    return (options.client ?? client).get<
      GetCompatibleMimeTypesResponses,
      GetCompatibleMimeTypesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-base/mime-types",
      ...options,
    });
  }

  /**
   * Get Knowledge Bases V2
   */
  public static getKnowledgeBasesV2(
    options: Options<GetKnowledgeBasesV2Data, true>
  ) {
    return (options.client ?? client).get<
      GetKnowledgeBasesV2Responses,
      GetKnowledgeBasesV2Errors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases",
      ...options,
    });
  }

  /**
   * Add Knowledge Base V2
   */
  public static addKnowledgeBaseV2(
    options: Options<AddKnowledgeBaseV2Data, true>
  ) {
    return (options.client ?? client).post<
      AddKnowledgeBaseV2Responses,
      AddKnowledgeBaseV2Errors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Knowledge Base V2
   */
  public static deleteKnowledgeBaseV2(
    options: Options<DeleteKnowledgeBaseV2Data, true>
  ) {
    return (options.client ?? client).delete<
      DeleteKnowledgeBaseV2Responses,
      DeleteKnowledgeBaseV2Errors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}",
      ...options,
    });
  }

  /**
   * Get Knowledge Base V2
   */
  public static getKnowledgeBaseV2(
    options: Options<GetKnowledgeBaseV2Data, true>
  ) {
    return (options.client ?? client).get<
      GetKnowledgeBaseV2Responses,
      GetKnowledgeBaseV2Errors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}",
      ...options,
    });
  }

  /**
   * Update Knowledge Base V2
   */
  public static updateKnowledgeBaseV2(
    options: Options<UpdateKnowledgeBaseV2Data, true>
  ) {
    return (options.client ?? client).patch<
      UpdateKnowledgeBaseV2Responses,
      UpdateKnowledgeBaseV2Errors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Repair Knowledge Base V2
   *
   * Run the user-triggered repair for a knowledge base.
   *
   * The FE shows this button when ``GET /kbs/{id}`` returns
   * ``health.status == "needs_repair"``. The CTA text (also on the
   * response) spells out exactly what the click will do — rebuild the
   * pgvector table, re-ingest documents, etc. — so there are no
   * surprises.
   *
   * Two-step orchestration:
   * 1. ``KBManagementService.repair`` runs the appropriate fix
   * (recreate pgvector table, rebuild kirby struct, etc.) and
   * flags every document with ``needs_reingestion=True`` when the
   * fix involved the pgvector column.
   * 2. For documents-affecting repairs, chain
   * ``retry_training(force_reingestion=True)`` right after — the
   * flag alone doesn't run anything; only the retry workflow
   * actually reprocesses documents. Skipping this step leaves the
   * KB with an empty vector store and documents stuck in
   * "Trained" state (exactly the bug this function is named after).
   *
   * Returns the post-repair ``KBHealth`` so the FE can flip the banner
   * back to ``ok``. The pgvector DDL runs synchronously (usually <1s);
   * document re-ingestion runs on the worker and streams in behind the
   * scenes, so the user sees documents flip to "Training" shortly after
   * the banner clears.
   */
  public static repairKnowledgeBaseV2(
    options: Options<RepairKnowledgeBaseV2Data, true>
  ) {
    return (options.client ?? client).post<
      RepairKnowledgeBaseV2Responses,
      RepairKnowledgeBaseV2Errors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/repair",
      ...options,
    });
  }

  /**
   * Export Knowledge Base V2
   */
  public static exportKnowledgeBaseV2(
    options: Options<ExportKnowledgeBaseV2Data, true>
  ) {
    return (options.client ?? client).post<
      ExportKnowledgeBaseV2Responses,
      ExportKnowledgeBaseV2Errors,
      true
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/export",
      ...options,
    });
  }

  /**
   * Search Knowledge Base
   */
  public static searchKnowledgeBase(
    options: Options<SearchKnowledgeBaseData, true>
  ) {
    return (options.client ?? client).post<
      SearchKnowledgeBaseResponses,
      SearchKnowledgeBaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/search",
      ...options,
    });
  }

  /**
   * Add Knowledge Base Document
   */
  public static addKnowledgeBaseDocument(
    options: Options<AddKnowledgeBaseDocumentData, true>
  ) {
    return (options.client ?? client).post<
      AddKnowledgeBaseDocumentResponses,
      AddKnowledgeBaseDocumentErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/document",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Knowledge Base Document
   */
  public static deleteKnowledgeBaseDocument(
    options: Options<DeleteKnowledgeBaseDocumentData, true>
  ) {
    return (options.client ?? client).delete<
      DeleteKnowledgeBaseDocumentResponses,
      DeleteKnowledgeBaseDocumentErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/document/{document_id}",
      ...options,
    });
  }

  /**
   * Get Knowledge Base Document
   */
  public static getKnowledgeBaseDocument(
    options: Options<GetKnowledgeBaseDocumentData, true>
  ) {
    return (options.client ?? client).get<
      GetKnowledgeBaseDocumentResponses,
      GetKnowledgeBaseDocumentErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/document/{document_id}",
      ...options,
    });
  }

  /**
   * Update Knowledge Base Document
   */
  public static updateKnowledgeBaseDocument(
    options: Options<UpdateKnowledgeBaseDocumentData, true>
  ) {
    return (options.client ?? client).patch<
      UpdateKnowledgeBaseDocumentResponses,
      UpdateKnowledgeBaseDocumentErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/document/{document_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Knowledge Base Documents
   */
  public static getKnowledgeBaseDocuments(
    options: Options<GetKnowledgeBaseDocumentsData, true>
  ) {
    return (options.client ?? client).get<
      GetKnowledgeBaseDocumentsResponses,
      GetKnowledgeBaseDocumentsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/documents/{status}",
      ...options,
    });
  }

  /**
   * Bulk Delete Knowledge Base Documents
   */
  public static bulkDeleteKnowledgeBaseDocuments(
    options: Options<BulkDeleteKnowledgeBaseDocumentsData, true>
  ) {
    return (options.client ?? client).post<
      BulkDeleteKnowledgeBaseDocumentsResponses,
      BulkDeleteKnowledgeBaseDocumentsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/documents/bulk/delete",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Dismiss Knowledge Base Document
   *
   * Mark a document as dismissed (typically used for error documents)
   */
  public static dismissKnowledgeBaseDocument(
    options: Options<DismissKnowledgeBaseDocumentData, true>
  ) {
    return (options.client ?? client).patch<
      DismissKnowledgeBaseDocumentResponses,
      DismissKnowledgeBaseDocumentErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/document/{document_id}/dismiss",
      ...options,
    });
  }

  /**
   * Upload Train Knowledge Base
   */
  public static uploadTrainKnowledgeBase(
    options: Options<UploadTrainKnowledgeBaseData, true>
  ) {
    return (options.client ?? client).post<
      UploadTrainKnowledgeBaseResponses,
      UploadTrainKnowledgeBaseErrors,
      true
    >({
      ...formDataBodySerializer,
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/upload_train",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });
  }

  /**
   * Fetch Knowledge Base Custom Types
   */
  public static fetchKnowledgeBaseCustomTypes(
    options?: Options<FetchKnowledgeBaseCustomTypesData, true>
  ) {
    return (options?.client ?? client).get<
      FetchKnowledgeBaseCustomTypesResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/knowledge-bases/types",
      ...options,
    });
  }

  /**
   * Generic Train Knowledge Base
   *
   * Ingest files into a KB, optionally enabling sync in the same call.
   *
   * Pass ``body.sync`` to also create a sync trigger pinned to the same
   * watch list. The trigger holds ``watched_items`` as the single
   * source of truth; the engine self-heals each item's ``kb_doc_id`` on
   * its first poll by matching source ids against
   * ``KnowledgeBaseDocument.m_source_external_id`` (which the
   * materialisation trigger populates from ``source_metadata.extra.id``
   * written by ``download_file``). No per-doc stamping needed.
   */
  public static genericTrainKnowledgeBase(
    options: Options<GenericTrainKnowledgeBaseData, true>
  ) {
    return (options.client ?? client).post<
      GenericTrainKnowledgeBaseResponses,
      GenericTrainKnowledgeBaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/generic_train",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Retry Train Knowledge Base
   */
  public static retryTrainKnowledgeBase(
    options: Options<RetryTrainKnowledgeBaseData, true>
  ) {
    return (options.client ?? client).post<
      RetryTrainKnowledgeBaseResponses,
      RetryTrainKnowledgeBaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/retry_all",
      ...options,
    });
  }

  /**
   * Generate Knowledge Base Summary
   */
  public static generateKnowledgeBaseSummary(
    options: Options<GenerateKnowledgeBaseSummaryData, true>
  ) {
    return (options.client ?? client).post<
      GenerateKnowledgeBaseSummaryResponses,
      GenerateKnowledgeBaseSummaryErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/generate-summary",
      ...options,
    });
  }

  /**
   * Retry Document Ingestion
   */
  public static retryDocumentIngestion(
    options: Options<RetryDocumentIngestionData, true>
  ) {
    return (options.client ?? client).post<
      RetryDocumentIngestionResponses,
      RetryDocumentIngestionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/document/{document_id}/retry",
      ...options,
    });
  }

  /**
   * Get Knowledge Base Running Jobs
   */
  public static getKnowledgeBaseRunningJobs(
    options: Options<GetKnowledgeBaseRunningJobsData, true>
  ) {
    return (options.client ?? client).get<
      GetKnowledgeBaseRunningJobsResponses,
      GetKnowledgeBaseRunningJobsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/runs",
      ...options,
    });
  }

  /**
   * Get Knowledge Base Ingestion Jobs
   *
   * Get all non-dismissed ingestion jobs for a knowledge base
   */
  public static getKnowledgeBaseIngestionJobs(
    options: Options<GetKnowledgeBaseIngestionJobsData, true>
  ) {
    return (options.client ?? client).get<
      GetKnowledgeBaseIngestionJobsResponses,
      GetKnowledgeBaseIngestionJobsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/ingestion-jobs",
      ...options,
    });
  }

  /**
   * Get Knowledge Base Ingestion Runs
   *
   * Get all ingestion runs for a knowledge base, paginated.
   *
   * Surfaces two run flavours:
   * - System-spawned ingestion runs (initial training, retry, sync) tagged
   * ``source="ingestion"`` with ``meta.kb_id``.
   * - User-built workflow runs that wrote KB docs through a
   * ``UnifiedKBIngestionNode`` — found through the documents they own
   * (``kb_docstore.run_id``) or through the knowledge bases they were
   * stamped with (``meta.kb_ids``), so a run whose files were all
   * unchanged stays listed even though it owns no document.
   */
  public static getKnowledgeBaseIngestionRuns(
    options: Options<GetKnowledgeBaseIngestionRunsData, true>
  ) {
    return (options.client ?? client).get<
      GetKnowledgeBaseIngestionRunsResponses,
      GetKnowledgeBaseIngestionRunsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/ingestion-runs",
      ...options,
    });
  }

  /**
   * Dismiss Knowledge Base Run
   *
   * Dismiss a run and all its associated documents
   */
  public static dismissKnowledgeBaseRun(
    options: Options<DismissKnowledgeBaseRunData, true>
  ) {
    return (options.client ?? client).patch<
      DismissKnowledgeBaseRunResponses,
      DismissKnowledgeBaseRunErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/runs/{run_id}/dismiss",
      ...options,
    });
  }

  /**
   * List Kb Syncs
   */
  public static listKbSyncs(options: Options<ListKbSyncsData, true>) {
    return (options.client ?? client).get<
      ListKbSyncsResponses,
      ListKbSyncsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/sync",
      ...options,
    });
  }

  /**
   * Enable Kb Sync
   *
   * Create a sync trigger pinned to the given watch list — *no ingestion*.
   *
   * Use this when the user already has docs in the KB (ingested earlier
   * without sync) and now wants to start syncing them. The watch list is
   * persisted on the trigger; the engine self-heals each item's
   * ``kb_doc_id`` on the first poll by matching source ids against
   * existing docs' ``m_source_external_id``. For the "create-sync-AND-
   * ingest-fresh" flow, callers should hit ``POST /generic_train`` with
   * a ``sync`` body block — that runs ingestion + trigger creation in
   * the same call.
   */
  public static enableKbSync(options: Options<EnableKbSyncData, true>) {
    return (options.client ?? client).post<
      EnableKbSyncResponses,
      EnableKbSyncErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/sync",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Disable Kb Sync
   */
  public static disableKbSync(options: Options<DisableKbSyncData, true>) {
    return (options.client ?? client).delete<
      DisableKbSyncResponses,
      DisableKbSyncErrors,
      true
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/sync/{trigger_id}",
      ...options,
    });
  }

  /**
   * Update Kb Sync
   */
  public static updateKbSync(options: Options<UpdateKbSyncData, true>) {
    return (options.client ?? client).patch<
      UpdateKbSyncResponses,
      UpdateKbSyncErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/sync/{trigger_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Unsync Kb Document
   *
   * Remove a watched item (by kb_doc_id) from a sync trigger.
   *
   * The doc itself stays in the KB — only the entry in
   * ``trigger.definition.watched_items`` is dropped. The next poll
   * won't process this item. The trigger row is kept even when it
   * empties (a watched source can legitimately go empty and refill).
   *
   * If the document_id matches a child of a watched folder rather than
   * a watched item itself, we return 400 — the user should remove the
   * parent folder from the watch list, not its descendants.
   */
  public static unsyncKbDocument(options: Options<UnsyncKbDocumentData, true>) {
    return (options.client ?? client).post<
      UnsyncKbDocumentResponses,
      UnsyncKbDocumentErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/sync/{trigger_id}/unsync/{document_id}",
      ...options,
    });
  }

  /**
   * Force Kb Sync
   */
  public static forceKbSync(options: Options<ForceKbSyncData, true>) {
    return (options.client ?? client).post<
      ForceKbSyncResponses,
      ForceKbSyncErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/sync/{trigger_id}/trigger",
      ...options,
    });
  }

  /**
   * Get Tmp Knowledge Base
   */
  public static getTmpKnowledgeBase(
    options: Options<GetTmpKnowledgeBaseData, true>
  ) {
    return (options.client ?? client).get<
      GetTmpKnowledgeBaseResponses,
      GetTmpKnowledgeBaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{workflow_id}/{node_id}",
      ...options,
    });
  }

  /**
   * Stream Kb Health
   *
   * Stream the health pipeline, one SSE frame per check as it finishes.
   */
  public static streamKbHealth(options: Options<StreamKbHealthData, true>) {
    return (options.client ?? client).get<
      StreamKbHealthResponses,
      StreamKbHealthErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/health/stream",
      ...options,
    });
  }

  /**
   * Run Kb Health
   *
   * The same loop as the stream, collected into one response.
   */
  public static runKbHealth(options: Options<RunKbHealthData, true>) {
    return (options.client ?? client).post<
      RunKbHealthResponses,
      RunKbHealthErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/health/run",
      ...options,
    });
  }

  /**
   * Kb Health Manifest
   *
   * Check catalogue + repair copy. KB-independent; gated only so it
   * isn't unauthenticated.
   */
  public static kbHealthManifest(options: Options<KbHealthManifestData, true>) {
    return (options.client ?? client).get<
      KbHealthManifestResponses,
      KbHealthManifestErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-base/health-manifest",
      ...options,
    });
  }

  /**
   * Repair Kb Health
   *
   * Queue a per-check repair. Resolves the KB group-scoped first, so a
   * foreign kb_id fails here rather than inside the worker.
   */
  public static repairKbHealth(options: Options<RepairKbHealthData, true>) {
    return (options.client ?? client).post<
      RepairKbHealthResponses,
      RepairKbHealthErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/health/repair/{check_id}",
      ...options,
    });
  }

  /**
   * Watch Kb Health Repair
   *
   * Follow a queued repair and emit the re-checked step when it lands.
   */
  public static watchKbHealthRepair(
    options: Options<WatchKbHealthRepairData, true>
  ) {
    return (options.client ?? client).get<
      WatchKbHealthRepairResponses,
      WatchKbHealthRepairErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/knowledge-bases/{knowledge_base_id}/health/repair/{check_id}/watch",
      ...options,
    });
  }
}

export class TablesService {
  /**
   * List Tables
   */
  public static listTables(options: Options<ListTablesData, true>) {
    return (options.client ?? client).get<
      ListTablesResponses,
      ListTablesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables",
      ...options,
    });
  }

  /**
   * Create Table
   */
  public static createTable(options: Options<CreateTableData, true>) {
    return (options.client ?? client).post<
      CreateTableResponses,
      CreateTableErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Import Csv
   *
   * Create a table from an uploaded CSV and bulk-load its rows in one atomic
   * request (Postgres COPY). ``spec`` is a JSON ``ImportCsvSpec`` naming the
   * table, id type, and which CSV columns to import (each with an identifier and
   * type). Row values are parsed from the raw CSV text server-side.
   */
  public static importCsv(options: Options<ImportCsvData, true>) {
    return (options.client ?? client).post<
      ImportCsvResponses,
      ImportCsvErrors,
      true
    >({
      ...formDataBodySerializer,
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/import",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });
  }

  /**
   * Import Csv Into Table
   */
  public static importCsvIntoTable(
    options: Options<ImportCsvIntoTableData, true>
  ) {
    return (options.client ?? client).post<
      ImportCsvIntoTableResponses,
      ImportCsvIntoTableErrors,
      true
    >({
      ...formDataBodySerializer,
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/import",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });
  }

  /**
   * Import Csv Rows
   */
  public static importCsvRows(options: Options<ImportCsvRowsData, true>) {
    return (options.client ?? client).post<
      ImportCsvRowsResponses,
      ImportCsvRowsErrors,
      true
    >({
      ...formDataBodySerializer,
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/import-rows",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });
  }

  /**
   * Import Preview
   *
   * Parse the first rows of an upload server-side — the browser can't read
   * .xlsx, so the import dialog previews through here.
   */
  public static importPreview(options: Options<ImportPreviewData, true>) {
    return (options.client ?? client).post<
      ImportPreviewResponses,
      ImportPreviewErrors,
      true
    >({
      ...formDataBodySerializer,
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/import/preview",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });
  }

  /**
   * Import Plan
   *
   * What importing an attached CSV or TSV file would create, for the
   * approval card of Genie's import: the columns with their types and how many
   * rows, read by the import's own planner.
   */
  public static importPlan(options: Options<ImportPlanData, true>) {
    return (options.client ?? client).post<
      ImportPlanResponses,
      ImportPlanErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/import/plan",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Table Stats
   */
  public static getTableStats(options: Options<GetTableStatsData, true>) {
    return (options.client ?? client).get<
      GetTableStatsResponses,
      GetTableStatsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/stats",
      ...options,
    });
  }

  /**
   * Delete Table
   */
  public static deleteTable(options: Options<DeleteTableData, true>) {
    return (options.client ?? client).delete<
      DeleteTableResponses,
      DeleteTableErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}",
      ...options,
    });
  }

  /**
   * Get Table
   */
  public static getTable(options: Options<GetTableData, true>) {
    return (options.client ?? client).get<
      GetTableResponses,
      GetTableErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}",
      ...options,
    });
  }

  /**
   * Update Table
   */
  public static updateTable(options: Options<UpdateTableData, true>) {
    return (options.client ?? client).patch<
      UpdateTableResponses,
      UpdateTableErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Add Column
   */
  public static addColumn(options: Options<AddColumnData, true>) {
    return (options.client ?? client).post<
      AddColumnResponses,
      AddColumnErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/columns",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Rename Column
   */
  public static renameColumn(options: Options<RenameColumnData, true>) {
    return (options.client ?? client).patch<
      RenameColumnResponses,
      RenameColumnErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/columns/{name}/rename",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Change Column Type
   */
  public static changeColumnType(options: Options<ChangeColumnTypeData, true>) {
    return (options.client ?? client).patch<
      ChangeColumnTypeResponses,
      ChangeColumnTypeErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/columns/{name}/type",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Drop Column
   */
  public static dropColumn(options: Options<DropColumnData, true>) {
    return (options.client ?? client).delete<
      DropColumnResponses,
      DropColumnErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/columns/{name}",
      ...options,
    });
  }

  /**
   * Update Column Label
   */
  public static updateColumnLabel(
    options: Options<UpdateColumnLabelData, true>
  ) {
    return (options.client ?? client).patch<
      UpdateColumnLabelResponses,
      UpdateColumnLabelErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/columns/{name}/label",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Reorder Columns
   */
  public static reorderColumns(options: Options<ReorderColumnsData, true>) {
    return (options.client ?? client).patch<
      ReorderColumnsResponses,
      ReorderColumnsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/columns/reorder",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Clear Rows
   */
  public static clearRows(options: Options<ClearRowsData, true>) {
    return (options.client ?? client).delete<
      ClearRowsResponses,
      ClearRowsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/rows",
      ...options,
    });
  }

  /**
   * List Rows
   */
  public static listRows(options: Options<ListRowsData, true>) {
    return (options.client ?? client).get<
      ListRowsResponses,
      ListRowsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/rows",
      ...options,
    });
  }

  /**
   * Insert Row
   */
  public static insertRow(options: Options<InsertRowData, true>) {
    return (options.client ?? client).post<
      InsertRowResponses,
      InsertRowErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/rows",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Export Table Csv
   */
  public static exportTableCsv(options: Options<ExportTableCsvData, true>) {
    return (options.client ?? client).get<
      ExportTableCsvResponses,
      ExportTableCsvErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/export",
      ...options,
    });
  }

  /**
   * Delete Row
   */
  public static deleteRow(options: Options<DeleteRowData, true>) {
    return (options.client ?? client).delete<
      DeleteRowResponses,
      DeleteRowErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/rows/{row_id}",
      ...options,
    });
  }

  /**
   * Update Row
   */
  public static updateRow(options: Options<UpdateRowData, true>) {
    return (options.client ?? client).patch<
      UpdateRowResponses,
      UpdateRowErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/rows/{row_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Bulk Delete Rows
   */
  public static bulkDeleteRows(options: Options<BulkDeleteRowsData, true>) {
    return (options.client ?? client).post<
      BulkDeleteRowsResponses,
      BulkDeleteRowsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/rows/bulk-delete",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Bulk Duplicate Rows
   */
  public static bulkDuplicateRows(
    options: Options<BulkDuplicateRowsData, true>
  ) {
    return (options.client ?? client).post<
      BulkDuplicateRowsResponses,
      BulkDuplicateRowsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/{table_id}/rows/bulk-duplicate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Query Tables
   */
  public static queryTables(options: Options<QueryTablesData, true>) {
    return (options.client ?? client).post<
      QueryTablesResponses,
      QueryTablesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/query",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Summarize Table Write
   *
   * The table a SQL INSERT or UPDATE writes to and how many rows an UPDATE
   * changes, for an approval card. Null for any other statement.
   */
  public static summarizeTableWrite(
    options: Options<SummarizeTableWriteData, true>
  ) {
    return (options.client ?? client).post<
      SummarizeTableWriteResponses,
      SummarizeTableWriteErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/write-summary",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Export Query Csv
   *
   * Stream the FULL result of an untrusted SELECT as CSV, fetched page by
   * page so it is not subject to the interactive query row cap.
   */
  public static exportQueryCsv(options: Options<ExportQueryCsvData, true>) {
    return (options.client ?? client).post<
      ExportQueryCsvResponses,
      ExportQueryCsvErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/groups/{group_id}/tables/query/export",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class SupportLogsService {
  /**
   * Send Run Logs To Support
   */
  public static sendRunLogsToSupport(
    options: Options<SendRunLogsToSupportData, true>
  ) {
    return (options.client ?? client).post<
      SendRunLogsToSupportResponses,
      SendRunLogsToSupportErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/runs/{run_id}/send-logs-to-support",
      ...options,
    });
  }
}

export class IntegrationsService {
  /**
   * Get Available Triggers
   */
  public static getAvailableTriggers(
    options: Options<GetAvailableTriggersData, true>
  ) {
    return (options.client ?? client).get<
      GetAvailableTriggersResponses,
      GetAvailableTriggersErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/triggers",
      ...options,
    });
  }

  /**
   * Get Trigger Config
   */
  public static getTriggerConfig(options: Options<GetTriggerConfigData, true>) {
    return (options.client ?? client).post<
      GetTriggerConfigResponses,
      GetTriggerConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/triggers/{trigger_id}/config",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Base Integration Config
   */
  public static getBaseIntegrationConfig(
    options: Options<GetBaseIntegrationConfigData, true>
  ) {
    return (options.client ?? client).post<
      GetBaseIntegrationConfigResponses,
      GetBaseIntegrationConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/base/{integration_type}/config",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Setup Integration
   */
  public static setupIntegration(options: Options<SetupIntegrationData, true>) {
    return (options.client ?? client).post<
      SetupIntegrationResponses,
      SetupIntegrationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/base/{integration_name}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Start Device Auth
   *
   * Begin a device-code sign-in for a plugin-backed integration.
   *
   * The plugin's warm sandbox worker runs the provider's device flow and
   * returns the one-time code + verification link to show the user; the
   * session then advances via the poll route below.
   */
  public static startDeviceAuth(options: Options<StartDeviceAuthData, true>) {
    return (options.client ?? client).post<
      StartDeviceAuthResponses,
      StartDeviceAuthErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/base/{integration_type}/device-auth",
      ...options,
    });
  }

  /**
   * Poll Device Auth
   */
  public static pollDeviceAuth(options: Options<PollDeviceAuthData, true>) {
    return (options.client ?? client).post<
      PollDeviceAuthResponses,
      PollDeviceAuthErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/base/{integration_type}/device-auth/{session_id}",
      ...options,
    });
  }

  /**
   * Disconnect Integration
   */
  public static disconnectIntegration(
    options: Options<DisconnectIntegrationData, true>
  ) {
    return (options.client ?? client).delete<
      DisconnectIntegrationResponses,
      DisconnectIntegrationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/base/{integration_name}/disconnect",
      ...options,
    });
  }

  /**
   * Delete Credential Endpoint
   *
   * Delete a single credential by its ID.
   */
  public static deleteCredentialEndpoint(
    options: Options<DeleteCredentialEndpointData, true>
  ) {
    return (options.client ?? client).delete<
      DeleteCredentialEndpointResponses,
      DeleteCredentialEndpointErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/credentials/{credential_id}",
      ...options,
    });
  }

  /**
   * Get Credential Payload
   *
   * Return the decrypted payload of an existing SecretAuth credential for pre-filling edit forms.
   *
   * Only SecretAuth credentials (auth_method='secret_auth') may be read back this way.
   * OAuth tokens (access_token / refresh_token) are never returned — callers must
   * re-authenticate via the OAuth flow instead.
   */
  public static getCredentialPayload(
    options: Options<GetCredentialPayloadData, true>
  ) {
    return (options.client ?? client).get<
      GetCredentialPayloadResponses,
      GetCredentialPayloadErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/credentials/{credential_id}",
      ...options,
    });
  }

  /**
   * Update Credential
   *
   * Update the payload of an existing credential (SecretAuth edit).
   */
  public static updateCredential(options: Options<UpdateCredentialData, true>) {
    return (options.client ?? client).put<
      UpdateCredentialResponses,
      UpdateCredentialErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/credentials/{credential_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Rename Credential
   *
   * Update only the display_name (label) of a credential.
   */
  public static renameCredential(options: Options<RenameCredentialData, true>) {
    return (options.client ?? client).patch<
      RenameCredentialResponses,
      RenameCredentialErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/credentials/{credential_id}/label",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Force Refresh Credential
   *
   * Force-refresh an OAuth credential's access token using the stored refresh token.
   */
  public static forceRefreshCredential(
    options: Options<ForceRefreshCredentialData, true>
  ) {
    return (options.client ?? client).post<
      ForceRefreshCredentialResponses,
      ForceRefreshCredentialErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/credentials/{credential_id}/refresh",
      ...options,
    });
  }

  /**
   * Update Credential Settings
   *
   * Update per-credential entity settings (disabled nodes/triggers).
   */
  public static updateCredentialSettings(
    options: Options<UpdateCredentialSettingsData, true>
  ) {
    return (options.client ?? client).put<
      UpdateCredentialSettingsResponses,
      UpdateCredentialSettingsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/credentials/{credential_id}/settings",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Oauth Start
   *
   * Initiate an OAuth flow. Returns the provider's authorize URL.
   * State is stored in Redis (TTL 10 min) for CSRF protection.
   */
  public static oauthStart(options: Options<OauthStartData, true>) {
    return (options.client ?? client).post<
      OauthStartResponses,
      OauthStartErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/oauth/start",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Oauth Callback
   *
   * OAuth callback. Validates state, exchanges code, saves credential.
   * Redirects user back to the app's redirect_uri.
   */
  public static oauthCallback(options?: Options<OauthCallbackData, true>) {
    return (options?.client ?? client).get<
      OauthCallbackResponses,
      unknown,
      true
    >({
      responseType: "json",
      url: "/integrations/oauth/callback",
      ...options,
    });
  }

  /**
   * List Connections
   */
  public static listConnections(options?: Options<ListConnectionsData, true>) {
    return (options?.client ?? client).get<
      ListConnectionsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/server",
      ...options,
    });
  }

  /**
   * Connection Config
   */
  public static connectionConfig(options: Options<ConnectionConfigData, true>) {
    return (options.client ?? client).post<
      ConnectionConfigResponses,
      ConnectionConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/server/{integration_type}/config",
      ...options,
    });
  }

  /**
   * Create Connection
   */
  public static createConnection(options: Options<CreateConnectionData, true>) {
    return (options.client ?? client).post<
      CreateConnectionResponses,
      CreateConnectionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/server/{integration_type}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Connection Senders
   */
  public static connectionSenders(
    options: Options<ConnectionSendersData, true>
  ) {
    return (options.client ?? client).get<
      ConnectionSendersResponses,
      ConnectionSendersErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/server/credentials/{credential_id}/senders",
      ...options,
    });
  }

  /**
   * Delete Connection
   */
  public static deleteConnection(options: Options<DeleteConnectionData, true>) {
    return (options.client ?? client).delete<
      DeleteConnectionResponses,
      DeleteConnectionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/server/credentials/{credential_id}",
      ...options,
    });
  }

  /**
   * Get Connection
   */
  public static getConnection(options: Options<GetConnectionData, true>) {
    return (options.client ?? client).get<
      GetConnectionResponses,
      GetConnectionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/server/credentials/{credential_id}",
      ...options,
    });
  }

  /**
   * Update Connection
   */
  public static updateConnection(options: Options<UpdateConnectionData, true>) {
    return (options.client ?? client).put<
      UpdateConnectionResponses,
      UpdateConnectionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/server/credentials/{credential_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Set Email Delivery
   */
  public static setEmailDelivery(options: Options<SetEmailDeliveryData, true>) {
    return (options.client ?? client).put<
      SetEmailDeliveryResponses,
      SetEmailDeliveryErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/server/email-delivery",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Set Connection Enabled
   */
  public static setConnectionEnabled(
    options: Options<SetConnectionEnabledData, true>
  ) {
    return (options.client ?? client).patch<
      SetConnectionEnabledResponses,
      SetConnectionEnabledErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/server/credentials/{credential_id}/enabled",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Integrations Admin
   *
   * List all registered integrations with their provider config status.
   */
  public static listIntegrationsAdmin(
    options?: Options<ListIntegrationsAdminData, true>
  ) {
    return (options?.client ?? client).get<
      ListIntegrationsAdminResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations",
      ...options,
    });
  }

  /**
   * Get Provider Config Schema
   *
   * Return the form schema for configuring a provider (from admin_config_class).
   */
  public static getProviderConfigSchema(
    options: Options<GetProviderConfigSchemaData, true>
  ) {
    return (options.client ?? client).get<
      GetProviderConfigSchemaResponses,
      GetProviderConfigSchemaErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/{integration_type}/providers/{provider_key}/config",
      ...options,
    });
  }

  /**
   * Delete Provider Config Endpoint
   *
   * Remove a provider's admin configuration, disabling OAuth for all groups.
   */
  public static deleteProviderConfigEndpoint(
    options: Options<DeleteProviderConfigEndpointData, true>
  ) {
    return (options.client ?? client).delete<
      DeleteProviderConfigEndpointResponses,
      DeleteProviderConfigEndpointErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/{integration_type}/providers/{provider_key}",
      ...options,
    });
  }

  /**
   * Save Provider Config Endpoint
   *
   * Save (or update) admin configuration for a provider.
   */
  public static saveProviderConfigEndpoint(
    options: Options<SaveProviderConfigEndpointData, true>
  ) {
    return (options.client ?? client).put<
      SaveProviderConfigEndpointResponses,
      SaveProviderConfigEndpointErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/{integration_type}/providers/{provider_key}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Integration Scopes Endpoint
   *
   * Return active scope configuration for an integration.
   */
  public static getIntegrationScopesEndpoint(
    options: Options<GetIntegrationScopesEndpointData, true>
  ) {
    return (options.client ?? client).get<
      GetIntegrationScopesEndpointResponses,
      GetIntegrationScopesEndpointErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/{integration_type}/scopes",
      ...options,
    });
  }

  /**
   * Set Integration Scopes Endpoint
   *
   * Set which scopes are active for an integration. Pass null to remove all restrictions.
   */
  public static setIntegrationScopesEndpoint(
    options: Options<SetIntegrationScopesEndpointData, true>
  ) {
    return (options.client ?? client).put<
      SetIntegrationScopesEndpointResponses,
      SetIntegrationScopesEndpointErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/{integration_type}/scopes",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Integration Enabled
   *
   * Return integration enabled state.
   */
  public static getIntegrationEnabled(
    options: Options<GetIntegrationEnabledData, true>
  ) {
    return (options.client ?? client).get<
      GetIntegrationEnabledResponses,
      GetIntegrationEnabledErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/{integration_type}/enabled",
      ...options,
    });
  }

  /**
   * Set Integration Enabled
   *
   * Enable or disable an integration platform-wide (admin only).
   */
  public static setIntegrationEnabled(
    options: Options<SetIntegrationEnabledData, true>
  ) {
    return (options.client ?? client).put<
      SetIntegrationEnabledResponses,
      SetIntegrationEnabledErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/{integration_type}/enabled",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Integration Settings Endpoint
   *
   * Return platform-level settings for one integration.
   */
  public static getIntegrationSettingsEndpoint(
    options: Options<GetIntegrationSettingsEndpointData, true>
  ) {
    return (options.client ?? client).get<
      GetIntegrationSettingsEndpointResponses,
      GetIntegrationSettingsEndpointErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/{integration_type}/settings",
      ...options,
    });
  }

  /**
   * Update Integration Settings Endpoint
   *
   * Update platform-level settings for one integration (disabled nodes/triggers, enabled).
   */
  public static updateIntegrationSettingsEndpoint(
    options: Options<UpdateIntegrationSettingsEndpointData, true>
  ) {
    return (options.client ?? client).put<
      UpdateIntegrationSettingsEndpointResponses,
      UpdateIntegrationSettingsEndpointErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/integrations/{integration_type}/settings",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Disconnect Oauth Credential
   *
   * Disconnect an OAuth credential for a specific integration + provider.
   */
  public static disconnectOauthCredential(
    options: Options<DisconnectOauthCredentialData, true>
  ) {
    return (options.client ?? client).delete<
      DisconnectOauthCredentialResponses,
      DisconnectOauthCredentialErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/oauth/{integration_type}/{provider_key}",
      ...options,
    });
  }

  /**
   * Get Gdrive Files
   *
   * Browse Google Drive files for the file picker.
   *
   * - folder_id: list files inside this folder (default: root for the source)
   * - query: free-text search (name contains)
   * - mime_type_filter: one of spreadsheet | document | presentation | folder
   * When set, results include that MIME type + folders (for navigation).
   * - credential_id: use a specific connected Google Drive account.
   * - page_token: continuation token for fetching the next page.
   * - source:
   * * "my_drive" (default) — the user's own My Drive
   * * "shared_with_me" — items shared with the user (root listing only;
   * navigating into a shared folder uses the folder_id path)
   * * "shared_drive:<driveId>" — a specific Shared Drive (formerly
   * Team Drive); navigation works the same way once `folder_id` is set.
   */
  public static getGdriveFiles(options: Options<GetGdriveFilesData, true>) {
    return (options.client ?? client).get<
      GetGdriveFilesResponses,
      GetGdriveFilesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/gdrive/files",
      ...options,
    });
  }

  /**
   * Get Gdrive Sources
   *
   * Enumerate the Shared Drives the user has access to. Used by the picker's
   * sidebar to render the list of "Shared drives" alongside My Drive and
   * "Shared with me". Returns an empty list when the user belongs to none.
   */
  public static getGdriveSources(options: Options<GetGdriveSourcesData, true>) {
    return (options.client ?? client).get<
      GetGdriveSourcesResponses,
      GetGdriveSourcesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/gdrive/sources",
      ...options,
    });
  }

  /**
   * Get Drive Token
   */
  public static getDriveToken(options: Options<GetDriveTokenData, true>) {
    return (options.client ?? client).get<
      GetDriveTokenResponses,
      GetDriveTokenErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/google/token",
      ...options,
    });
  }

  /**
   * Get Spreadsheet Information
   */
  public static getSpreadsheetInformation(
    options: Options<GetSpreadsheetInformationData, true>
  ) {
    return (options.client ?? client).get<
      GetSpreadsheetInformationResponses,
      GetSpreadsheetInformationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/gspreadsheets/{spreadsheet_id}",
      ...options,
    });
  }

  /**
   * Get Docs Information
   */
  public static getDocsInformation(
    options: Options<GetDocsInformationData, true>
  ) {
    return (options.client ?? client).get<
      GetDocsInformationResponses,
      GetDocsInformationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/gdocs/{doc_id}",
      ...options,
    });
  }

  /**
   * Get Slack Information
   */
  public static getSlackInformation(
    options: Options<GetSlackInformationData, true>
  ) {
    return (options.client ?? client).get<
      GetSlackInformationResponses,
      GetSlackInformationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/slack/information",
      ...options,
    });
  }

  /**
   * Complete Telegram Integration
   */
  public static completeTelegramIntegration(
    options: Options<CompleteTelegramIntegrationData, true>
  ) {
    return (options.client ?? client).post<
      CompleteTelegramIntegrationResponses,
      CompleteTelegramIntegrationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/telegram",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Disconnect Telegram
   */
  public static disconnectTelegram(
    options: Options<DisconnectTelegramData, true>
  ) {
    return (options.client ?? client).delete<
      DisconnectTelegramResponses,
      DisconnectTelegramErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/telegram/disconnect",
      ...options,
    });
  }

  /**
   * Get Onedrive User Information
   */
  public static getOnedriveUserInformation(
    options: Options<GetOnedriveUserInformationData, true>
  ) {
    return (options.client ?? client).get<
      GetOnedriveUserInformationResponses,
      GetOnedriveUserInformationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/onedrive/me",
      ...options,
    });
  }

  /**
   * Get Onedrive Docs Information
   */
  public static getOnedriveDocsInformation(
    options: Options<GetOnedriveDocsInformationData, true>
  ) {
    return (options.client ?? client).get<
      GetOnedriveDocsInformationResponses,
      GetOnedriveDocsInformationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/onedrive/{doc_id}",
      ...options,
    });
  }

  /**
   * Get Sharepoint Docs Information
   */
  public static getSharepointDocsInformation(
    options: Options<GetSharepointDocsInformationData, true>
  ) {
    return (options.client ?? client).get<
      GetSharepointDocsInformationResponses,
      GetSharepointDocsInformationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/sharepoint/{drive_id}/files/{doc_id}",
      ...options,
    });
  }

  /**
   * Get Onedrive Drive Files
   */
  public static getOnedriveDriveFiles(
    options: Options<GetOnedriveDriveFilesData, true>
  ) {
    return (options.client ?? client).get<
      GetOnedriveDriveFilesResponses,
      GetOnedriveDriveFilesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/onedrive/{drive_id}/files",
      ...options,
    });
  }

  /**
   * Get Sharepoint Drive Files
   */
  public static getSharepointDriveFiles(
    options: Options<GetSharepointDriveFilesData, true>
  ) {
    return (options.client ?? client).get<
      GetSharepointDriveFilesResponses,
      GetSharepointDriveFilesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/sharepoint/{site_id}/drives/{drive_id}/files",
      ...options,
    });
  }

  /**
   * Get Sharepoint Sites
   */
  public static getSharepointSites(
    options: Options<GetSharepointSitesData, true>
  ) {
    return (options.client ?? client).get<
      GetSharepointSitesResponses,
      GetSharepointSitesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/sharepoint/sites",
      ...options,
    });
  }

  /**
   * Get Sharepoint Subsites
   */
  public static getSharepointSubsites(
    options: Options<GetSharepointSubsitesData, true>
  ) {
    return (options.client ?? client).get<
      GetSharepointSubsitesResponses,
      GetSharepointSubsitesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/sharepoint/sites/{site_id}/subsites",
      ...options,
    });
  }

  /**
   * Get Sharepoint Site Drives
   */
  public static getSharepointSiteDrives(
    options: Options<GetSharepointSiteDrivesData, true>
  ) {
    return (options.client ?? client).get<
      GetSharepointSiteDrivesResponses,
      GetSharepointSiteDrivesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/sharepoint/sites/{site_id}/drives",
      ...options,
    });
  }

  /**
   * Complete Confluence Integration
   */
  public static completeConfluenceIntegration(
    options: Options<CompleteConfluenceIntegrationData, true>
  ) {
    return (options.client ?? client).post<
      CompleteConfluenceIntegrationResponses,
      CompleteConfluenceIntegrationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/confluence",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Disconnect Confluence
   */
  public static disconnectConfluence(
    options: Options<DisconnectConfluenceData, true>
  ) {
    return (options.client ?? client).delete<
      DisconnectConfluenceResponses,
      DisconnectConfluenceErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/confluence/disconnect",
      ...options,
    });
  }

  /**
   * Complete Odoo Integration
   */
  public static completeOdooIntegration(
    options: Options<CompleteOdooIntegrationData, true>
  ) {
    return (options.client ?? client).post<
      CompleteOdooIntegrationResponses,
      CompleteOdooIntegrationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/odoo",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Disconnect Odoo
   */
  public static disconnectOdoo(options: Options<DisconnectOdooData, true>) {
    return (options.client ?? client).delete<
      DisconnectOdooResponses,
      DisconnectOdooErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/odoo/disconnect",
      ...options,
    });
  }

  /**
   * Complete Paypay Integration
   */
  public static completePaypayIntegration(
    options: Options<CompletePaypayIntegrationData, true>
  ) {
    return (options.client ?? client).post<
      CompletePaypayIntegrationResponses,
      CompletePaypayIntegrationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/paypay",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Disconnect Paypay
   */
  public static disconnectPaypay(options: Options<DisconnectPaypayData, true>) {
    return (options.client ?? client).delete<
      DisconnectPaypayResponses,
      DisconnectPaypayErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/paypay/disconnect",
      ...options,
    });
  }

  /**
   * Complete Rapyd Integration
   */
  public static completeRapydIntegration(
    options: Options<CompleteRapydIntegrationData, true>
  ) {
    return (options.client ?? client).post<
      CompleteRapydIntegrationResponses,
      CompleteRapydIntegrationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/rapyd",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Disconnect Rapyd
   */
  public static disconnectRapyd(options: Options<DisconnectRapydData, true>) {
    return (options.client ?? client).delete<
      DisconnectRapydResponses,
      DisconnectRapydErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/rapyd/disconnect",
      ...options,
    });
  }

  /**
   * Complete Persona Integration
   */
  public static completePersonaIntegration(
    options: Options<CompletePersonaIntegrationData, true>
  ) {
    return (options.client ?? client).post<
      CompletePersonaIntegrationResponses,
      CompletePersonaIntegrationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/persona",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Disconnect Persona
   */
  public static disconnectPersona(
    options: Options<DisconnectPersonaData, true>
  ) {
    return (options.client ?? client).delete<
      DisconnectPersonaResponses,
      DisconnectPersonaErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/persona/disconnect",
      ...options,
    });
  }

  /**
   * Complete Clipone Integration
   */
  public static completeCliponeIntegration(
    options: Options<CompleteCliponeIntegrationData, true>
  ) {
    return (options.client ?? client).post<
      CompleteCliponeIntegrationResponses,
      CompleteCliponeIntegrationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/clipone",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Disconnect Clipone
   */
  public static disconnectClipone(
    options: Options<DisconnectCliponeData, true>
  ) {
    return (options.client ?? client).delete<
      DisconnectCliponeResponses,
      DisconnectCliponeErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/clipone/disconnect",
      ...options,
    });
  }

  /**
   * Complete Thom Integration
   */
  public static completeThomIntegration(
    options: Options<CompleteThomIntegrationData, true>
  ) {
    return (options.client ?? client).post<
      CompleteThomIntegrationResponses,
      CompleteThomIntegrationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/thom",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Disconnect Thom
   */
  public static disconnectThom(options: Options<DisconnectThomData, true>) {
    return (options.client ?? client).delete<
      DisconnectThomResponses,
      DisconnectThomErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/thom/disconnect",
      ...options,
    });
  }

  /**
   * Get Integration Config
   *
   * Returns all visible integrations with:
   * - Which providers are available (admin configured + enabled)
   * - Which providers/SecretAuth the group currently has connected
   * - Credential status (active / needs_reconnect / expired)
   * - Form schema URLs
   */
  public static getIntegrationConfig(
    options: Options<GetIntegrationConfigData, true>
  ) {
    return (options.client ?? client).get<
      GetIntegrationConfigResponses,
      GetIntegrationConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/config",
      ...options,
    });
  }

  /**
   * Get Integration Status
   *
   * Legacy status endpoint — kept for frontend backward compatibility.
   * Returns bool per integration type indicating whether the group is connected.
   */
  public static getIntegrationStatus(
    options: Options<GetIntegrationStatusData, true>
  ) {
    return (options.client ?? client).get<
      GetIntegrationStatusResponses,
      GetIntegrationStatusErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/status",
      ...options,
    });
  }

  /**
   * Get Available Integrations
   *
   * Returns which integrations are available to this group
   * (provider is configured by admin, or SecretAuth is always available).
   */
  public static getAvailableIntegrations(
    options: Options<GetAvailableIntegrationsData, true>
  ) {
    return (options.client ?? client).get<
      GetAvailableIntegrationsResponses,
      GetAvailableIntegrationsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/integrations/available",
      ...options,
    });
  }
}

export class MonitoringService {
  /**
   * Record Chat Timing
   *
   * Record how long a chat reply took to show, as the user's browser measured it.
   */
  public static recordChatTiming(options: Options<RecordChatTimingData, true>) {
    return (options.client ?? client).post<
      RecordChatTimingResponses,
      RecordChatTimingErrors,
      true
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/ui-timing/chat",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class StatusService {
  /**
   * Storage Status
   */
  public static storageStatus(options?: Options<StorageStatusData, true>) {
    return (options?.client ?? client).get<
      StorageStatusResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/status/storage",
      ...options,
    });
  }

  /**
   * Sandbox Allocations
   */
  public static sandboxAllocations(
    options?: Options<SandboxAllocationsData, true>
  ) {
    return (options?.client ?? client).get<
      SandboxAllocationsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/status/sandbox/allocations",
      ...options,
    });
  }

  /**
   * Evict Sandbox Allocation
   *
   * Stop or kill one running sandbox. The manager URL must be one the
   * platform is talking to (it comes from the allocation row), so the
   * admin cannot point this at an arbitrary host.
   */
  public static evictSandboxAllocation(
    options: Options<EvictSandboxAllocationData, true>
  ) {
    return (options.client ?? client).delete<
      EvictSandboxAllocationResponses,
      EvictSandboxAllocationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/status/sandbox/allocations/{sandbox_id}",
      ...options,
    });
  }

  /**
   * Remove Queued Sandbox Request
   *
   * Withdraw one queued sandbox create; whatever waits on it fails with
   * a message saying an administrator removed it.
   */
  public static removeQueuedSandboxRequest(
    options: Options<RemoveQueuedSandboxRequestData, true>
  ) {
    return (options.client ?? client).delete<
      RemoveQueuedSandboxRequestResponses,
      RemoveQueuedSandboxRequestErrors,
      true
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/status/sandbox/queue/{operation_id}",
      ...options,
    });
  }

  /**
   * Health
   */
  public static health(options?: Options<HealthData, true>) {
    return (options?.client ?? client).get<HealthResponses, unknown, true>({
      responseType: "json",
      url: "/status/health",
      ...options,
    });
  }

  /**
   * Read Item
   */
  public static readItem(options?: Options<ReadItemData, true>) {
    return (options?.client ?? client).get<ReadItemResponses, unknown, true>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/status/psql-conn",
      ...options,
    });
  }

  /**
   * Test Redis Conn
   */
  public static testRedisConn(options?: Options<TestRedisConnData, true>) {
    return (options?.client ?? client).get<
      TestRedisConnResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/status/redis-conn",
      ...options,
    });
  }

  /**
   * Redis Conn
   */
  public static redisConn(options?: Options<RedisConnData, true>) {
    return (options?.client ?? client).get<RedisConnResponses, unknown, true>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/status/redis-reset",
      ...options,
    });
  }

  /**
   * Database Locks
   *
   * Postgres activity and lock profile for admin diagnostics.
   */
  public static databaseLocks(options?: Options<DatabaseLocksData, true>) {
    return (options?.client ?? client).get<
      DatabaseLocksResponses,
      DatabaseLocksErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/status/db-locks",
      ...options,
    });
  }

  /**
   * Terminate Database Backend
   *
   * Terminate a selected Postgres backend from the diagnostics page.
   */
  public static terminateDatabaseBackend(
    options: Options<TerminateDatabaseBackendData, true>
  ) {
    return (options.client ?? client).post<
      TerminateDatabaseBackendResponses,
      TerminateDatabaseBackendErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/status/db-locks/terminate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Platform Status
   *
   * Comprehensive platform status with connectivity and latency for all services.
   */
  public static platformStatus(options?: Options<PlatformStatusData, true>) {
    return (options?.client ?? client).get<
      PlatformStatusResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/status/platform",
      ...options,
    });
  }
}

export class UploadService {
  /**
   * Add Image
   */
  public static addImage(options: Options<AddImageData, true>) {
    return (options.client ?? client).post<
      AddImageResponses,
      AddImageErrors,
      true
    >({
      ...formDataBodySerializer,
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/file",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });
  }

  /**
   * Get Image
   */
  public static getImage(options: Options<GetImageData, true>) {
    return (options.client ?? client).get<
      GetImageResponses,
      GetImageErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/file/{name}",
      ...options,
    });
  }

  /**
   * Get Public Image
   */
  public static getPublicImage(options: Options<GetPublicImageData, true>) {
    return (options.client ?? client).get<
      GetPublicImageResponses,
      GetPublicImageErrors,
      true
    >({
      responseType: "json",
      url: "/file/public/{name}",
      ...options,
    });
  }

  /**
   * Get Image Metadata
   */
  public static getImageMetadata(options: Options<GetImageMetadataData, true>) {
    return (options.client ?? client).get<
      GetImageMetadataResponses,
      GetImageMetadataErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/file/{name}/metadata",
      ...options,
    });
  }

  /**
   * Add Public Image
   */
  public static addPublicImage(options: Options<AddPublicImageData, true>) {
    return (options.client ?? client).post<
      AddPublicImageResponses,
      AddPublicImageErrors,
      true
    >({
      ...formDataBodySerializer,
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/file/public",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });
  }
}

export class AdminService {
  /**
   * Get Admin Stats
   */
  public static getAdminStats(options?: Options<GetAdminStatsData, true>) {
    return (options?.client ?? client).get<
      GetAdminStatsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/stats",
      ...options,
    });
  }

  /**
   * List Tenants
   */
  public static listTenants(options?: Options<ListTenantsData, true>) {
    return (options?.client ?? client).get<
      ListTenantsResponses,
      ListTenantsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants",
      ...options,
    });
  }

  /**
   * Admin Create Tenant
   *
   * Create a tenant from scratch with a primary admin user.
   *
   * Works for both SaaS and on-prem: ``Tenant.bootstrap`` skips the Stripe +
   * license-server side-effects when ``settings.ON_PREM`` is true.
   */
  public static adminCreateTenant(
    options: Options<AdminCreateTenantData, true>
  ) {
    return (options.client ?? client).post<
      AdminCreateTenantResponses,
      AdminCreateTenantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Tenant
   *
   * Queue a permanent tenant purge and return without waiting for it.
   */
  public static deleteTenant(options: Options<DeleteTenantData, true>) {
    return (options.client ?? client).delete<
      DeleteTenantResponses,
      DeleteTenantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Admin Tenant
   */
  public static getAdminTenant(options: Options<GetAdminTenantData, true>) {
    return (options.client ?? client).get<
      GetAdminTenantResponses,
      GetAdminTenantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}",
      ...options,
    });
  }

  /**
   * Admin Invite User
   *
   * Invite a user to a specific tenant as a noxus admin.
   *
   * Creates a pending user (no auth_id) and attaches them to a workspace as the
   * given role (defaults to ``Base``). Works on-prem: the SendGrid email is
   * skipped when no ``SENDGRID_API_KEY`` is configured.
   */
  public static adminInviteUser(options: Options<AdminInviteUserData, true>) {
    return (options.client ?? client).post<
      AdminInviteUserResponses,
      AdminInviteUserErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}/invite",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Update Subscription Plan
   */
  public static updateSubscriptionPlan(
    options: Options<UpdateSubscriptionPlanData, true>
  ) {
    return (options.client ?? client).patch<
      UpdateSubscriptionPlanResponses,
      UpdateSubscriptionPlanErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}/plan",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Rename Tenant
   */
  public static renameTenant(options: Options<RenameTenantData, true>) {
    return (options.client ?? client).patch<
      RenameTenantResponses,
      RenameTenantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}/rename",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Suspend Tenant
   */
  public static suspendTenant(options: Options<SuspendTenantData, true>) {
    return (options.client ?? client).patch<
      SuspendTenantResponses,
      SuspendTenantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}/suspend",
      ...options,
    });
  }

  /**
   * Activate Tenant
   */
  public static activateTenant(options: Options<ActivateTenantData, true>) {
    return (options.client ?? client).patch<
      ActivateTenantResponses,
      ActivateTenantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}/activate",
      ...options,
    });
  }

  /**
   * Get Tenant Audit Logs
   */
  public static getTenantAuditLogs(
    options: Options<GetTenantAuditLogsData, true>
  ) {
    return (options.client ?? client).get<
      GetTenantAuditLogsResponses,
      GetTenantAuditLogsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}/audit-logs",
      ...options,
    });
  }

  /**
   * Get Tenant Audit Log Facets
   */
  public static getTenantAuditLogFacets(
    options: Options<GetTenantAuditLogFacetsData, true>
  ) {
    return (options.client ?? client).get<
      GetTenantAuditLogFacetsResponses,
      GetTenantAuditLogFacetsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}/audit-log-facets",
      ...options,
    });
  }

  /**
   * Merge Tenant
   */
  public static mergeTenant(options: Options<MergeTenantData, true>) {
    return (options.client ?? client).patch<
      MergeTenantResponses,
      MergeTenantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}/merge",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Topup Credits
   */
  public static topupCredits(options: Options<TopupCreditsData, true>) {
    return (options.client ?? client).patch<
      TopupCreditsResponses,
      TopupCreditsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}/topup",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Admin Unjoin Tenant
   */
  public static adminUnjoinTenant(
    options?: Options<AdminUnjoinTenantData, true>
  ) {
    return (options?.client ?? client).post<
      AdminUnjoinTenantResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/unjoin",
      ...options,
    });
  }

  /**
   * Admin Join Tenant
   */
  public static adminJoinTenant(options: Options<AdminJoinTenantData, true>) {
    return (options.client ?? client).post<
      AdminJoinTenantResponses,
      AdminJoinTenantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}/join",
      ...options,
    });
  }

  /**
   * Get Tenant Feature Flags
   */
  public static getTenantFeatureFlags(
    options: Options<GetTenantFeatureFlagsData, true>
  ) {
    return (options.client ?? client).get<
      GetTenantFeatureFlagsResponses,
      GetTenantFeatureFlagsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}/ffs",
      ...options,
    });
  }

  /**
   * Update Feature Flags
   */
  public static updateFeatureFlags(
    options: Options<UpdateFeatureFlagsData, true>
  ) {
    return (options.client ?? client).patch<
      UpdateFeatureFlagsResponses,
      UpdateFeatureFlagsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/tenants/{tenant_id}/ffs",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get User Profile
   */
  public static getUserProfile(options?: Options<GetUserProfileData, true>) {
    return (options?.client ?? client).get<
      GetUserProfileResponses,
      GetUserProfileErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/users/spot",
      ...options,
    });
  }

  /**
   * Delete User Profile
   */
  public static deleteUserProfile(
    options: Options<DeleteUserProfileData, true>
  ) {
    return (options.client ?? client).delete<
      DeleteUserProfileResponses,
      DeleteUserProfileErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/users/spot/{user_id}",
      ...options,
    });
  }

  /**
   * Get User Profile By Id
   */
  public static getUserProfileById(
    options: Options<GetUserProfileByIdData, true>
  ) {
    return (options.client ?? client).get<
      GetUserProfileByIdResponses,
      GetUserProfileByIdErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/users/spot/{user_id}",
      ...options,
    });
  }

  /**
   * Patch User Profile
   */
  public static patchUserProfile(options: Options<PatchUserProfileData, true>) {
    return (options.client ?? client).patch<
      PatchUserProfileResponses,
      PatchUserProfileErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/users/spot/{user_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Set User Admin Status
   *
   * Set or remove admin status for a user.
   * Only accessible by platform admins.
   */
  public static setUserAdminStatus(
    options: Options<SetUserAdminStatusData, true>
  ) {
    return (options.client ?? client).post<
      SetUserAdminStatusResponses,
      SetUserAdminStatusErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/users/{user_id}/set-admin",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Auth0 Users
   */
  public static getAuth0Users(options?: Options<GetAuth0UsersData, true>) {
    return (options?.client ?? client).get<
      GetAuth0UsersResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/users/auth0",
      ...options,
    });
  }

  /**
   * Refresh Auth0 Users
   */
  public static refreshAuth0Users(
    options?: Options<RefreshAuth0UsersData, true>
  ) {
    return (options?.client ?? client).post<
      RefreshAuth0UsersResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/users/auth0/refresh",
      ...options,
    });
  }

  /**
   * Admin Resume Run
   */
  public static adminResumeRun(options: Options<AdminResumeRunData, true>) {
    return (options.client ?? client).post<
      AdminResumeRunResponses,
      AdminResumeRunErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/runs/{run_id}/resume",
      ...options,
    });
  }

  /**
   * Admin Stop Run
   */
  public static adminStopRun(options: Options<AdminStopRunData, true>) {
    return (options.client ?? client).post<
      AdminStopRunResponses,
      AdminStopRunErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/runs/{run_id}/stop",
      ...options,
    });
  }

  /**
   * Make Template
   */
  public static makeTemplate(options: Options<MakeTemplateData, true>) {
    return (options.client ?? client).post<
      MakeTemplateResponses,
      MakeTemplateErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/workflows/{workflow_id}/template",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Running Workers
   */
  public static getRunningWorkers(
    options?: Options<GetRunningWorkersData, true>
  ) {
    return (options?.client ?? client).get<
      GetRunningWorkersResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/workers",
      ...options,
    });
  }

  /**
   * Get Worker Logs
   */
  public static getWorkerLogs(options: Options<GetWorkerLogsData, true>) {
    return (options.client ?? client).get<
      GetWorkerLogsResponses,
      GetWorkerLogsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/workers/{worker_name}/logs",
      ...options,
    });
  }

  /**
   * Get Api Keys Set
   */
  public static getApiKeysSet(options?: Options<GetApiKeysSetData, true>) {
    return (options?.client ?? client).get<
      GetApiKeysSetResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/secrets",
      ...options,
    });
  }

  /**
   * Set Api Keys
   */
  public static setApiKeys(options: Options<SetApiKeysData, true>) {
    return (options.client ?? client).post<
      SetApiKeysResponses,
      SetApiKeysErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/secrets/{secret_name}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Recovery Stats
   */
  public static getRecoveryStats(
    options?: Options<GetRecoveryStatsData, true>
  ) {
    return (options?.client ?? client).get<
      GetRecoveryStatsResponses,
      GetRecoveryStatsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/runs/recovery-stats",
      ...options,
    });
  }

  /**
   * Resume Recent
   */
  public static resumeRecent(options?: Options<ResumeRecentData, true>) {
    return (options?.client ?? client).post<
      ResumeRecentResponses,
      ResumeRecentErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/runs/resume-recent",
      ...options,
    });
  }

  /**
   * Resume Queued
   */
  public static resumeQueued(options?: Options<ResumeQueuedData, true>) {
    return (options?.client ?? client).post<
      ResumeQueuedResponses,
      ResumeQueuedErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/runs/resume-queued",
      ...options,
    });
  }

  /**
   * Get Server Settings
   */
  public static getServerSettings(
    options?: Options<GetServerSettingsData, true>
  ) {
    return (options?.client ?? client).get<
      GetServerSettingsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/server/settings",
      ...options,
    });
  }

  /**
   * Update Server Settings
   */
  public static updateServerSettings(
    options: Options<UpdateServerSettingsData, true>
  ) {
    return (options.client ?? client).post<
      UpdateServerSettingsResponses,
      UpdateServerSettingsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/server/settings",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Audit Logs Storage
   */
  public static getAuditLogsStorage(
    options?: Options<GetAuditLogsStorageData, true>
  ) {
    return (options?.client ?? client).get<
      GetAuditLogsStorageResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/server/audit-logs/storage",
      ...options,
    });
  }

  /**
   * Get Run Data Index Stats
   */
  public static getRunDataIndexStats(
    options?: Options<GetRunDataIndexStatsData, true>
  ) {
    return (options?.client ?? client).get<
      GetRunDataIndexStatsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/server/run-data/index",
      ...options,
    });
  }

  /**
   * Trigger Run Data Backfill
   */
  public static triggerRunDataBackfill(
    options: Options<TriggerRunDataBackfillData, true>
  ) {
    return (options.client ?? client).post<
      TriggerRunDataBackfillResponses,
      TriggerRunDataBackfillErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/server/run-data/backfill",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Service Metrics
   *
   * Time series of per-process resource snapshots for the admin graphs.
   *
   * Rows are averaged into time buckets sized so each series stays under
   * ~300 points regardless of the requested window.
   */
  public static getServiceMetrics(
    options?: Options<GetServiceMetricsData, true>
  ) {
    return (options?.client ?? client).get<
      GetServiceMetricsResponses,
      GetServiceMetricsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/server/service-metrics",
      ...options,
    });
  }

  /**
   * Get Build Version
   */
  public static getBuildVersion(options?: Options<GetBuildVersionData, true>) {
    return (options?.client ?? client).get<
      GetBuildVersionResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/server/version",
      ...options,
    });
  }

  /**
   * Get Security Settings
   *
   * Read deployment-level security toggles (System → Security).
   */
  public static getSecuritySettings(
    options?: Options<GetSecuritySettingsData, true>
  ) {
    return (options?.client ?? client).get<
      GetSecuritySettingsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/server/security",
      ...options,
    });
  }

  /**
   * Update Security Settings
   *
   * Update deployment-level security toggles. Creates the row on first
   * write — there's no migration needed, the ``security`` key is created
   * lazily like ``rate_limits``.
   */
  public static updateSecuritySettings(
    options: Options<UpdateSecuritySettingsData, true>
  ) {
    return (options.client ?? client).post<
      UpdateSecuritySettingsResponses,
      UpdateSecuritySettingsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/server/security",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Rate Limits
   */
  public static getRateLimits(options?: Options<GetRateLimitsData, true>) {
    return (options?.client ?? client).get<
      GetRateLimitsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/rate-limits",
      ...options,
    });
  }

  /**
   * Update Rate Limits
   */
  public static updateRateLimits(options: Options<UpdateRateLimitsData, true>) {
    return (options.client ?? client).patch<
      UpdateRateLimitsResponses,
      UpdateRateLimitsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/rate-limits",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Activate Dev License
   *
   * Set the development license key. Restricted to @noxus.ai users.
   */
  public static activateDevLicense(
    options?: Options<ActivateDevLicenseData, true>
  ) {
    return (options?.client ?? client).post<
      ActivateDevLicenseResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/server/activate-dev-license",
      ...options,
    });
  }

  /**
   * Generate Jwt
   */
  public static generateJwt(options?: Options<GenerateJwtData, true>) {
    return (options?.client ?? client).post<
      GenerateJwtResponses,
      GenerateJwtErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/support/jwt",
      ...options,
    });
  }

  /**
   * Invalidate Cache
   */
  public static invalidateCache(options?: Options<InvalidateCacheData, true>) {
    return (options?.client ?? client).post<
      InvalidateCacheResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/cache/invalidate",
      ...options,
    });
  }

  /**
   * Get Cache Stats
   */
  public static getCacheStats(options?: Options<GetCacheStatsData, true>) {
    return (options?.client ?? client).get<
      GetCacheStatsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/cache/stats",
      ...options,
    });
  }

  /**
   * Invalidate Cache Tag
   */
  public static invalidateCacheTag(
    options: Options<InvalidateCacheTagData, true>
  ) {
    return (options.client ?? client).post<
      InvalidateCacheTagResponses,
      InvalidateCacheTagErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/cache/invalidate-tag",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Cache Pattern
   */
  public static deleteCachePattern(
    options: Options<DeleteCachePatternData, true>
  ) {
    return (options.client ?? client).post<
      DeleteCachePatternResponses,
      DeleteCachePatternErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/cache/delete-pattern",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Go To Link
   */
  public static goToLink(options: Options<GoToLinkData, true>) {
    return (options.client ?? client).post<
      GoToLinkResponses,
      GoToLinkErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/go-to-link",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Encrypt Provider Keys
   *
   * Encrypt plaintext provider keys that were migrated before encryption was in place.
   *
   * Finds all rows in the providers table where data IS NOT NULL and encrypted_data
   * IS NULL, encrypts the data with AES-256-GCM, writes it to encrypted_data, and
   * clears the plaintext data column. Safe to re-run — skips already-encrypted rows.
   */
  public static encryptProviderKeys(
    options?: Options<EncryptProviderKeysData, true>
  ) {
    return (options?.client ?? client).post<
      EncryptProviderKeysResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/providers/encrypt",
      ...options,
    });
  }

  /**
   * Migrate Legacy Credentials
   *
   * Migrate legacy credentials into the new credentials table.
   *
   * 1. Secret-auth: copies API keys / custom credentials from integration_credentials.data.
   * 2. Nango OAuth: fetches current OAuth tokens from the Nango API for all groups
   * with Nango-backed connections and inserts them. Requires NANGO_SECRET_KEY.
   *
   * Requires CREDENTIAL_ENCRYPTION_KEY. Safe to re-run — uses ON CONFLICT DO NOTHING.
   */
  public static migrateLegacyCredentials(
    options?: Options<MigrateLegacyCredentialsData, true>
  ) {
    return (options?.client ?? client).post<
      MigrateLegacyCredentialsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/credentials/migrate-legacy",
      ...options,
    });
  }

  /**
   * Upgrade Credentials To Ncs
   *
   * Upgrade migrated oauth2 credentials to use the active NCS provider.
   *
   * For each integration that has an NCS provider available, finds credentials
   * with auth_method='oauth2' and updates them to use the NCS provider_key and
   * auth_method='ncs'. Safe to re-run — only touches oauth2 credentials.
   */
  public static upgradeCredentialsToNcs(
    options?: Options<UpgradeCredentialsToNcsData, true>
  ) {
    return (options?.client ?? client).post<
      UpgradeCredentialsToNcsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/credentials/upgrade-to-ncs",
      ...options,
    });
  }

  /**
   * Remigrate Secret Auth Credentials
   *
   * Re-read secret-auth credentials from the legacy integration_credentials table
   * and UPDATE existing rows in the credentials table with fresh encrypted payloads.
   *
   * Use this when the initial migration produced empty payloads due to a bug.
   * Only touches credentials with provider_key='_secret_auth'.
   */
  public static remigrateSecretAuthCredentials(
    options?: Options<RemigrateSecretAuthCredentialsData, true>
  ) {
    return (options?.client ?? client).post<
      RemigrateSecretAuthCredentialsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/credentials/remigrate-secret-auth",
      ...options,
    });
  }

  /**
   * Migrate Google Credentials
   *
   * Migrate legacy "google" entries from integration_credentials into per-service
   * credential rows (gdrive, gmail, gspreadsheets, gdocs, gcalendar).
   *
   * The old system stored a single "google" OAuth credential with broad scopes.
   * This endpoint inspects the granted scopes and creates a separate credential
   * for each Google service that has matching scopes. The same token is replicated
   * across all matching services.
   *
   * Safe to re-run — skips groups that already have credentials for a given service.
   */
  public static migrateGoogleCredentials(
    options?: Options<MigrateGoogleCredentialsData, true>
  ) {
    return (options?.client ?? client).post<
      MigrateGoogleCredentialsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/credentials/migrate-google",
      ...options,
    });
  }

  /**
   * Billing Rectification Summary
   */
  public static billingRectificationSummary(
    options?: Options<BillingRectificationSummaryData, true>
  ) {
    return (options?.client ?? client).get<
      BillingRectificationSummaryResponses,
      BillingRectificationSummaryErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/billing-rectification/summary",
      ...options,
    });
  }

  /**
   * Billing Rectification Events
   */
  public static billingRectificationEvents(
    options?: Options<BillingRectificationEventsData, true>
  ) {
    return (options?.client ?? client).get<
      BillingRectificationEventsResponses,
      BillingRectificationEventsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/billing-rectification/events",
      ...options,
    });
  }

  /**
   * Billing Rectification Deduplicate
   */
  public static billingRectificationDeduplicate(
    options: Options<BillingRectificationDeduplicateData, true>
  ) {
    return (options.client ?? client).post<
      BillingRectificationDeduplicateResponses,
      BillingRectificationDeduplicateErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/billing-rectification/deduplicate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Billing Rectification Correct Prices
   */
  public static billingRectificationCorrectPrices(
    options: Options<BillingRectificationCorrectPricesData, true>
  ) {
    return (options.client ?? client).post<
      BillingRectificationCorrectPricesResponses,
      BillingRectificationCorrectPricesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/billing-rectification/correct-prices",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Lifecycle Config
   *
   * Get current lifecycle runtime config (Redis overrides + env defaults).
   *
   * Restricted to ``@noxus.ai`` operators — overwriting these knobs
   * (interval_seconds, max_concurrent_checks, …) can DoS every provider
   * in the platform every minute, so a tenant-level admin is not enough.
   */
  public static getLifecycleConfig(
    options?: Options<GetLifecycleConfigData, true>
  ) {
    return (options?.client ?? client).get<
      GetLifecycleConfigResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/lifecycle/config",
      ...options,
    });
  }

  /**
   * Update Lifecycle Config
   *
   * Update lifecycle runtime config. Pass 0 / 0.0 to reset a field to default.
   */
  public static updateLifecycleConfig(
    options: Options<UpdateLifecycleConfigData, true>
  ) {
    return (options.client ?? client).post<
      UpdateLifecycleConfigResponses,
      UpdateLifecycleConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/lifecycle/config",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Apply Local Test Preset
   *
   * Apply the aggressive local-test preset (1-min cadence, fast thresholds).
   *
   * Writes all fields as overrides in Redis. Call 'reset to defaults' to
   * revert to production values.
   */
  public static applyLocalTestPreset(
    options?: Options<ApplyLocalTestPresetData, true>
  ) {
    return (options?.client ?? client).post<
      ApplyLocalTestPresetResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/lifecycle/config/local-preset",
      ...options,
    });
  }

  /**
   * Toggle Lifecycle Pause
   *
   * Toggle periodic health checks on/off (backwards compat).
   */
  public static toggleLifecyclePause(
    options?: Options<ToggleLifecyclePauseData, true>
  ) {
    return (options?.client ?? client).post<
      ToggleLifecyclePauseResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/lifecycle/pause",
      ...options,
    });
  }

  /**
   * Get Lifecycle Status
   *
   * Get current lifecycle pause status (backwards compat).
   */
  public static getLifecycleStatus(
    options?: Options<GetLifecycleStatusData, true>
  ) {
    return (options?.client ?? client).get<
      GetLifecycleStatusResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/lifecycle/status",
      ...options,
    });
  }

  /**
   * Run Lifecycle Health Checks
   *
   * Defer a forced lifecycle health check to the worker. Returns immediately.
   */
  public static runLifecycleHealthChecks(
    options?: Options<RunLifecycleHealthChecksData, true>
  ) {
    return (options?.client ?? client).post<
      RunLifecycleHealthChecksResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/lifecycle/run-health-checks",
      ...options,
    });
  }

  /**
   * Get Insights Config
   *
   * Get current insights cadence config. Restricted to ``@noxus.ai`` operators.
   */
  public static getInsightsConfig(
    options?: Options<GetInsightsConfigData, true>
  ) {
    return (options?.client ?? client).get<
      GetInsightsConfigResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/insights/config",
      ...options,
    });
  }

  /**
   * Update Insights Config
   *
   * Update insights cadence config. Pass 0 to reset an interval to default.
   */
  public static updateInsightsConfig(
    options: Options<UpdateInsightsConfigData, true>
  ) {
    return (options.client ?? client).post<
      UpdateInsightsConfigResponses,
      UpdateInsightsConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/insights/config",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Run Insights Analysis
   *
   * Force the per-conversation analysis sweep on the worker (skips the gate).
   */
  public static runInsightsAnalysis(
    options?: Options<RunInsightsAnalysisData, true>
  ) {
    return (options?.client ?? client).post<
      RunInsightsAnalysisResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/insights/run-analysis",
      ...options,
    });
  }

  /**
   * Run Insights Aggregates
   *
   * Force the aggregate rebuild on the worker (skips the gate).
   */
  public static runInsightsAggregates(
    options?: Options<RunInsightsAggregatesData, true>
  ) {
    return (options?.client ?? client).post<
      RunInsightsAggregatesResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/insights/run-aggregates",
      ...options,
    });
  }

  /**
   * Get Noxus Provider Config
   *
   * Read the current Noxus platform-tenant UUID from ``server_settings``.
   */
  public static getNoxusProviderConfig(
    options?: Options<GetNoxusProviderConfigData, true>
  ) {
    return (options?.client ?? client).get<
      GetNoxusProviderConfigResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/noxus-provider",
      ...options,
    });
  }

  /**
   * Set Noxus Provider Config
   *
   * Set or clear the Noxus platform-tenant UUID in ``server_settings``.
   *
   * The UUID must refer to an existing tenant; otherwise 404. Clients on SaaS
   * will transparently fall back to this tenant's active model-provider links
   * when they have no coverage of their own. The mem cache used by the
   * runtime hot path is busted inside ``set_noxus_tenant_id``.
   */
  public static setNoxusProviderConfig(
    options: Options<SetNoxusProviderConfigData, true>
  ) {
    return (options.client ?? client).patch<
      SetNoxusProviderConfigResponses,
      SetNoxusProviderConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/noxus-provider",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Repair Noxus Links
   *
   * Reactivate all unhealthy/disabled Noxus-backed links across all tenants,
   * then defer a forced health check to the worker.
   *
   * The reactivation is a fast DB update (inline). The health check is
   * dispatched to the worker so it doesn't block the API request.
   */
  public static repairNoxusLinks(
    options?: Options<RepairNoxusLinksData, true>
  ) {
    return (options?.client ?? client).post<
      RepairNoxusLinksResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/noxus-provider/repair",
      ...options,
    });
  }

  /**
   * Get Chaos Testing Config
   *
   * Read the platform-wide chaos-testing toggle.
   */
  public static getChaosTestingConfig(
    options?: Options<GetChaosTestingConfigData, true>
  ) {
    return (options?.client ?? client).get<
      GetChaosTestingConfigResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/chaos-testing",
      ...options,
    });
  }

  /**
   * Set Chaos Testing Config
   *
   * Flip the platform-wide chaos-testing toggle.
   *
   * When ON, any user with provider-management permission can fire the
   * chaos endpoint — used so QA testers can exercise the lifecycle
   * without granting them admin or relying on DEPLOYMENT_ENV=local.
   */
  public static setChaosTestingConfig(
    options: Options<SetChaosTestingConfigData, true>
  ) {
    return (options.client ?? client).patch<
      SetChaosTestingConfigResponses,
      SetChaosTestingConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/chaos-testing",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Admin Kb Chaos
   *
   * Trip the failure mode for a single check on demand. Local-dev only.
   *
   * Each check class implements its own ``.chaos()`` — this endpoint
   * just dispatches via id. Returns ``KBChaosResult``.
   */
  public static adminKbChaos(options: Options<AdminKbChaosData, true>) {
    return (options.client ?? client).post<
      AdminKbChaosResponses,
      AdminKbChaosErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/kbs/{kb_id}/health/chaos/{check_id}",
      ...options,
    });
  }

  /**
   * Resume Recent
   */
  public static resumeRecent2(options?: Options<ResumeRecent2Data, true>) {
    return (options?.client ?? client).post<
      ResumeRecent2Responses,
      ResumeRecent2Errors,
      true
    >({
      responseType: "json",
      security: [{ name: "X-API-Key", type: "apiKey" }],
      url: "/admin/runs/resume-recent-api",
      ...options,
    });
  }

  /**
   * List Components Admin
   *
   * List every registered component with its global enabled state.
   */
  public static listComponentsAdmin(
    options?: Options<ListComponentsAdminData, true>
  ) {
    return (options?.client ?? client).get<
      ListComponentsAdminResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/components",
      ...options,
    });
  }

  /**
   * Set Component Enabled
   *
   * Enable or disable a single component globally.
   */
  public static setComponentEnabled(
    options: Options<SetComponentEnabledData, true>
  ) {
    return (options.client ?? client).put<
      SetComponentEnabledResponses,
      SetComponentEnabledErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/components/{kind}/{key}/enabled",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Bulk Set Disabled
   *
   * Replace the disabled set for one kind. Keys not in ``disabled`` become enabled.
   */
  public static bulkSetDisabled(options: Options<BulkSetDisabledData, true>) {
    return (options.client ?? client).put<
      BulkSetDisabledResponses,
      BulkSetDisabledErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/components/{kind}/bulk",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class NodesService {
  /**
   * Batch Get Node Config
   */
  public static batchGetNodeConfig(
    options: Options<BatchGetNodeConfigData, true>
  ) {
    return (options.client ?? client).post<
      BatchGetNodeConfigResponses,
      BatchGetNodeConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/nodes/batch-config",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Node Config
   */
  public static getNodeConfig(options: Options<GetNodeConfigData, true>) {
    return (options.client ?? client).post<
      GetNodeConfigResponses,
      GetNodeConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/nodes/{node_id}/config",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Node Config V2
   *
   * Dynamic config for a V2 node.
   *
   * V2-native and connector-free: returns the (possibly node-customized) config
   * schema + outputs. A node opts in simply by defining `get_config`; the
   * endpoint is auto-declared on the node (config_endpoint), so the frontend
   * refreshes config from here when values change.
   */
  public static getNodeConfigV2(options: Options<GetNodeConfigV2Data, true>) {
    return (options.client ?? client).post<
      GetNodeConfigV2Responses,
      GetNodeConfigV2Errors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/nodes-v2/{node_id}/config",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class SpecService {
  /**
   * Get Product Spec
   */
  public static getProductSpec(options?: Options<GetProductSpecData, true>) {
    return (options?.client ?? client).get<
      GetProductSpecResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/spec",
      ...options,
    });
  }

  /**
   * Get Spec Node History
   *
   * Git-derived history of a key; works for removed keys too. 404 when the
   * build has no git checkout (production images).
   */
  public static getSpecNodeHistory(
    options: Options<GetSpecNodeHistoryData, true>
  ) {
    return (options.client ?? client).get<
      GetSpecNodeHistoryResponses,
      GetSpecNodeHistoryErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/spec/nodes/{key}/history",
      ...options,
    });
  }

  /**
   * Create Spec Node
   */
  public static createSpecNode(options: Options<CreateSpecNodeData, true>) {
    return (options.client ?? client).post<
      CreateSpecNodeResponses,
      CreateSpecNodeErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/spec/nodes",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Spec Node
   */
  public static deleteSpecNode(options: Options<DeleteSpecNodeData, true>) {
    return (options.client ?? client).delete<
      DeleteSpecNodeResponses,
      DeleteSpecNodeErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/spec/nodes/{key}",
      ...options,
    });
  }

  /**
   * Patch Spec Node
   */
  public static patchSpecNode(options: Options<PatchSpecNodeData, true>) {
    return (options.client ?? client).patch<
      PatchSpecNodeResponses,
      PatchSpecNodeErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/spec/nodes/{key}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Move Spec Node
   */
  public static moveSpecNode(options: Options<MoveSpecNodeData, true>) {
    return (options.client ?? client).post<
      MoveSpecNodeResponses,
      MoveSpecNodeErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/spec/nodes/{key}/move",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Create Spec Case
   */
  public static createSpecCase(options: Options<CreateSpecCaseData, true>) {
    return (options.client ?? client).post<
      CreateSpecCaseResponses,
      CreateSpecCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/spec/cases",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Spec Case
   */
  public static deleteSpecCase(options: Options<DeleteSpecCaseData, true>) {
    return (options.client ?? client).delete<
      DeleteSpecCaseResponses,
      DeleteSpecCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/spec/cases/{key}",
      ...options,
    });
  }

  /**
   * Patch Spec Case
   */
  public static patchSpecCase(options: Options<PatchSpecCaseData, true>) {
    return (options.client ?? client).patch<
      PatchSpecCaseResponses,
      PatchSpecCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/spec/cases/{key}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class PaymentsService {
  /**
   * Get License Data
   */
  public static getLicenseData(options?: Options<GetLicenseDataData, true>) {
    return (options?.client ?? client).get<
      GetLicenseDataResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/license",
      ...options,
    });
  }

  /**
   * Get All Invoices
   */
  public static getAllInvoices(options?: Options<GetAllInvoicesData, true>) {
    return (options?.client ?? client).get<
      GetAllInvoicesResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/payments/invoices",
      ...options,
    });
  }

  /**
   * Create Stripe Customer
   */
  public static createStripeCustomer(
    options?: Options<CreateStripeCustomerData, true>
  ) {
    return (options?.client ?? client).post<
      CreateStripeCustomerResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/payment/stripe/customer",
      ...options,
    });
  }

  /**
   * Cancel Subscription Cancelation
   */
  public static cancelSubscriptionCancelation(
    options?: Options<CancelSubscriptionCancelationData, true>
  ) {
    return (options?.client ?? client).post<
      CancelSubscriptionCancelationResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/payment/stripe/subscription/uncancel",
      ...options,
    });
  }

  /**
   * Create Checkout Session
   */
  public static createCheckoutSession(
    options: Options<CreateCheckoutSessionData, true>
  ) {
    return (options.client ?? client).post<
      CreateCheckoutSessionResponses,
      CreateCheckoutSessionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/payment/stripe/create-checkout-session",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Create Billing Portal Session
   */
  public static createBillingPortalSession(
    options?: Options<CreateBillingPortalSessionData, true>
  ) {
    return (options?.client ?? client).post<
      CreateBillingPortalSessionResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/payment/stripe/create-billing-portal-session",
      ...options,
    });
  }

  /**
   * Create Payasyougo Checkout Session
   */
  public static createPayasyougoCheckoutSession(
    options?: Options<CreatePayasyougoCheckoutSessionData, true>
  ) {
    return (options?.client ?? client).post<
      CreatePayasyougoCheckoutSessionResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/payment/stripe/create-pay-as-you-go-checkout-session",
      ...options,
    });
  }

  /**
   * Webhook Checkout Completed
   */
  public static webhookCheckoutCompleted(
    options?: Options<WebhookCheckoutCompletedData, true>
  ) {
    return (options?.client ?? client).post<
      WebhookCheckoutCompletedResponses,
      unknown,
      true
    >({
      responseType: "json",
      url: "/payment/stripe/webhook-checkout-completed",
      ...options,
    });
  }

  /**
   * Webhook Subscription Updated
   */
  public static webhookSubscriptionUpdated(
    options: Options<WebhookSubscriptionUpdatedData, true>
  ) {
    return (options.client ?? client).post<
      WebhookSubscriptionUpdatedResponses,
      WebhookSubscriptionUpdatedErrors,
      true
    >({
      responseType: "json",
      url: "/payment/stripe/webhook-subscription-updated",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class BillingService {
  /**
   * Get Billing Information
   */
  public static getBillingInformation(
    options?: Options<GetBillingInformationData, true>
  ) {
    return (options?.client ?? client).get<
      GetBillingInformationResponses,
      GetBillingInformationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/billing",
      ...options,
    });
  }

  /**
   * Get Billing Currency
   */
  public static getBillingCurrency(
    options?: Options<GetBillingCurrencyData, true>
  ) {
    return (options?.client ?? client).get<
      GetBillingCurrencyResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/billing/currency",
      ...options,
    });
  }

  /**
   * Open Stripe Billing Portal
   */
  public static openStripeBillingPortal(
    options?: Options<OpenStripeBillingPortalData, true>
  ) {
    return (options?.client ?? client).post<
      OpenStripeBillingPortalResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/billing/stripe",
      ...options,
    });
  }

  /**
   * Upgrade Tenant Subscription
   */
  public static upgradeTenantSubscription(
    options: Options<UpgradeTenantSubscriptionData, true>
  ) {
    return (options.client ?? client).post<
      UpgradeTenantSubscriptionResponses,
      UpgradeTenantSubscriptionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/billing/upgrade",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Limits
   */
  public static getLimits(options?: Options<GetLimitsData, true>) {
    return (options?.client ?? client).get<GetLimitsResponses, unknown, true>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/billing/limits",
      ...options,
    });
  }

  /**
   * Add Limit
   */
  public static addLimit(options: Options<AddLimitData, true>) {
    return (options.client ?? client).post<
      AddLimitResponses,
      AddLimitErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/billing/limits",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Limit Providers
   */
  public static getLimitProviders(
    options?: Options<GetLimitProvidersData, true>
  ) {
    return (options?.client ?? client).get<
      GetLimitProvidersResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/billing/limits/providers",
      ...options,
    });
  }

  /**
   * Get Limit Usage
   */
  public static getLimitUsage(options?: Options<GetLimitUsageData, true>) {
    return (options?.client ?? client).get<
      GetLimitUsageResponses,
      GetLimitUsageErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/billing/limits/usage",
      ...options,
    });
  }

  /**
   * Delete Limit
   */
  public static deleteLimit(options: Options<DeleteLimitData, true>) {
    return (options.client ?? client).delete<
      DeleteLimitResponses,
      DeleteLimitErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/billing/limits/{limit_id}",
      ...options,
    });
  }

  /**
   * Update Limit
   */
  public static updateLimit(options: Options<UpdateLimitData, true>) {
    return (options.client ?? client).put<
      UpdateLimitResponses,
      UpdateLimitErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/billing/limits/{limit_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Payments
   */
  public static getPayments(options?: Options<GetPaymentsData, true>) {
    return (options?.client ?? client).get<GetPaymentsResponses, unknown, true>(
      {
        responseType: "json",
        security: [{ scheme: "bearer", type: "http" }],
        url: "/billing/payments",
        ...options,
      }
    );
  }
}

export class AuthService {
  /**
   * Get Connections
   *
   * Fetches the Auth0 connections enabled for this application, categorised
   * by type (password, social, enterprise). Cached for 5 minutes; when Auth0
   * is unavailable or rate-limits us the last successful answer is served.
   */
  public static getConnections(options?: Options<GetConnectionsData, true>) {
    return (options?.client ?? client).get<
      GetConnectionsResponses,
      unknown,
      true
    >({
      responseType: "json",
      url: "/auth/custom/connections",
      ...options,
    });
  }

  /**
   * Get Connections
   *
   * Fetches the Auth0 connections enabled for this application, categorised
   * by type (password, social, enterprise). Cached for 5 minutes; when Auth0
   * is unavailable or rate-limits us the last successful answer is served.
   */
  public static getConnections2(options?: Options<GetConnectionsData, true>) {
    return (options?.client ?? client).get<
      GetConnectionsResponses,
      unknown,
      true
    >({
      responseType: "json",
      url: "/auth/custom/connections",
      ...options,
    });
  }

  /**
   * Login
   *
   * Custom login endpoint using Auth0's Resource Owner Password Grant.
   *
   * Note: ROPG must be enabled in your Auth0 tenant and application settings.
   * The connection must support password authentication (Database connection).
   */
  public static login(options: Options<LoginData, true>) {
    return (options.client ?? client).post<LoginResponses, LoginErrors, true>({
      responseType: "json",
      url: "/auth/custom/login",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Login
   *
   * Custom login endpoint using Auth0's Resource Owner Password Grant.
   *
   * Note: ROPG must be enabled in your Auth0 tenant and application settings.
   * The connection must support password authentication (Database connection).
   */
  public static login2(options: Options<LoginData, true>) {
    return (options.client ?? client).post<LoginResponses, LoginErrors, true>({
      responseType: "json",
      url: "/auth/custom/login",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Signup
   *
   * Custom signup endpoint using Auth0's Database signup endpoint.
   * Creates a new user in the specified database connection.
   */
  public static signup(options: Options<SignupData, true>) {
    return (options.client ?? client).post<SignupResponses, SignupErrors, true>(
      {
        responseType: "json",
        url: "/auth/custom/signup",
        ...options,
        headers: {
          "Content-Type": "application/json",
          ...options.headers,
        },
      }
    );
  }

  /**
   * Signup
   *
   * Custom signup endpoint using Auth0's Database signup endpoint.
   * Creates a new user in the specified database connection.
   */
  public static signup2(options: Options<SignupData, true>) {
    return (options.client ?? client).post<SignupResponses, SignupErrors, true>(
      {
        responseType: "json",
        url: "/auth/custom/signup",
        ...options,
        headers: {
          "Content-Type": "application/json",
          ...options.headers,
        },
      }
    );
  }

  /**
   * Forgot Password
   *
   * Initiates password reset flow via Auth0.
   * Sends a password reset email to the specified address.
   */
  public static forgotPassword(options: Options<ForgotPasswordData, true>) {
    return (options.client ?? client).post<
      ForgotPasswordResponses,
      ForgotPasswordErrors,
      true
    >({
      responseType: "json",
      url: "/auth/custom/forgot-password",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Forgot Password
   *
   * Initiates password reset flow via Auth0.
   * Sends a password reset email to the specified address.
   */
  public static forgotPassword2(options: Options<ForgotPasswordData, true>) {
    return (options.client ?? client).post<
      ForgotPasswordResponses,
      ForgotPasswordErrors,
      true
    >({
      responseType: "json",
      url: "/auth/custom/forgot-password",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Check Email Verification
   *
   * Checks if a user's email has been verified in Auth0.
   * Requires the Auth0 user ID.
   */
  public static checkEmailVerification(
    options: Options<CheckEmailVerificationData, true>
  ) {
    return (options.client ?? client).post<
      CheckEmailVerificationResponses,
      CheckEmailVerificationErrors,
      true
    >({
      responseType: "json",
      url: "/auth/custom/email-verification-status",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Check Email Verification
   *
   * Checks if a user's email has been verified in Auth0.
   * Requires the Auth0 user ID.
   */
  public static checkEmailVerification2(
    options: Options<CheckEmailVerificationData, true>
  ) {
    return (options.client ?? client).post<
      CheckEmailVerificationResponses,
      CheckEmailVerificationErrors,
      true
    >({
      responseType: "json",
      url: "/auth/custom/email-verification-status",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class AuthConfigService {
  /**
   * Email Config
   */
  public static emailConfig(options?: Options<EmailConfigData, true>) {
    return (options?.client ?? client).get<EmailConfigResponses, unknown, true>(
      {
        responseType: "json",
        url: "/auth/email/config",
        ...options,
      }
    );
  }

  /**
   * Send Auth Email
   */
  public static sendAuthEmail(options?: Options<SendAuthEmailData, true>) {
    return (options?.client ?? client).post<
      SendAuthEmailResponses,
      unknown,
      true
    >({
      responseType: "json",
      url: "/auth/email/send",
      ...options,
    });
  }

  /**
   * Auth Bootstrap Status
   */
  public static authBootstrapStatus(
    options?: Options<AuthBootstrapStatusData, true>
  ) {
    return (options?.client ?? client).get<
      AuthBootstrapStatusResponses,
      unknown,
      true
    >({
      responseType: "json",
      url: "/auth/bootstrap",
      ...options,
    });
  }

  /**
   * Get Welcome Auth Config
   *
   * Public, unauthenticated subset of auth config used by the welcome screens
   * (login / signup / forgot-password / onboarding). Operational fields
   * (autojoin_tenant_id, saml_attribute_mapping, redirect_map, session policy)
   * are intentionally omitted — those live behind the admin-only endpoint
   * below.
   */
  public static getWelcomeAuthConfig(
    options?: Options<GetWelcomeAuthConfigData, true>
  ) {
    return (options?.client ?? client).get<
      GetWelcomeAuthConfigResponses,
      unknown,
      true
    >({
      responseType: "json",
      url: "/auth/welcome-config",
      ...options,
    });
  }

  /**
   * Get Auth Config
   *
   * Full auth configuration — admin only. Includes saml_attribute_mapping
   * (with internal role UUIDs), session policy, redirect map, etc. Public
   * callers should hit /auth/welcome-config instead.
   */
  public static getAuthConfig(options?: Options<GetAuthConfigData, true>) {
    return (options?.client ?? client).get<
      GetAuthConfigResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/auth/config",
      ...options,
    });
  }

  /**
   * Update Auth Config
   *
   * Create or update auth configuration (admin only).
   */
  public static updateAuthConfig(options: Options<UpdateAuthConfigData, true>) {
    return (options.client ?? client).post<
      UpdateAuthConfigResponses,
      UpdateAuthConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/auth/config",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Legacy Auth Users
   *
   * Read-only source for the Better Auth import; never rewrite platform users.
   */
  public static legacyAuthUsers(options?: Options<LegacyAuthUsersData, true>) {
    return (options?.client ?? client).get<
      LegacyAuthUsersResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/auth/migration/users",
      ...options,
    });
  }

  /**
   * Get Oidc Sync Status
   *
   * Check whether the configured Auth0 OIDC connection currently exists (admin only).
   */
  public static getOidcSyncStatus(
    options?: Options<GetOidcSyncStatusData, true>
  ) {
    return (options?.client ?? client).get<
      GetOidcSyncStatusResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/auth/config/oidc/sync",
      ...options,
    });
  }

  /**
   * Sync Oidc Connection
   *
   * Create or update the Auth0 OIDC connection from env vars (admin only).
   * Unlike boot-time bootstrap, this endpoint PATCHes an existing connection
   * to re-sync credentials and options.
   */
  public static syncOidcConnection(
    options?: Options<SyncOidcConnectionData, true>
  ) {
    return (options?.client ?? client).post<
      SyncOidcConnectionResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/auth/config/oidc/sync",
      ...options,
    });
  }

  /**
   * Get Redirect Url
   *
   * Get redirect URL based on current domain (helper endpoint).
   */
  public static getRedirectUrl(options?: Options<GetRedirectUrlData, true>) {
    return (options?.client ?? client).get<
      GetRedirectUrlResponses,
      unknown,
      true
    >({
      responseType: "json",
      url: "/auth/config/redirect",
      ...options,
    });
  }

  /**
   * Auth Runtime
   */
  public static authRuntime(options?: Options<AuthRuntimeData, true>) {
    return (options?.client ?? client).get<AuthRuntimeResponses, unknown, true>(
      {
        responseType: "json",
        url: "/auth/runtime",
        ...options,
      }
    );
  }

  /**
   * Change Auth Runtime
   */
  public static changeAuthRuntime(
    options: Options<ChangeAuthRuntimeData, true>
  ) {
    return (options.client ?? client).post<
      ChangeAuthRuntimeResponses,
      ChangeAuthRuntimeErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/auth/migration/state",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Migration Identity
   */
  public static migrationIdentity(
    options?: Options<MigrationIdentityData, true>
  ) {
    return (options?.client ?? client).get<
      MigrationIdentityResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/auth/migration/identity",
      ...options,
    });
  }

  /**
   * Migration Connections
   */
  public static migrationConnections(
    options?: Options<MigrationConnectionsData, true>
  ) {
    return (options?.client ?? client).get<
      MigrationConnectionsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/auth/migration/connections",
      ...options,
    });
  }

  /**
   * Review Auth0 Emails
   */
  public static reviewAuth0Emails(
    options?: Options<ReviewAuth0EmailsData, true>
  ) {
    return (options?.client ?? client).get<
      ReviewAuth0EmailsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/auth/migration/emails",
      ...options,
    });
  }

  /**
   * Update Auth0 Emails
   */
  public static updateAuth0Emails(
    options: Options<UpdateAuth0EmailsData, true>
  ) {
    return (options.client ?? client).post<
      UpdateAuth0EmailsResponses,
      UpdateAuth0EmailsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/auth/migration/emails",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class ProvidersService {
  /**
   * List Provider Definitions
   */
  public static listProviderDefinitions(
    options: Options<ListProviderDefinitionsData, true>
  ) {
    return (options.client ?? client).get<
      ListProviderDefinitionsResponses,
      ListProviderDefinitionsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/providers/definitions",
      ...options,
    });
  }

  /**
   * List Providers
   */
  public static listProviders(options: Options<ListProvidersData, true>) {
    return (options.client ?? client).get<
      ListProvidersResponses,
      ListProvidersErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/providers",
      ...options,
    });
  }

  /**
   * Create Provider
   */
  public static createProvider(options: Options<CreateProviderData, true>) {
    return (options.client ?? client).post<
      CreateProviderResponses,
      CreateProviderErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/providers",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Provider
   */
  public static deleteProvider(options: Options<DeleteProviderData, true>) {
    return (options.client ?? client).delete<
      DeleteProviderResponses,
      DeleteProviderErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/providers/{provider_id}",
      ...options,
    });
  }

  /**
   * Get Provider
   */
  public static getProvider(options: Options<GetProviderData, true>) {
    return (options.client ?? client).get<
      GetProviderResponses,
      GetProviderErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/providers/{provider_id}",
      ...options,
    });
  }

  /**
   * Update Provider
   */
  public static updateProvider(options: Options<UpdateProviderData, true>) {
    return (options.client ?? client).patch<
      UpdateProviderResponses,
      UpdateProviderErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/providers/{provider_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Deactivate Provider
   */
  public static deactivateProvider(
    options: Options<DeactivateProviderData, true>
  ) {
    return (options.client ?? client).patch<
      DeactivateProviderResponses,
      DeactivateProviderErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/providers/{provider_id}/deactivate",
      ...options,
    });
  }

  /**
   * Activate Provider
   */
  public static activateProvider(options: Options<ActivateProviderData, true>) {
    return (options.client ?? client).patch<
      ActivateProviderResponses,
      ActivateProviderErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/providers/{provider_id}/activate",
      ...options,
    });
  }

  /**
   * Add Provider Region
   *
   * Add a region to a provider's regions.
   */
  public static addProviderRegion(
    options: Options<AddProviderRegionData, true>
  ) {
    return (options.client ?? client).post<
      AddProviderRegionResponses,
      AddProviderRegionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/providers/{provider_id}/regions",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Test Provider Connection
   *
   * Test a provider's connection via pipeline and record health result.
   *
   * Returns step-by-step results for the frontend timeline. The response
   * model is concrete (not ``dict[str, JsonValue]``) so the OpenAPI
   * schema carries the step shape and the FE picks it up via
   * ``ProviderTestResponse`` instead of hand-mirroring the interface.
   */
  public static testProviderConnection(
    options: Options<TestProviderConnectionData, true>
  ) {
    return (options.client ?? client).post<
      TestProviderConnectionResponses,
      TestProviderConnectionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/providers/{provider_id}/test",
      ...options,
    });
  }

  /**
   * Test All Models
   *
   * Test all models linked to a provider.
   */
  public static testAllModels(options: Options<TestAllModelsData, true>) {
    return (options.client ?? client).post<
      TestAllModelsResponses,
      TestAllModelsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/providers/{provider_id}/test-all",
      ...options,
    });
  }
}

export class ModelConfigurationsService {
  /**
   * List Model Configurations
   *
   * List all model configurations with provider links (admin view).
   */
  public static listModelConfigurations(
    options: Options<ListModelConfigurationsData, true>
  ) {
    return (options.client ?? client).get<
      ListModelConfigurationsResponses,
      ListModelConfigurationsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/configurations",
      ...options,
    });
  }

  /**
   * Create Custom Model Configuration
   *
   * Add a model served by one of this tenant's OpenAI-compatible providers.
   *
   * The slug is checked against the live endpoint before the model goes live.
   * One that fails is still added, with its link off and the failure as the
   * link's error, so the model stays listed and editable and opening it says
   * why it is not running.
   */
  public static createCustomModelConfiguration(
    options: Options<CreateCustomModelConfigurationData, true>
  ) {
    return (options.client ?? client).post<
      CreateCustomModelConfigurationResponses,
      CreateCustomModelConfigurationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/configurations",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Custom Model Configuration
   *
   * Remove a model this tenant added. Built-in models are not deletable —
   * the service scopes the statement to tenant-owned rows, so asking to delete
   * one 404s rather than doing nothing quietly.
   */
  public static deleteCustomModelConfiguration(
    options: Options<DeleteCustomModelConfigurationData, true>
  ) {
    return (options.client ?? client).delete<
      DeleteCustomModelConfigurationResponses,
      DeleteCustomModelConfigurationErrors,
      true
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/configurations/{model_id}",
      ...options,
    });
  }

  /**
   * Update Model Configuration
   *
   * Update model visibility.
   */
  public static updateModelConfiguration(
    options: Options<UpdateModelConfigurationData, true>
  ) {
    return (options.client ?? client).put<
      UpdateModelConfigurationResponses,
      UpdateModelConfigurationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/configurations/{model_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Price References
   *
   * Published prices matching *q*, best match first.
   *
   * Lets a custom model be billed from a known model's rates instead of
   * hand-typed numbers — the reference stays live, so vendor price changes are
   * picked up rather than frozen at whatever was true when the model was added.
   */
  public static listPriceReferences(
    options: Options<ListPriceReferencesData, true>
  ) {
    return (options.client ?? client).get<
      ListPriceReferencesResponses,
      ListPriceReferencesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/price-references",
      ...options,
    });
  }

  /**
   * Update Custom Model Configuration
   *
   * Edit a model this tenant added. The slug is re-verified when it changes.
   */
  public static updateCustomModelConfiguration(
    options: Options<UpdateCustomModelConfigurationData, true>
  ) {
    return (options.client ?? client).put<
      UpdateCustomModelConfigurationResponses,
      UpdateCustomModelConfigurationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/configurations/{model_id}/custom",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Reprice Custom Model Usage
   *
   * Re-cost this workspace's past usage of a custom model at its current
   * price, on the worker. Costs are derived from the stored token counts, so
   * a price fixed after the fact can be applied to what was already billed.
   */
  public static repriceCustomModelUsage(
    options: Options<RepriceCustomModelUsageData, true>
  ) {
    return (options.client ?? client).post<
      RepriceCustomModelUsageResponses,
      RepriceCustomModelUsageErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/configurations/{model_id}/custom/reprice",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Embedding Configurations
   *
   * List all embedding configurations with provider links (admin view).
   */
  public static listEmbeddingConfigurations(
    options: Options<ListEmbeddingConfigurationsData, true>
  ) {
    return (options.client ?? client).get<
      ListEmbeddingConfigurationsResponses,
      ListEmbeddingConfigurationsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/embeddings/configurations",
      ...options,
    });
  }

  /**
   * Update Embedding Configuration
   *
   * Update embedding visibility.
   */
  public static updateEmbeddingConfiguration(
    options: Options<UpdateEmbeddingConfigurationData, true>
  ) {
    return (options.client ?? client).put<
      UpdateEmbeddingConfigurationResponses,
      UpdateEmbeddingConfigurationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/embeddings/configurations/{embedding_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Reranker Configurations
   *
   * List all reranker configurations with provider links (admin view).
   */
  public static listRerankerConfigurations(
    options: Options<ListRerankerConfigurationsData, true>
  ) {
    return (options.client ?? client).get<
      ListRerankerConfigurationsResponses,
      ListRerankerConfigurationsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/rerankers/configurations",
      ...options,
    });
  }

  /**
   * List Decision Model Configurations
   */
  public static listDecisionModelConfigurations(
    options: Options<ListDecisionModelConfigurationsData, true>
  ) {
    return (options.client ?? client).get<
      ListDecisionModelConfigurationsResponses,
      ListDecisionModelConfigurationsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/decision-models/configurations",
      ...options,
    });
  }

  /**
   * List Voice Model Configurations
   */
  public static listVoiceModelConfigurations(
    options: Options<ListVoiceModelConfigurationsData, true>
  ) {
    return (options.client ?? client).get<
      ListVoiceModelConfigurationsResponses,
      ListVoiceModelConfigurationsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/voice-models/configurations",
      ...options,
    });
  }

  /**
   * Create Provider Link
   *
   * Link a provider to a model or embedding: on if its check passes, off with the reason if not.
   */
  public static createProviderLink(
    options: Options<CreateProviderLinkData, true>
  ) {
    return (options.client ?? client).post<
      CreateProviderLinkResponses,
      CreateProviderLinkErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/provider-links",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Run Health Checks
   *
   * Run health checks on all active provider links.
   *
   * Routes through ``ModelLifecycleService.run_link_health_checks`` —
   * same code path the worker uses for the periodic lifecycle task. The
   * legacy duplicate that lived on ``ModelService`` was deleted; this
   * keeps the API and the worker on a single implementation.
   */
  public static runHealthChecks(options: Options<RunHealthChecksData, true>) {
    return (options.client ?? client).post<
      RunHealthChecksResponses,
      RunHealthChecksErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/provider-links/health-check",
      ...options,
    });
  }

  /**
   * Chaos Test Enabled
   *
   * Return whether chaos testing is currently allowed for the calling user.
   *
   * Read by the FE to decide whether to render the chaos button on the
   * Providers / Models / Embeddings pages. Combines:
   * - DEPLOYMENT_ENV=local (always on for local dev)
   * - the platform-wide toggle (set via Admin → Admin Actions)
   *
   * Noxus admins separately see the button via their email check on the FE,
   * so they don't need this endpoint to return True for themselves.
   */
  public static chaosTestEnabled(options: Options<ChaosTestEnabledData, true>) {
    return (options.client ?? client).get<
      ChaosTestEnabledResponses,
      ChaosTestEnabledErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/provider-links/chaos-test/enabled",
      ...options,
    });
  }

  /**
   * Chaos Test Links
   *
   * Simulate random health check outcomes on all links.
   *
   * Randomly succeeds/fails each active link, writes results to DB,
   * then runs evaluate_link_states() to trigger state transitions.
   *
   * Gate: local dev OR the platform-wide ``chaos_testing_enabled`` toggle
   * is on. The toggle is the single source of truth on non-local deploys
   * — there's no admin bypass, so flipping it off in Admin → Admin
   * Actions immediately disables chaos testing for everyone (Noxus admins
   * included).
   */
  public static chaosTestLinks(options: Options<ChaosTestLinksData, true>) {
    return (options.client ?? client).post<
      ChaosTestLinksResponses,
      ChaosTestLinksErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/provider-links/chaos-test",
      ...options,
    });
  }

  /**
   * Delete Provider Link
   *
   * Remove a provider link.
   */
  public static deleteProviderLink(
    options: Options<DeleteProviderLinkData, true>
  ) {
    return (options.client ?? client).delete<
      DeleteProviderLinkResponses,
      DeleteProviderLinkErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/provider-links/{link_id}",
      ...options,
    });
  }

  /**
   * Update Provider Link
   *
   * Update a provider link (priority, active, overrides).
   */
  public static updateProviderLink(
    options: Options<UpdateProviderLinkData, true>
  ) {
    return (options.client ?? client).put<
      UpdateProviderLinkResponses,
      UpdateProviderLinkErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/provider-links/{link_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Test Provider Link
   *
   * Test a provider link's connection and billing, recording the result.
   */
  public static testProviderLink(options: Options<TestProviderLinkData, true>) {
    return (options.client ?? client).post<
      TestProviderLinkResponses,
      TestProviderLinkErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/provider-links/{link_id}/test",
      ...options,
    });
  }

  /**
   * Stream Test Batch
   *
   * Stream test results for a batch of provider links and providers over SSE.
   *
   * One event per pipeline stage (`stage`), one terminal `result` event per
   * target, one final `done`. Replaces the FE pattern of N concurrent POSTs
   * with a single multiplexed stream.
   *
   * Frame format:
   * event: stage   data: {target_type, target_id, stage, ts, message?}
   * event: result  data: {target_type, target_id, status, message,
   * latency_seconds, ...full ModelTestResult|pipeline}
   * event: done    data: {}
   *
   * Concurrency is capped at ``_STREAM_CONCURRENCY`` so a 50-link batch
   * doesn't fan out into 50 simultaneous LLM calls. Each link/provider
   * test still respects its existing per-target 30s timeout.
   */
  public static streamTestBatch(options: Options<StreamTestBatchData, true>) {
    return (options.client ?? client).get<
      StreamTestBatchResponses,
      StreamTestBatchErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/provider-links/test/stream",
      ...options,
    });
  }
}

export class CaseManagementService {
  /**
   * List Inboxes
   *
   * List all inboxes in the group with pagination.
   */
  public static listInboxes(options: Options<ListInboxesData, true>) {
    return (options.client ?? client).get<
      ListInboxesResponses,
      ListInboxesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes",
      ...options,
    });
  }

  /**
   * Create Inbox
   */
  public static createInbox(options: Options<CreateInboxData, true>) {
    return (options.client ?? client).post<
      CreateInboxResponses,
      CreateInboxErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Check Slug
   *
   * Check if a slug is available platform-wide.
   */
  public static checkSlug(options: Options<CheckSlugData, true>) {
    return (options.client ?? client).get<
      CheckSlugResponses,
      CheckSlugErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/check-slug",
      ...options,
    });
  }

  /**
   * Check Prefix
   *
   * Check if a case prefix is available within the group.
   */
  public static checkPrefix(options: Options<CheckPrefixData, true>) {
    return (options.client ?? client).get<
      CheckPrefixResponses,
      CheckPrefixErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/check-prefix",
      ...options,
    });
  }

  /**
   * Delete Inbox
   *
   * Delete an inbox.
   */
  public static deleteInbox(options: Options<DeleteInboxData, true>) {
    return (options.client ?? client).delete<
      DeleteInboxResponses,
      DeleteInboxErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}",
      ...options,
    });
  }

  /**
   * Get Inbox
   *
   * Get a specific inbox by ID.
   */
  public static getInbox(options: Options<GetInboxData, true>) {
    return (options.client ?? client).get<
      GetInboxResponses,
      GetInboxErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}",
      ...options,
    });
  }

  /**
   * Update Inbox
   */
  public static updateInbox(options: Options<UpdateInboxData, true>) {
    return (options.client ?? client).put<
      UpdateInboxResponses,
      UpdateInboxErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Update Inbox Case Layout
   *
   * Set or clear the case-view field layout for an inbox.
   *
   * Saving a layout atomically syncs field group/order with it; a null
   * layout restores auto-placement.
   */
  public static updateInboxCaseLayout(
    options: Options<UpdateInboxCaseLayoutData, true>
  ) {
    return (options.client ?? client).put<
      UpdateInboxCaseLayoutResponses,
      UpdateInboxCaseLayoutErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}/case-layout",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Rename Inbox Group
   *
   * Rename a field group, atomically retitling its case-layout section.
   */
  public static renameInboxGroup(options: Options<RenameInboxGroupData, true>) {
    return (options.client ?? client).post<
      RenameInboxGroupResponses,
      RenameInboxGroupErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}/groups/rename",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Export Inbox
   */
  public static exportInbox(options: Options<ExportInboxData, true>) {
    return (options.client ?? client).post<
      ExportInboxResponses,
      ExportInboxErrors,
      true
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}/export",
      ...options,
    });
  }

  /**
   * Export Inbox Preview
   */
  public static exportInboxPreview(
    options: Options<ExportInboxPreviewData, true>
  ) {
    return (options.client ?? client).post<
      ExportInboxPreviewResponses,
      ExportInboxPreviewErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}/export/preview",
      ...options,
    });
  }

  /**
   * Import Inbox
   */
  public static importInbox(options: Options<ImportInboxData, true>) {
    return (options.client ?? client).post<
      ImportInboxResponses,
      ImportInboxErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/import",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Inbox Templates
   */
  public static listInboxTemplates(
    options: Options<ListInboxTemplatesData, true>
  ) {
    return (options.client ?? client).get<
      ListInboxTemplatesResponses,
      ListInboxTemplatesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inbox-templates",
      ...options,
    });
  }

  /**
   * Get Inbox Template Config
   */
  public static getInboxTemplateConfig(
    options: Options<GetInboxTemplateConfigData, true>
  ) {
    return (options.client ?? client).post<
      GetInboxTemplateConfigResponses,
      GetInboxTemplateConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inbox-templates/{template_id}/config",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Deploy Inbox Template
   */
  public static deployInboxTemplate(
    options: Options<DeployInboxTemplateData, true>
  ) {
    return (options.client ?? client).post<
      DeployInboxTemplateResponses,
      DeployInboxTemplateErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inbox-templates/{template_id}/deploy",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Create Inbox Field
   *
   * Create a new inbox field.
   */
  public static createInboxField(options: Options<CreateInboxFieldData, true>) {
    return (options.client ?? client).post<
      CreateInboxFieldResponses,
      CreateInboxFieldErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}/inbox-fields",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Inbox Field
   *
   * Delete an inbox field.
   */
  public static deleteInboxField(options: Options<DeleteInboxFieldData, true>) {
    return (options.client ?? client).delete<
      DeleteInboxFieldResponses,
      DeleteInboxFieldErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inbox-fields/{field_id}",
      ...options,
    });
  }

  /**
   * Update Inbox Field
   *
   * Update an existing inbox field.
   */
  public static updateInboxField(options: Options<UpdateInboxFieldData, true>) {
    return (options.client ?? client).put<
      UpdateInboxFieldResponses,
      UpdateInboxFieldErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inbox-fields/{field_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Cases
   */
  public static listCases(options: Options<ListCasesData, true>) {
    return (options.client ?? client).get<
      ListCasesResponses,
      ListCasesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases",
      ...options,
    });
  }

  /**
   * Create Case
   *
   * Create a new case, optionally linked to a conversation.
   */
  public static createCase(options: Options<CreateCaseData, true>) {
    return (options.client ?? client).post<
      CreateCaseResponses,
      CreateCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Case
   *
   * Delete a case.
   */
  public static deleteCase(options: Options<DeleteCaseData, true>) {
    return (options.client ?? client).delete<
      DeleteCaseResponses,
      DeleteCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases/{case_id}",
      ...options,
    });
  }

  /**
   * Get Case
   *
   * Get a specific case by ID.
   */
  public static getCase(options: Options<GetCaseData, true>) {
    return (options.client ?? client).get<
      GetCaseResponses,
      GetCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases/{case_id}",
      ...options,
    });
  }

  /**
   * Update Case
   *
   * Update an existing case.
   */
  public static updateCase(options: Options<UpdateCaseData, true>) {
    return (options.client ?? client).put<
      UpdateCaseResponses,
      UpdateCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases/{case_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Simulate Email
   *
   * Push a fake inbound email through the inbox pipeline.
   *
   * Multipart so the dashboard's "Simulate email" can attach files the same
   * way the real webhook does. Returns ``None`` if filtering excluded the
   * synthetic email. Mirrors `create_case` and uses `CaseCreateResponse`
   * (no relationships) so we don't trigger async lazy-loads.
   */
  public static simulateEmail(options: Options<SimulateEmailData, true>) {
    return (options.client ?? client).post<
      SimulateEmailResponses,
      SimulateEmailErrors,
      true
    >({
      ...formDataBodySerializer,
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}/simulate-email",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });
  }

  /**
   * Delete All Cases
   *
   * Delete all cases for a specific inbox.
   */
  public static deleteAllCases(options: Options<DeleteAllCasesData, true>) {
    return (options.client ?? client).delete<
      DeleteAllCasesResponses,
      DeleteAllCasesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}/cases",
      ...options,
    });
  }

  /**
   * Clone Case
   */
  public static cloneCase(options: Options<CloneCaseData, true>) {
    return (options.client ?? client).post<
      CloneCaseResponses,
      CloneCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases/{case_id}/clone",
      ...options,
    });
  }

  /**
   * Move Case
   *
   * Move a case to a different inbox.
   */
  public static moveCase(options: Options<MoveCaseData, true>) {
    return (options.client ?? client).post<
      MoveCaseResponses,
      MoveCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases/{case_id}/move",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Reprocess Case
   *
   * Reopen the case and re-run the pipeline (extraction → process) on its
   * original email — e.g. to force-open a case the filter excluded.
   */
  public static reprocessCase(options: Options<ReprocessCaseData, true>) {
    return (options.client ?? client).post<
      ReprocessCaseResponses,
      ReprocessCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases/{case_id}/reprocess",
      ...options,
    });
  }

  /**
   * Link Conversation To Case
   *
   * Link a conversation to an existing case.
   */
  public static linkConversationToCase(
    options: Options<LinkConversationToCaseData, true>
  ) {
    return (options.client ?? client).post<
      LinkConversationToCaseResponses,
      LinkConversationToCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases/{case_id}/link-conversation",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Tasks
   */
  public static listTasks(options: Options<ListTasksData, true>) {
    return (options.client ?? client).get<
      ListTasksResponses,
      ListTasksErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tasks",
      ...options,
    });
  }

  /**
   * Get Task
   */
  public static getTask(options: Options<GetTaskData, true>) {
    return (options.client ?? client).get<
      GetTaskResponses,
      GetTaskErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tasks/{task_id}",
      ...options,
    });
  }

  /**
   * Update Task
   */
  public static updateTask(options: Options<UpdateTaskData, true>) {
    return (options.client ?? client).patch<
      UpdateTaskResponses,
      UpdateTaskErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tasks/{task_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class CaseManagementService2 {
  /**
   * List Inboxes
   *
   * List all inboxes in the group with pagination.
   */
  public static listInboxes(options: Options<ListInboxesData, true>) {
    return (options.client ?? client).get<
      ListInboxesResponses,
      ListInboxesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes",
      ...options,
    });
  }

  /**
   * Create Inbox
   */
  public static createInbox(options: Options<CreateInboxData, true>) {
    return (options.client ?? client).post<
      CreateInboxResponses,
      CreateInboxErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Check Slug
   *
   * Check if a slug is available platform-wide.
   */
  public static checkSlug(options: Options<CheckSlugData, true>) {
    return (options.client ?? client).get<
      CheckSlugResponses,
      CheckSlugErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/check-slug",
      ...options,
    });
  }

  /**
   * Check Prefix
   *
   * Check if a case prefix is available within the group.
   */
  public static checkPrefix(options: Options<CheckPrefixData, true>) {
    return (options.client ?? client).get<
      CheckPrefixResponses,
      CheckPrefixErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/check-prefix",
      ...options,
    });
  }

  /**
   * Delete Inbox
   *
   * Delete an inbox.
   */
  public static deleteInbox(options: Options<DeleteInboxData, true>) {
    return (options.client ?? client).delete<
      DeleteInboxResponses,
      DeleteInboxErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}",
      ...options,
    });
  }

  /**
   * Get Inbox
   *
   * Get a specific inbox by ID.
   */
  public static getInbox(options: Options<GetInboxData, true>) {
    return (options.client ?? client).get<
      GetInboxResponses,
      GetInboxErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}",
      ...options,
    });
  }

  /**
   * Update Inbox
   */
  public static updateInbox(options: Options<UpdateInboxData, true>) {
    return (options.client ?? client).put<
      UpdateInboxResponses,
      UpdateInboxErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Update Inbox Case Layout
   *
   * Set or clear the case-view field layout for an inbox.
   *
   * Saving a layout atomically syncs field group/order with it; a null
   * layout restores auto-placement.
   */
  public static updateInboxCaseLayout(
    options: Options<UpdateInboxCaseLayoutData, true>
  ) {
    return (options.client ?? client).put<
      UpdateInboxCaseLayoutResponses,
      UpdateInboxCaseLayoutErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}/case-layout",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Rename Inbox Group
   *
   * Rename a field group, atomically retitling its case-layout section.
   */
  public static renameInboxGroup(options: Options<RenameInboxGroupData, true>) {
    return (options.client ?? client).post<
      RenameInboxGroupResponses,
      RenameInboxGroupErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}/groups/rename",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Export Inbox
   */
  public static exportInbox(options: Options<ExportInboxData, true>) {
    return (options.client ?? client).post<
      ExportInboxResponses,
      ExportInboxErrors,
      true
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}/export",
      ...options,
    });
  }

  /**
   * Export Inbox Preview
   */
  public static exportInboxPreview(
    options: Options<ExportInboxPreviewData, true>
  ) {
    return (options.client ?? client).post<
      ExportInboxPreviewResponses,
      ExportInboxPreviewErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}/export/preview",
      ...options,
    });
  }

  /**
   * Import Inbox
   */
  public static importInbox(options: Options<ImportInboxData, true>) {
    return (options.client ?? client).post<
      ImportInboxResponses,
      ImportInboxErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/import",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Inbox Templates
   */
  public static listInboxTemplates(
    options: Options<ListInboxTemplatesData, true>
  ) {
    return (options.client ?? client).get<
      ListInboxTemplatesResponses,
      ListInboxTemplatesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inbox-templates",
      ...options,
    });
  }

  /**
   * Get Inbox Template Config
   */
  public static getInboxTemplateConfig(
    options: Options<GetInboxTemplateConfigData, true>
  ) {
    return (options.client ?? client).post<
      GetInboxTemplateConfigResponses,
      GetInboxTemplateConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inbox-templates/{template_id}/config",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Deploy Inbox Template
   */
  public static deployInboxTemplate(
    options: Options<DeployInboxTemplateData, true>
  ) {
    return (options.client ?? client).post<
      DeployInboxTemplateResponses,
      DeployInboxTemplateErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inbox-templates/{template_id}/deploy",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Create Inbox Field
   *
   * Create a new inbox field.
   */
  public static createInboxField(options: Options<CreateInboxFieldData, true>) {
    return (options.client ?? client).post<
      CreateInboxFieldResponses,
      CreateInboxFieldErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}/inbox-fields",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Inbox Field
   *
   * Delete an inbox field.
   */
  public static deleteInboxField(options: Options<DeleteInboxFieldData, true>) {
    return (options.client ?? client).delete<
      DeleteInboxFieldResponses,
      DeleteInboxFieldErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inbox-fields/{field_id}",
      ...options,
    });
  }

  /**
   * Update Inbox Field
   *
   * Update an existing inbox field.
   */
  public static updateInboxField(options: Options<UpdateInboxFieldData, true>) {
    return (options.client ?? client).put<
      UpdateInboxFieldResponses,
      UpdateInboxFieldErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inbox-fields/{field_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Cases
   */
  public static listCases(options: Options<ListCasesData, true>) {
    return (options.client ?? client).get<
      ListCasesResponses,
      ListCasesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases",
      ...options,
    });
  }

  /**
   * Create Case
   *
   * Create a new case, optionally linked to a conversation.
   */
  public static createCase(options: Options<CreateCaseData, true>) {
    return (options.client ?? client).post<
      CreateCaseResponses,
      CreateCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Case
   *
   * Delete a case.
   */
  public static deleteCase(options: Options<DeleteCaseData, true>) {
    return (options.client ?? client).delete<
      DeleteCaseResponses,
      DeleteCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases/{case_id}",
      ...options,
    });
  }

  /**
   * Get Case
   *
   * Get a specific case by ID.
   */
  public static getCase(options: Options<GetCaseData, true>) {
    return (options.client ?? client).get<
      GetCaseResponses,
      GetCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases/{case_id}",
      ...options,
    });
  }

  /**
   * Update Case
   *
   * Update an existing case.
   */
  public static updateCase(options: Options<UpdateCaseData, true>) {
    return (options.client ?? client).put<
      UpdateCaseResponses,
      UpdateCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases/{case_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Simulate Email
   *
   * Push a fake inbound email through the inbox pipeline.
   *
   * Multipart so the dashboard's "Simulate email" can attach files the same
   * way the real webhook does. Returns ``None`` if filtering excluded the
   * synthetic email. Mirrors `create_case` and uses `CaseCreateResponse`
   * (no relationships) so we don't trigger async lazy-loads.
   */
  public static simulateEmail(options: Options<SimulateEmailData, true>) {
    return (options.client ?? client).post<
      SimulateEmailResponses,
      SimulateEmailErrors,
      true
    >({
      ...formDataBodySerializer,
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}/simulate-email",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });
  }

  /**
   * Delete All Cases
   *
   * Delete all cases for a specific inbox.
   */
  public static deleteAllCases(options: Options<DeleteAllCasesData, true>) {
    return (options.client ?? client).delete<
      DeleteAllCasesResponses,
      DeleteAllCasesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/inboxes/{inbox_id}/cases",
      ...options,
    });
  }

  /**
   * Clone Case
   */
  public static cloneCase(options: Options<CloneCaseData, true>) {
    return (options.client ?? client).post<
      CloneCaseResponses,
      CloneCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases/{case_id}/clone",
      ...options,
    });
  }

  /**
   * Move Case
   *
   * Move a case to a different inbox.
   */
  public static moveCase(options: Options<MoveCaseData, true>) {
    return (options.client ?? client).post<
      MoveCaseResponses,
      MoveCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases/{case_id}/move",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Reprocess Case
   *
   * Reopen the case and re-run the pipeline (extraction → process) on its
   * original email — e.g. to force-open a case the filter excluded.
   */
  public static reprocessCase(options: Options<ReprocessCaseData, true>) {
    return (options.client ?? client).post<
      ReprocessCaseResponses,
      ReprocessCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases/{case_id}/reprocess",
      ...options,
    });
  }

  /**
   * Link Conversation To Case
   *
   * Link a conversation to an existing case.
   */
  public static linkConversationToCase(
    options: Options<LinkConversationToCaseData, true>
  ) {
    return (options.client ?? client).post<
      LinkConversationToCaseResponses,
      LinkConversationToCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/cases/{case_id}/link-conversation",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Tasks
   */
  public static listTasks(options: Options<ListTasksData, true>) {
    return (options.client ?? client).get<
      ListTasksResponses,
      ListTasksErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tasks",
      ...options,
    });
  }

  /**
   * Get Task
   */
  public static getTask(options: Options<GetTaskData, true>) {
    return (options.client ?? client).get<
      GetTaskResponses,
      GetTaskErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tasks/{task_id}",
      ...options,
    });
  }

  /**
   * Update Task
   */
  public static updateTask(options: Options<UpdateTaskData, true>) {
    return (options.client ?? client).patch<
      UpdateTaskResponses,
      UpdateTaskErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tasks/{task_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class PluginsService {
  /**
   * List Plugins
   */
  public static listPlugins(options: Options<ListPluginsData, true>) {
    return (options.client ?? client).get<
      ListPluginsResponses,
      ListPluginsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/plugins",
      ...options,
    });
  }

  /**
   * Create Plugin
   */
  public static createPlugin(options: Options<CreatePluginData, true>) {
    return (options.client ?? client).post<
      CreatePluginResponses,
      CreatePluginErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/plugins",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Marketplace Plugins
   */
  public static listMarketplacePlugins(
    options: Options<ListMarketplacePluginsData, true>
  ) {
    return (options.client ?? client).get<
      ListMarketplacePluginsResponses,
      ListMarketplacePluginsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/plugins/marketplace",
      ...options,
    });
  }

  /**
   * List Plugin Catalog
   */
  public static listPluginCatalog(
    options: Options<ListPluginCatalogData, true>
  ) {
    return (options.client ?? client).get<
      ListPluginCatalogResponses,
      ListPluginCatalogErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/plugins/catalog",
      ...options,
    });
  }

  /**
   * Delete Plugin
   */
  public static deletePlugin(options: Options<DeletePluginData, true>) {
    return (options.client ?? client).delete<
      DeletePluginResponses,
      DeletePluginErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/plugins/{plugin_id}",
      ...options,
    });
  }

  /**
   * Get Plugin
   */
  public static getPlugin(options: Options<GetPluginData, true>) {
    return (options.client ?? client).get<
      GetPluginResponses,
      GetPluginErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/plugins/{plugin_id}",
      ...options,
    });
  }

  /**
   * Reload Plugin
   *
   * Restart plugin on plugin server (full restart)
   */
  public static reloadPlugin(options: Options<ReloadPluginData, true>) {
    return (options.client ?? client).patch<
      ReloadPluginResponses,
      ReloadPluginErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/plugins/{plugin_id}/reload",
      ...options,
    });
  }

  /**
   * Validate Plugin Config
   *
   * Validate plugin configuration without saving
   */
  public static validatePluginConfig(
    options: Options<ValidatePluginConfigData, true>
  ) {
    return (options.client ?? client).post<
      ValidatePluginConfigResponses,
      ValidatePluginConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/plugins/{plugin_id}/config/validate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Update Plugin Config
   *
   * Update plugin configuration with validation
   */
  public static updatePluginConfig(
    options: Options<UpdatePluginConfigData, true>
  ) {
    return (options.client ?? client).patch<
      UpdatePluginConfigResponses,
      UpdatePluginConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/plugins/{plugin_id}/config",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Complete Integration
   */
  public static completeIntegration(
    options: Options<CompleteIntegrationData, true>
  ) {
    return (options.client ?? client).post<
      CompleteIntegrationResponses,
      CompleteIntegrationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/plugins/{plugin_id}/integrations/{name}/complete",
      ...options,
    });
  }

  /**
   * Disconnect Integration
   */
  public static disconnectIntegration(
    options: Options<DisconnectIntegration2Data, true>
  ) {
    return (options.client ?? client).delete<
      DisconnectIntegration2Responses,
      DisconnectIntegration2Errors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/plugins/{plugin_id}/integrations/{name}/disconnect",
      ...options,
    });
  }

  /**
   * Get Plugin Logs
   *
   * Get logs for a specific plugin with optional filtering and search
   */
  public static getPluginLogs(options: Options<GetPluginLogsData, true>) {
    return (options.client ?? client).get<
      GetPluginLogsResponses,
      GetPluginLogsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/plugins/{plugin_id}/logs",
      ...options,
    });
  }

  /**
   * Get Plugin Log Stats
   *
   * Get log statistics (counts by level) for a plugin
   */
  public static getPluginLogStats(
    options: Options<GetPluginLogStatsData, true>
  ) {
    return (options.client ?? client).get<
      GetPluginLogStatsResponses,
      GetPluginLogStatsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/plugins/{plugin_id}/logs/stats",
      ...options,
    });
  }
}

export class ConversationsService {
  /**
   * List Conversations
   */
  public static listConversations(
    options: Options<ListConversationsData, true>
  ) {
    return (options.client ?? client).get<
      ListConversationsResponses,
      ListConversationsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation",
      ...options,
    });
  }

  /**
   * Create Conversation
   */
  public static createConversation(
    options: Options<CreateConversationData, true>
  ) {
    return (options.client ?? client).post<
      CreateConversationResponses,
      CreateConversationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Conversation Costs
   */
  public static listConversationCosts(
    options: Options<ListConversationCostsData, true>
  ) {
    return (options.client ?? client).get<
      ListConversationCostsResponses,
      ListConversationCostsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/costs",
      ...options,
    });
  }

  /**
   * Get Conversation Cost Summary
   */
  public static getConversationCostSummary(
    options: Options<GetConversationCostSummaryData, true>
  ) {
    return (options.client ?? client).get<
      GetConversationCostSummaryResponses,
      GetConversationCostSummaryErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/cost",
      ...options,
    });
  }

  /**
   * Bulk Export Feedback Csv
   */
  public static bulkExportFeedbackCsv(
    options: Options<BulkExportFeedbackCsvData, true>
  ) {
    return (options.client ?? client).post<
      BulkExportFeedbackCsvResponses,
      BulkExportFeedbackCsvErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/bulk/export-feedback",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Bulk Export Conversations Csv
   */
  public static bulkExportConversationsCsv(
    options: Options<BulkExportConversationsCsvData, true>
  ) {
    return (options.client ?? client).post<
      BulkExportConversationsCsvResponses,
      BulkExportConversationsCsvErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/bulk/export",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Bulk Delete Conversations
   */
  public static bulkDeleteConversations(
    options: Options<BulkDeleteConversationsData, true>
  ) {
    return (options.client ?? client).post<
      BulkDeleteConversationsResponses,
      BulkDeleteConversationsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/bulk/delete",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Conversation
   */
  public static deleteConversation(
    options: Options<DeleteConversationData, true>
  ) {
    return (options.client ?? client).delete<
      DeleteConversationResponses,
      DeleteConversationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}",
      ...options,
    });
  }

  /**
   * Get Conversation
   */
  public static getConversation(options: Options<GetConversationData, true>) {
    return (options.client ?? client).get<
      GetConversationResponses,
      GetConversationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}",
      ...options,
    });
  }

  /**
   * Update Conversation
   */
  public static updateConversation(
    options: Options<UpdateConversationData, true>
  ) {
    return (options.client ?? client).patch<
      UpdateConversationResponses,
      UpdateConversationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Add Message
   */
  public static addMessage(options: Options<AddMessageData, true>) {
    return (options.client ?? client).post<
      AddMessageResponses,
      AddMessageErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Rated Messages
   *
   * The conversation's thumbs-rated messages, in order, without their content.
   */
  public static listRatedMessages(
    options: Options<ListRatedMessagesData, true>
  ) {
    return (options.client ?? client).get<
      ListRatedMessagesResponses,
      ListRatedMessagesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/rated-messages",
      ...options,
    });
  }

  /**
   * Add Admin Message
   */
  public static addAdminMessage(options: Options<AddAdminMessageData, true>) {
    return (options.client ?? client).post<
      AddAdminMessageResponses,
      AddAdminMessageErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/adminmessage",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Refresh Message
   */
  public static refreshMessage(options: Options<RefreshMessageData, true>) {
    return (options.client ?? client).post<
      RefreshMessageResponses,
      RefreshMessageErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/messages/{message_id}/refresh",
      ...options,
    });
  }

  /**
   * Get Message Debug Info
   */
  public static getMessageDebugInfo(
    options: Options<GetMessageDebugInfoData, true>
  ) {
    return (options.client ?? client).get<
      GetMessageDebugInfoResponses,
      GetMessageDebugInfoErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/messages/debug",
      ...options,
    });
  }

  /**
   * Get Message Cost Breakdown
   */
  public static getMessageCostBreakdown(
    options: Options<GetMessageCostBreakdownData, true>
  ) {
    return (options.client ?? client).get<
      GetMessageCostBreakdownResponses,
      GetMessageCostBreakdownErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/messages/cost",
      ...options,
    });
  }

  /**
   * Remove Message Feedback
   */
  public static removeMessageFeedback(
    options: Options<RemoveMessageFeedbackData, true>
  ) {
    return (options.client ?? client).delete<
      RemoveMessageFeedbackResponses,
      RemoveMessageFeedbackErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/messages/{message_id}/feedback",
      ...options,
    });
  }

  /**
   * Add Message Feedback
   */
  public static addMessageFeedback(
    options: Options<AddMessageFeedbackData, true>
  ) {
    return (options.client ?? client).post<
      AddMessageFeedbackResponses,
      AddMessageFeedbackErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/messages/{message_id}/feedback",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Add Csat Response
   */
  public static addCsatResponse(options: Options<AddCsatResponseData, true>) {
    return (options.client ?? client).post<
      AddCsatResponseResponses,
      AddCsatResponseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/csat",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Defer Csat Response
   *
   * User dismissed the CSAT form without rating ('Maybe later').
   */
  public static deferCsatResponse(
    options: Options<DeferCsatResponseData, true>
  ) {
    return (options.client ?? client).post<
      DeferCsatResponseResponses,
      DeferCsatResponseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/csat/defer",
      ...options,
    });
  }

  /**
   * Trigger Csat Debug
   *
   * Push a CSAT form into the conversation's SSE stream. Dev/staging only.
   */
  public static triggerCsatDebug(options: Options<TriggerCsatDebugData, true>) {
    return (options.client ?? client).post<
      TriggerCsatDebugResponses,
      TriggerCsatDebugErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/debug/trigger-csat",
      ...options,
    });
  }

  /**
   * Conversation Events
   */
  public static conversationEvents(
    options: Options<ConversationEventsData, true>
  ) {
    return (options.client ?? client).get<
      ConversationEventsResponses,
      ConversationEventsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/events",
      ...options,
    });
  }

  /**
   * Vercel Events Resume
   */
  public static vercelEventsResume(
    options: Options<VercelEventsResumeData, true>
  ) {
    return (options.client ?? client).get<
      VercelEventsResumeResponses,
      VercelEventsResumeErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/vercel-events",
      ...options,
    });
  }

  /**
   * Vercel Events
   */
  public static vercelEvents(options: Options<VercelEventsData, true>) {
    return (options.client ?? client).post<
      VercelEventsResponses,
      VercelEventsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/vercel-events",
      ...options,
    });
  }

  /**
   * Stop Conversation
   */
  public static stopConversation(options: Options<StopConversationData, true>) {
    return (options.client ?? client).post<
      StopConversationResponses,
      StopConversationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/stop",
      ...options,
    });
  }

  /**
   * Get Conversation Execution Logs
   *
   * Get execution logs for a conversation (agent runs).
   *
   * Access restricted to platform admins or on-prem deployments.
   */
  public static getConversationExecutionLogs(
    options: Options<GetConversationExecutionLogsData, true>
  ) {
    return (options.client ?? client).get<
      GetConversationExecutionLogsResponses,
      GetConversationExecutionLogsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/execution-logs",
      ...options,
    });
  }

  /**
   * Get Conversation Spans
   *
   * Get OTel spans for a conversation's most recent run.
   *
   * Access restricted to platform admins or on-prem deployments.
   */
  public static getConversationSpans(
    options: Options<GetConversationSpansData, true>
  ) {
    return (options.client ?? client).get<
      GetConversationSpansResponses,
      GetConversationSpansErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/conversation/{conversation_id}/spans",
      ...options,
    });
  }
}

export class ClientsService {
  /**
   * Client Authorize
   *
   * Consent step (authenticated): register a device + mint a one-time code.
   */
  public static clientAuthorize(options: Options<ClientAuthorizeData, true>) {
    return (options.client ?? client).post<
      ClientAuthorizeResponses,
      ClientAuthorizeErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/clients/authorize",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Client Token
   *
   * Token step (public): exchange a code (PKCE) or refresh token for tokens.
   */
  public static clientToken(options: Options<ClientTokenData, true>) {
    return (options.client ?? client).post<
      ClientTokenResponses,
      ClientTokenErrors,
      true
    >({
      responseType: "json",
      url: "/clients/token",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Clients
   */
  public static listClients(options?: Options<ListClientsData, true>) {
    return (options?.client ?? client).get<ListClientsResponses, unknown, true>(
      {
        responseType: "json",
        security: [{ scheme: "bearer", type: "http" }],
        url: "/clients",
        ...options,
      }
    );
  }

  /**
   * Revoke Client
   */
  public static revokeClient(options: Options<RevokeClientData, true>) {
    return (options.client ?? client).post<
      RevokeClientResponses,
      RevokeClientErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/clients/{client_id}/revoke",
      ...options,
    });
  }

  /**
   * Revoke All Clients
   */
  public static revokeAllClients(
    options?: Options<RevokeAllClientsData, true>
  ) {
    return (options?.client ?? client).post<
      RevokeAllClientsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/clients/revoke-all",
      ...options,
    });
  }

  /**
   * Authorize Embed
   *
   * Mint a Noxus-issued access token for an embedded widget, same-origin.
   *
   * The ``/embed/authorize`` consent popup (served on the Noxus origin) calls
   * this for the signed-in user, then ``postMessage``s the token to the host
   * page — so the host never makes a cross-origin token call (no CORS) and the
   * widget runs as the real Noxus user. When the deployment is domain-locked the
   * requesting ``origin`` must be on its allow-list.
   */
  public static authorizeEmbed(options: Options<AuthorizeEmbedData, true>) {
    return (options.client ?? client).post<
      AuthorizeEmbedResponses,
      AuthorizeEmbedErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/clients/embed-authorize",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class EmbedSessionsService {
  /**
   * Exchange Embed Session
   *
   * Trade a host-signed JWT for a Noxus session (the only place it is taken).
   */
  public static exchangeEmbedSession(
    options: Options<ExchangeEmbedSessionData, true>
  ) {
    return (options.client ?? client).post<
      ExchangeEmbedSessionResponses,
      ExchangeEmbedSessionErrors,
      true
    >({
      responseType: "json",
      url: "/embed/session",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Refresh Embed Session
   */
  public static refreshEmbedSession(
    options: Options<RefreshEmbedSessionData, true>
  ) {
    return (options.client ?? client).post<
      RefreshEmbedSessionResponses,
      RefreshEmbedSessionErrors,
      true
    >({
      responseType: "json",
      url: "/embed/session/refresh",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Revoke Embed Sessions
   *
   * Kill every live session for the subject named by a host-signed token.
   *
   * Authenticated with the customer's own signing key: their backend mints a
   * token for the user it wants cut off and calls this. That restores the
   * immediate revocation they give up by moving to exchange mode.
   */
  public static revokeEmbedSessions(
    options: Options<RevokeEmbedSessionsData, true>
  ) {
    return (options.client ?? client).post<
      RevokeEmbedSessionsResponses,
      RevokeEmbedSessionsErrors,
      true
    >({
      responseType: "json",
      url: "/embed/session/revoke",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class AssistantsService {
  /**
   * Get Assistants
   */
  public static getAssistants(options: Options<GetAssistantsData, true>) {
    return (options.client ?? client).get<
      GetAssistantsResponses,
      GetAssistantsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants",
      ...options,
    });
  }

  /**
   * Add Assistant
   */
  public static addAssistant(options: Options<AddAssistantData, true>) {
    return (options.client ?? client).post<
      AddAssistantResponses,
      AddAssistantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Or Create Genie Assistant
   */
  public static getOrCreateGenieAssistant(
    options: Options<GetOrCreateGenieAssistantData, true>
  ) {
    return (options.client ?? client).get<
      GetOrCreateGenieAssistantResponses,
      GetOrCreateGenieAssistantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/genie/assistant",
      ...options,
    });
  }

  /**
   * Delete Assistant
   */
  public static deleteAssistant(options: Options<DeleteAssistantData, true>) {
    return (options.client ?? client).delete<
      DeleteAssistantResponses,
      DeleteAssistantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}",
      ...options,
    });
  }

  /**
   * Get Assistant
   */
  public static getAssistant(options: Options<GetAssistantData, true>) {
    return (options.client ?? client).get<
      GetAssistantResponses,
      GetAssistantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}",
      ...options,
    });
  }

  /**
   * Update Assistant
   */
  public static updateAssistant(options: Options<UpdateAssistantData, true>) {
    return (options.client ?? client).patch<
      UpdateAssistantResponses,
      UpdateAssistantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Duplicate Assistant
   */
  public static duplicateAssistant(
    options: Options<DuplicateAssistantData, true>
  ) {
    return (options.client ?? client).post<
      DuplicateAssistantResponses,
      DuplicateAssistantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/duplicate",
      ...options,
    });
  }

  /**
   * Get Assistant Public
   */
  public static getAssistantPublic(
    options: Options<GetAssistantPublicData, true>
  ) {
    return (options.client ?? client).get<
      GetAssistantPublicResponses,
      GetAssistantPublicErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistantId}/public",
      ...options,
    });
  }

  /**
   * Export Assistant Preview
   */
  public static exportAssistantPreview(
    options: Options<ExportAssistantPreviewData, true>
  ) {
    return (options.client ?? client).get<
      ExportAssistantPreviewResponses,
      ExportAssistantPreviewErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/export/preview",
      ...options,
    });
  }

  /**
   * Export Assistant
   */
  public static exportAssistant(options: Options<ExportAssistantData, true>) {
    return (options.client ?? client).post<
      ExportAssistantResponses,
      ExportAssistantErrors,
      true
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/export",
      ...options,
    });
  }

  /**
   * Restore Assistant
   */
  public static restoreAssistant(options: Options<RestoreAssistantData, true>) {
    return (options.client ?? client).post<
      RestoreAssistantResponses,
      RestoreAssistantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/restore",
      ...options,
    });
  }

  /**
   * Get Assistant Trigger Config
   */
  public static getAssistantTriggerConfig(
    options: Options<GetAssistantTriggerConfigData, true>
  ) {
    return (options.client ?? client).post<
      GetAssistantTriggerConfigResponses,
      GetAssistantTriggerConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/trigger/{trigger_type}/config",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Assistant Trigger Customization
   */
  public static getAssistantTriggerCustomization(
    options: Options<GetAssistantTriggerCustomizationData, true>
  ) {
    return (options.client ?? client).post<
      GetAssistantTriggerCustomizationResponses,
      GetAssistantTriggerCustomizationErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/trigger/{trigger_type}/customization",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Assistant Versions
   */
  public static getAssistantVersions(
    options: Options<GetAssistantVersionsData, true>
  ) {
    return (options.client ?? client).get<
      GetAssistantVersionsResponses,
      GetAssistantVersionsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/versions",
      ...options,
    });
  }

  /**
   * Create Assistant Version
   */
  public static createAssistantVersion(
    options: Options<CreateAssistantVersionData, true>
  ) {
    return (options.client ?? client).post<
      CreateAssistantVersionResponses,
      CreateAssistantVersionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/versions",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Assistant Version
   */
  public static getAssistantVersion(
    options: Options<GetAssistantVersionData, true>
  ) {
    return (options.client ?? client).get<
      GetAssistantVersionResponses,
      GetAssistantVersionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/versions/{version_id}",
      ...options,
    });
  }

  /**
   * Update Assistant Version
   */
  public static updateAssistantVersion(
    options: Options<UpdateAssistantVersionData, true>
  ) {
    return (options.client ?? client).post<
      UpdateAssistantVersionResponses,
      UpdateAssistantVersionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/versions/{version_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Is Valid Assistant
   */
  public static getIsValidAssistant(
    options: Options<GetIsValidAssistantData, true>
  ) {
    return (options.client ?? client).get<
      GetIsValidAssistantResponses,
      GetIsValidAssistantErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/valid",
      ...options,
    });
  }

  /**
   * Get Assistant Version Usages
   */
  public static getAssistantVersionUsages(
    options: Options<GetAssistantVersionUsagesData, true>
  ) {
    return (options.client ?? client).get<
      GetAssistantVersionUsagesResponses,
      GetAssistantVersionUsagesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/versions/{version_id}/usages",
      ...options,
    });
  }

  /**
   * Restore Assistant Version
   */
  public static restoreAssistantVersion(
    options: Options<RestoreAssistantVersionData, true>
  ) {
    return (options.client ?? client).post<
      RestoreAssistantVersionResponses,
      RestoreAssistantVersionErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/versions/{version_id}/restore",
      ...options,
    });
  }

  /**
   * Get Assistant Capability Updates
   */
  public static getAssistantCapabilityUpdates(
    options: Options<GetAssistantCapabilityUpdatesData, true>
  ) {
    return (options.client ?? client).get<
      GetAssistantCapabilityUpdatesResponses,
      GetAssistantCapabilityUpdatesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/capability-updates",
      ...options,
    });
  }

  /**
   * Apply Assistant Capability Updates
   */
  public static applyAssistantCapabilityUpdates(
    options: Options<ApplyAssistantCapabilityUpdatesData, true>
  ) {
    return (options.client ?? client).post<
      ApplyAssistantCapabilityUpdatesResponses,
      ApplyAssistantCapabilityUpdatesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/capability-updates",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Preview New Assistant Changes
   *
   * What settings an agent created now would get from a change, without
   * creating it: what Genie's card for a new agent shows before the user
   * approves.
   */
  public static previewNewAssistantChanges(
    options: Options<PreviewNewAssistantChangesData, true>
  ) {
    return (options.client ?? client).post<
      PreviewNewAssistantChangesResponses,
      PreviewNewAssistantChangesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/changes",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Preview Assistant Changes
   *
   * What a change would do to the agent, setting by setting, without making
   * it: what a Genie approval card shows before the user approves.
   */
  public static previewAssistantChanges(
    options: Options<PreviewAssistantChangesData, true>
  ) {
    return (options.client ?? client).post<
      PreviewAssistantChangesResponses,
      PreviewAssistantChangesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/changes",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Assistant Capabilities
   */
  public static getAssistantCapabilities(
    options: Options<GetAssistantCapabilitiesData, true>
  ) {
    return (options.client ?? client).get<
      GetAssistantCapabilitiesResponses,
      GetAssistantCapabilitiesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/capabilities",
      ...options,
    });
  }

  /**
   * List Assistant Tools
   */
  public static listAssistantTools(
    options: Options<ListAssistantToolsData, true>
  ) {
    return (options.client ?? client).get<
      ListAssistantToolsResponses,
      ListAssistantToolsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/tools",
      ...options,
    });
  }
}

export class DeploymentsService {
  /**
   * List Channels
   *
   * Return metadata for all registered deployment channels.
   *
   * Respects the platform component kill switch — channels added to
   * ``server_settings.components.disabled.channel`` are hidden from the
   * deployment picker.
   */
  public static listChannels(options?: Options<ListChannelsData, true>) {
    return (options?.client ?? client).get<
      ListChannelsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/channels",
      ...options,
    });
  }

  /**
   * List Deployments
   */
  public static listDeployments(options: Options<ListDeploymentsData, true>) {
    return (options.client ?? client).get<
      ListDeploymentsResponses,
      ListDeploymentsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/deployments",
      ...options,
    });
  }

  /**
   * Create Deployment
   */
  public static createDeployment(options: Options<CreateDeploymentData, true>) {
    return (options.client ?? client).post<
      CreateDeploymentResponses,
      CreateDeploymentErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/deployments",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Deployment
   */
  public static deleteDeployment(options: Options<DeleteDeploymentData, true>) {
    return (options.client ?? client).delete<
      DeleteDeploymentResponses,
      DeleteDeploymentErrors,
      true
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/deployments/{deployment_id}",
      ...options,
    });
  }

  /**
   * Get Deployment
   */
  public static getDeployment(options: Options<GetDeploymentData, true>) {
    return (options.client ?? client).get<
      GetDeploymentResponses,
      GetDeploymentErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/deployments/{deployment_id}",
      ...options,
    });
  }

  /**
   * Update Deployment
   */
  public static updateDeployment(options: Options<UpdateDeploymentData, true>) {
    return (options.client ?? client).patch<
      UpdateDeploymentResponses,
      UpdateDeploymentErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/deployments/{deployment_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Activate Deployment
   */
  public static activateDeployment(
    options: Options<ActivateDeploymentData, true>
  ) {
    return (options.client ?? client).post<
      ActivateDeploymentResponses,
      ActivateDeploymentErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/deployments/{deployment_id}/activate",
      ...options,
    });
  }

  /**
   * Deactivate Deployment
   */
  public static deactivateDeployment(
    options: Options<DeactivateDeploymentData, true>
  ) {
    return (options.client ?? client).post<
      DeactivateDeploymentResponses,
      DeactivateDeploymentErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/deployments/{deployment_id}/deactivate",
      ...options,
    });
  }

  /**
   * Pause Teams App
   */
  public static pauseTeamsApp(options: Options<PauseTeamsAppData, true>) {
    return (options.client ?? client).post<
      PauseTeamsAppResponses,
      PauseTeamsAppErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/deployments/{deployment_id}/teams-app/pause",
      ...options,
    });
  }

  /**
   * Resume Teams App
   */
  public static resumeTeamsApp(options: Options<ResumeTeamsAppData, true>) {
    return (options.client ?? client).post<
      ResumeTeamsAppResponses,
      ResumeTeamsAppErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/deployments/{deployment_id}/teams-app/resume",
      ...options,
    });
  }

  /**
   * Retry Teams App
   */
  public static retryTeamsApp(options: Options<RetryTeamsAppData, true>) {
    return (options.client ?? client).post<
      RetryTeamsAppResponses,
      RetryTeamsAppErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/deployments/{deployment_id}/teams-app/retry",
      ...options,
    });
  }

  /**
   * Get Deployment Config
   *
   * Return the config form schema for a deployment.
   *
   * Combines the trigger config schema with transport display fields.
   */
  public static getDeploymentConfig(
    options: Options<GetDeploymentConfigData, true>
  ) {
    return (options.client ?? client).post<
      GetDeploymentConfigResponses,
      GetDeploymentConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/deployments/{deployment_id}/config",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Deployment Events
   *
   * Return trigger events for a deployment.
   */
  public static getDeploymentEvents(
    options: Options<GetDeploymentEventsData, true>
  ) {
    return (options.client ?? client).get<
      GetDeploymentEventsResponses,
      GetDeploymentEventsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/deployments/{deployment_id}/events",
      ...options,
    });
  }

  /**
   * Get Deployment App By Alias
   *
   * Resolve a deployment by its stable alias, then serve the app payload.
   *
   * A separate route rather than widening the id path: a single path would have
   * to guess whether the segment is an id or an alias, and every existing embed
   * already carries an id. Resolves alias -> id and delegates, so there is one
   * cached payload and one invalidation path.
   */
  public static getDeploymentAppByAlias(
    options: Options<GetDeploymentAppByAliasData, true>
  ) {
    return (options.client ?? client).get<
      GetDeploymentAppByAliasResponses,
      GetDeploymentAppByAliasErrors,
      true
    >({
      responseType: "json",
      url: "/deployments/by-alias/{alias}/app",
      ...options,
    });
  }

  /**
   * Get Deployment App
   *
   * Public endpoint for app pages to resolve deployment info.
   *
   * Returns deployment config, assistant info, and permissions data
   * needed to render the app UI.
   *
   * Cached briefly: every public widget page load hits this endpoint, so we
   * serve a 60s snapshot to take pressure off the DB. Config edits propagate
   * within the TTL — acceptable for the deploy/preview UX.
   */
  public static getDeploymentApp(options: Options<GetDeploymentAppData, true>) {
    return (options.client ?? client).get<
      GetDeploymentAppResponses,
      GetDeploymentAppErrors,
      true
    >({
      responseType: "json",
      url: "/deployments/{deployment_id}/app",
      ...options,
    });
  }
}

export class PeriodicTasksService {
  /**
   * List Periodic Tasks
   */
  public static listPeriodicTasks(
    options: Options<ListPeriodicTasksData, true>
  ) {
    return (options.client ?? client).get<
      ListPeriodicTasksResponses,
      ListPeriodicTasksErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/periodic-tasks",
      ...options,
    });
  }

  /**
   * Create Periodic Task
   */
  public static createPeriodicTask(
    options: Options<CreatePeriodicTaskData, true>
  ) {
    return (options.client ?? client).post<
      CreatePeriodicTaskResponses,
      CreatePeriodicTaskErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/periodic-tasks",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Periodic Task
   */
  public static deletePeriodicTask(
    options: Options<DeletePeriodicTaskData, true>
  ) {
    return (options.client ?? client).delete<
      DeletePeriodicTaskResponses,
      DeletePeriodicTaskErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/periodic-tasks/{task_id}",
      ...options,
    });
  }

  /**
   * Update Periodic Task
   */
  public static updatePeriodicTask(
    options: Options<UpdatePeriodicTaskData, true>
  ) {
    return (options.client ?? client).patch<
      UpdatePeriodicTaskResponses,
      UpdatePeriodicTaskErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/periodic-tasks/{task_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class AnalyticsService {
  /**
   * Get Workflow Analytics Items
   */
  public static getWorkflowAnalyticsItems(
    options?: Options<GetWorkflowAnalyticsItemsData, true>
  ) {
    return (options?.client ?? client).get<
      GetWorkflowAnalyticsItemsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/analytics/workflows/metadata",
      ...options,
    });
  }

  /**
   * Get Api Analytics Items
   */
  public static getApiAnalyticsItems(
    options?: Options<GetApiAnalyticsItemsData, true>
  ) {
    return (options?.client ?? client).get<
      GetApiAnalyticsItemsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/analytics/api/metadata",
      ...options,
    });
  }

  /**
   * Get Chat Analytics Items
   */
  public static getChatAnalyticsItems(
    options?: Options<GetChatAnalyticsItemsData, true>
  ) {
    return (options?.client ?? client).get<
      GetChatAnalyticsItemsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/analytics/chat/metadata",
      ...options,
    });
  }

  /**
   * Get Workspace Analytics Items
   */
  public static getWorkspaceAnalyticsItems(
    options?: Options<GetWorkspaceAnalyticsItemsData, true>
  ) {
    return (options?.client ?? client).get<
      GetWorkspaceAnalyticsItemsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/analytics/workspace/metadata",
      ...options,
    });
  }

  /**
   * Get Billing Analytics Items
   */
  public static getBillingAnalyticsItems(
    options?: Options<GetBillingAnalyticsItemsData, true>
  ) {
    return (options?.client ?? client).get<
      GetBillingAnalyticsItemsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/analytics/billing/metadata",
      ...options,
    });
  }

  /**
   * Get Kb Analytics Items
   */
  public static getKbAnalyticsItems(
    options?: Options<GetKbAnalyticsItemsData, true>
  ) {
    return (options?.client ?? client).get<
      GetKbAnalyticsItemsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/analytics/kb/metadata",
      ...options,
    });
  }

  /**
   * Get Tenant Analytics Items
   */
  public static getTenantAnalyticsItems(
    options?: Options<GetTenantAnalyticsItemsData, true>
  ) {
    return (options?.client ?? client).get<
      GetTenantAnalyticsItemsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/analytics/tenant/metadata",
      ...options,
    });
  }

  /**
   * Get Control Center Analytics Items
   */
  public static getControlCenterAnalyticsItems(
    options?: Options<GetControlCenterAnalyticsItemsData, true>
  ) {
    return (options?.client ?? client).get<
      GetControlCenterAnalyticsItemsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/analytics/control-center/metadata",
      ...options,
    });
  }

  /**
   * Get Workflow Analytics
   */
  public static getWorkflowAnalytics(
    options: Options<GetWorkflowAnalyticsData, true>
  ) {
    return (options.client ?? client).get<
      GetWorkflowAnalyticsResponses,
      GetWorkflowAnalyticsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/analytics/workflows/{workflow_id}/{analytics_key}",
      ...options,
    });
  }

  /**
   * Get Assistant Analytics
   */
  public static getAssistantAnalytics(
    options: Options<GetAssistantAnalyticsData, true>
  ) {
    return (options.client ?? client).get<
      GetAssistantAnalyticsResponses,
      GetAssistantAnalyticsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/analytics/assistants/{assistant_id}/{analytics_key}",
      ...options,
    });
  }

  /**
   * Get Tenant Analytics
   */
  public static getTenantAnalytics(
    options: Options<GetTenantAnalyticsData, true>
  ) {
    return (options.client ?? client).get<
      GetTenantAnalyticsResponses,
      GetTenantAnalyticsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/analytics/groups/{group_id}/{analytics_key}",
      ...options,
    });
  }

  /**
   * Get Api Analytics
   */
  public static getApiAnalytics(options: Options<GetApiAnalyticsData, true>) {
    return (options.client ?? client).get<
      GetApiAnalyticsResponses,
      GetApiAnalyticsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/analytics/api/{group_id}/{analytics_key}",
      ...options,
    });
  }

  /**
   * Get Kb Analytics
   */
  public static getKbAnalytics(options: Options<GetKbAnalyticsData, true>) {
    return (options.client ?? client).get<
      GetKbAnalyticsResponses,
      GetKbAnalyticsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/analytics/kb/{kb_id}/{analytics_key}",
      ...options,
    });
  }

  /**
   * Get Infrastructure Analytics Items
   */
  public static getInfrastructureAnalyticsItems(
    options?: Options<GetInfrastructureAnalyticsItemsData, true>
  ) {
    return (options?.client ?? client).get<
      GetInfrastructureAnalyticsItemsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/analytics/infrastructure/metadata",
      ...options,
    });
  }

  /**
   * Get Infrastructure Analytics
   */
  public static getInfrastructureAnalytics(
    options: Options<GetInfrastructureAnalyticsData, true>
  ) {
    return (options.client ?? client).get<
      GetInfrastructureAnalyticsResponses,
      GetInfrastructureAnalyticsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/analytics/infrastructure",
      ...options,
    });
  }
}

export class InsightsService {
  /**
   * Get Sentiment Over Time
   *
   * Day-by-day positive/neutral/negative conversation sentiment.
   */
  public static getSentimentOverTime(
    options: Options<GetSentimentOverTimeData, true>
  ) {
    return (options.client ?? client).get<
      GetSentimentOverTimeResponses,
      GetSentimentOverTimeErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/insights/sentiment-over-time",
      ...options,
    });
  }

  /**
   * Get Rating Drivers
   *
   * What drove positive vs negative ratings — two ranked driver-theme lists.
   */
  public static getRatingDrivers(options: Options<GetRatingDriversData, true>) {
    return (options.client ?? client).get<
      GetRatingDriversResponses,
      GetRatingDriversErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/insights/rating-drivers",
      ...options,
    });
  }

  /**
   * Get Custom Insights
   *
   * Per custom-insight conversation counts, descending (the bar plot).
   */
  public static getCustomInsights(
    options: Options<GetCustomInsightsData, true>
  ) {
    return (options.client ?? client).get<
      GetCustomInsightsResponses,
      GetCustomInsightsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/insights/custom-insights",
      ...options,
    });
  }

  /**
   * Get Insight Conversations
   *
   * Conversations behind a clicked insight (topic / CX rating / driver / …).
   */
  public static getInsightConversations(
    options: Options<GetInsightConversationsData, true>
  ) {
    return (options.client ?? client).get<
      GetInsightConversationsResponses,
      GetInsightConversationsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/insights/conversations",
      ...options,
    });
  }

  /**
   * Get Sub Topics
   *
   * Sub-topic conversation counts (descending), optionally filtered by parent.
   */
  public static getSubTopics(options: Options<GetSubTopicsData, true>) {
    return (options.client ?? client).get<
      GetSubTopicsResponses,
      GetSubTopicsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/insights/sub-topics",
      ...options,
    });
  }

  /**
   * Get Noticed
   *
   * The latest "What the AI noticed" feed: trending/severe sub-topics.
   */
  public static getNoticed(options: Options<GetNoticedData, true>) {
    return (options.client ?? client).get<
      GetNoticedResponses,
      GetNoticedErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/insights/noticed",
      ...options,
    });
  }

  /**
   * Get Top Topics
   *
   * Most frequent conversation topics, descending (the bar plot).
   */
  public static getTopTopics(options: Options<GetTopTopicsData, true>) {
    return (options.client ?? client).get<
      GetTopTopicsResponses,
      GetTopTopicsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/insights/top-topics",
      ...options,
    });
  }

  /**
   * Get Conversation Funnel
   *
   * Conversation funnel: stage drop-off and terminal outcomes.
   */
  public static getConversationFunnel(
    options: Options<GetConversationFunnelData, true>
  ) {
    return (options.client ?? client).get<
      GetConversationFunnelResponses,
      GetConversationFunnelErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/insights/conversation-funnel",
      ...options,
    });
  }

  /**
   * Get Csat Score
   *
   * CX score: share of conversations rated 4 or 5, with rating breakdown.
   */
  public static getCsatScore(options: Options<GetCsatScoreData, true>) {
    return (options.client ?? client).get<
      GetCsatScoreResponses,
      GetCsatScoreErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/insights/csat-score",
      ...options,
    });
  }

  /**
   * Get Bootstrap Status
   *
   * Whether enough data exists to show the insights dashboard.
   */
  public static getBootstrapStatus(
    options: Options<GetBootstrapStatusData, true>
  ) {
    return (options.client ?? client).get<
      GetBootstrapStatusResponses,
      GetBootstrapStatusErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/insights/bootstrap",
      ...options,
    });
  }

  /**
   * Trigger Insights Bootstrap
   *
   * Start the first (manual, throttled) analysis of the agent's backlog.
   *
   * The periodic worker sweep does NOT auto-analyze a fresh agent's backlog. This
   * stamps the agent bootstrapped — so the sweep then handles ongoing
   * conversations — and defers a throttled backlog analysis to the worker
   * (executed N-at-a-time under the shared AI lock). Progress surfaces via
   * ``/insights/calculating`` and the plots' empty states.
   */
  public static triggerInsightsBootstrap(
    options: Options<TriggerInsightsBootstrapData, true>
  ) {
    return (options.client ?? client).post<
      TriggerInsightsBootstrapResponses,
      TriggerInsightsBootstrapErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/insights/bootstrap",
      ...options,
    });
  }

  /**
   * Get Calculating Insights
   *
   * Which plots are mid-calculation (worker- or debug-triggered).
   */
  public static getCalculatingInsights(
    options: Options<GetCalculatingInsightsData, true>
  ) {
    return (options.client ?? client).get<
      GetCalculatingInsightsResponses,
      GetCalculatingInsightsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/insights/calculating",
      ...options,
    });
  }

  /**
   * Debug Recompute Insights
   *
   * Compute one plot on demand, contained to that vertical.
   *
   * The per-conversation analysis pass (sentiment + outcome + custom) runs first
   * — the foundation every plot needs, a no-op once a conversation is analyzed —
   * then only the aggregate step(s) the requested plot depends on, so calculating
   * Top topics doesn't also recompute drivers/noticed. Locally this runs inline
   * (no worker); in prod it is deferred to the worker and ``target`` is marked
   * ``calculating`` so the dashboard shows a loading state (polled via
   * ``/insights/calculating``) until the worker clears it.
   */
  public static debugRecomputeInsights(
    options: Options<DebugRecomputeInsightsData, true>
  ) {
    return (options.client ?? client).post<
      DebugRecomputeInsightsResponses,
      DebugRecomputeInsightsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/assistants/{assistant_id}/insights/debug/recompute",
      ...options,
    });
  }
}

export class LabellingTasksService {
  /**
   * Get Labelling Tasks
   */
  public static getLabellingTasks(
    options: Options<GetLabellingTasksData, true>
  ) {
    return (options.client ?? client).get<
      GetLabellingTasksResponses,
      GetLabellingTasksErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/labelling_tasks",
      ...options,
    });
  }

  /**
   * Update Labelling Task
   */
  public static updateLabellingTask(
    options: Options<UpdateLabellingTaskData, true>
  ) {
    return (options.client ?? client).post<
      UpdateLabellingTaskResponses,
      UpdateLabellingTaskErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/labelling_tasks/{labelling_task_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Assign Labelling Task
   */
  public static assignLabellingTask(
    options: Options<AssignLabellingTaskData, true>
  ) {
    return (options.client ?? client).post<
      AssignLabellingTaskResponses,
      AssignLabellingTaskErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/labelling_tasks/{labelling_task_id}/assign",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class SafetyService {
  /**
   * Get Pii Safety Data
   */
  public static getPiiSafetyData(
    options?: Options<GetPiiSafetyDataData, true>
  ) {
    return (options?.client ?? client).get<
      GetPiiSafetyDataResponses,
      GetPiiSafetyDataErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/safety/pii",
      ...options,
    });
  }

  /**
   * Get Ai Safety Data
   */
  public static getAiSafetyData(options?: Options<GetAiSafetyDataData, true>) {
    return (options?.client ?? client).get<
      GetAiSafetyDataResponses,
      unknown,
      true
    >({
      responseType: "json",
      url: "/safety/ai",
      ...options,
    });
  }

  /**
   * Get Coworker Form
   *
   * The agent settings form, as the agent's capability pins define it.
   *
   * The builder has to render the shape the agent is pinned to, not the newest
   * one — otherwise it offers options the agent's versions don't read and shows
   * defaults it won't run on. Pins are version numbers, not tenant data, so
   * they stay a query parameter on this public form endpoint.
   *
   * Written as ``name:version`` pairs (``kb_search:2,noxus_settings:1``). No
   * pins means every capability's deployed version, which is what every caller
   * got before versioning.
   *
   * Feature-flag visibility is then applied against the *pinned* settings class
   * rather than the storage class: a version that added a flagged field is a
   * subclass, so passing the storage class would leave that field's flag
   * unresolved and show it to tenants without the flag.
   */
  public static getCoworkerForm(options?: Options<GetCoworkerFormData, true>) {
    return (options?.client ?? client).get<
      GetCoworkerFormResponses,
      GetCoworkerFormErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/safety/coworker",
      ...options,
    });
  }

  /**
   * Get Agent Form
   */
  public static getAgentForm(options?: Options<GetAgentFormData, true>) {
    return (options?.client ?? client).get<
      GetAgentFormResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/safety/agent",
      ...options,
    });
  }

  /**
   * Get Agent Tool Form
   */
  public static getAgentToolForm(options: Options<GetAgentToolFormData, true>) {
    return (options.client ?? client).get<
      GetAgentToolFormResponses,
      GetAgentToolFormErrors,
      true
    >({
      responseType: "json",
      url: "/safety/agent/tool/{tool_type}",
      ...options,
    });
  }

  /**
   * Get Disabled Agent Tools
   *
   * List tool types the config picker should hide: those disabled
   * platform-wide (ComponentKind.TOOL) and those whose tenant flag is off.
   *
   * The kill-switch half is also enforced server-side (see create_agent); this
   * endpoint drives the UI so authors don't configure a tool that will no-op.
   */
  public static getDisabledAgentTools(
    options?: Options<GetDisabledAgentToolsData, true>
  ) {
    return (options?.client ?? client).get<
      GetDisabledAgentToolsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/safety/agent/disabled-tools",
      ...options,
    });
  }

  /**
   * Get Agent Coworker Tool Form
   */
  public static getAgentCoworkerToolForm(
    options?: Options<GetAgentCoworkerToolFormData, true>
  ) {
    return (options?.client ?? client).get<
      GetAgentCoworkerToolFormResponses,
      unknown,
      true
    >({
      responseType: "json",
      url: "/safety/agent/coworker-tool",
      ...options,
    });
  }

  /**
   * Get Kb Form
   */
  public static getKbForm(options?: Options<GetKbFormData, true>) {
    return (options?.client ?? client).get<GetKbFormResponses, unknown, true>({
      responseType: "json",
      url: "/safety/kb",
      ...options,
    });
  }
}

export class FeatureFlagsService {
  /**
   * Get Feature Flags
   */
  public static getFeatureFlags(options?: Options<GetFeatureFlagsData, true>) {
    return (options?.client ?? client).get<
      GetFeatureFlagsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/tenant/feature-flags",
      ...options,
    });
  }

  /**
   * Get All Feature Flags
   */
  public static getAllFeatureFlags(
    options?: Options<GetAllFeatureFlagsData, true>
  ) {
    return (options?.client ?? client).get<
      GetAllFeatureFlagsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/feature-flags",
      ...options,
    });
  }

  /**
   * Get Enabled Beta Features
   */
  public static getEnabledBetaFeatures(
    options?: Options<GetEnabledBetaFeaturesData, true>
  ) {
    return (options?.client ?? client).get<
      GetEnabledBetaFeaturesResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/beta-features",
      ...options,
    });
  }

  /**
   * Get Beta Feature States
   */
  public static getBetaFeatureStates(
    options?: Options<GetBetaFeatureStatesData, true>
  ) {
    return (options?.client ?? client).get<
      GetBetaFeatureStatesResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/beta-features",
      ...options,
    });
  }

  /**
   * Set Beta Feature
   */
  public static setBetaFeature(options: Options<SetBetaFeatureData, true>) {
    return (options.client ?? client).put<
      SetBetaFeatureResponses,
      SetBetaFeatureErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/beta-features/{feature}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class AppsService {
  /**
   * Get App Config
   *
   * Get additional configuration fields by app type
   */
  public static getAppConfig(options: Options<GetAppConfigData, true>) {
    return (options.client ?? client).get<
      GetAppConfigResponses,
      GetAppConfigErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/apps/config/{app_type}",
      ...options,
    });
  }

  /**
   * List Apps
   */
  public static listApps(options: Options<ListAppsData, true>) {
    return (options.client ?? client).get<
      ListAppsResponses,
      ListAppsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/apps",
      ...options,
    });
  }
}

export class DocumentExtractionService {
  /**
   * Extract Document
   */
  public static extractDocument(options: Options<ExtractDocumentData, true>) {
    return (options.client ?? client).post<
      ExtractDocumentResponses,
      ExtractDocumentErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/document-extraction",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class TagsService {
  /**
   * List Tags
   */
  public static listTags(options: Options<ListTagsData, true>) {
    return (options.client ?? client).get<
      ListTagsResponses,
      ListTagsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tags",
      ...options,
    });
  }

  /**
   * Create Tag
   */
  public static createTag(options: Options<CreateTagData, true>) {
    return (options.client ?? client).post<
      CreateTagResponses,
      CreateTagErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tags",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Tag
   */
  public static deleteTag(options: Options<DeleteTagData, true>) {
    return (options.client ?? client).delete<
      DeleteTagResponses,
      DeleteTagErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tags/{tag_id}",
      ...options,
    });
  }

  /**
   * Get Tag
   *
   * Get a specific tag by ID.
   */
  public static getTag(options: Options<GetTagData, true>) {
    return (options.client ?? client).get<GetTagResponses, GetTagErrors, true>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tags/{tag_id}",
      ...options,
    });
  }

  /**
   * Update Tag
   */
  public static updateTag(options: Options<UpdateTagData, true>) {
    return (options.client ?? client).patch<
      UpdateTagResponses,
      UpdateTagErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tags/{tag_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Entities By Tag
   *
   * Get all entities that have a specific tag.
   */
  public static getEntitiesByTag(options: Options<GetEntitiesByTagData, true>) {
    return (options.client ?? client).get<
      GetEntitiesByTagResponses,
      GetEntitiesByTagErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tags/{tag_id}/entities",
      ...options,
    });
  }

  /**
   * Tag Entity
   *
   * Apply a tag to an entity.
   */
  public static tagEntity(options: Options<TagEntityData, true>) {
    return (options.client ?? client).post<
      TagEntityResponses,
      TagEntityErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tags/{tag_id}/entities",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Untag Entity
   *
   * Remove a tag from an entity.
   */
  public static untagEntity(options: Options<UntagEntityData, true>) {
    return (options.client ?? client).delete<
      UntagEntityResponses,
      UntagEntityErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tags/{tag_id}/entities/{entity_id}",
      ...options,
    });
  }

  /**
   * Get Entity Tags
   *
   * Get all tags for a specific entity.
   */
  public static getEntityTags(options: Options<GetEntityTagsData, true>) {
    return (options.client ?? client).get<
      GetEntityTagsResponses,
      GetEntityTagsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/entities/{entity_id}/tags",
      ...options,
    });
  }

  /**
   * Bulk Tag Entities
   *
   * Apply a tag to multiple entities at once.
   */
  public static bulkTagEntities(options: Options<BulkTagEntitiesData, true>) {
    return (options.client ?? client).post<
      BulkTagEntitiesResponses,
      BulkTagEntitiesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/tags/{tag_id}/entities/bulk",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class EvaluationService {
  /**
   * Get Evaluator Definitions
   *
   * Get all available evaluator type definitions.
   */
  public static getEvaluatorDefinitions(
    options?: Options<GetEvaluatorDefinitionsData, true>
  ) {
    return (options?.client ?? client).get<
      GetEvaluatorDefinitionsResponses,
      unknown,
      true
    >({
      responseType: "json",
      url: "/evaluator-definitions",
      ...options,
    });
  }

  /**
   * Get Workflow Evaluator Definitions
   *
   * Get evaluator type definitions that support workflow evaluation.
   */
  public static getWorkflowEvaluatorDefinitions(
    options?: Options<GetWorkflowEvaluatorDefinitionsData, true>
  ) {
    return (options?.client ?? client).get<
      GetWorkflowEvaluatorDefinitionsResponses,
      unknown,
      true
    >({
      responseType: "json",
      url: "/evaluator-definitions/workflow",
      ...options,
    });
  }

  /**
   * Get Agent Evaluator Definitions
   *
   * Get evaluator type definitions that support agent evaluation.
   */
  public static getAgentEvaluatorDefinitions(
    options?: Options<GetAgentEvaluatorDefinitionsData, true>
  ) {
    return (options?.client ?? client).get<
      GetAgentEvaluatorDefinitionsResponses,
      unknown,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/evaluator-definitions/agent",
      ...options,
    });
  }

  /**
   * Get Knowledge Base Evaluator Definitions
   *
   * Get evaluator type definitions that support knowledge_base retrieval evaluation.
   */
  public static getKnowledgeBaseEvaluatorDefinitions(
    options?: Options<GetKnowledgeBaseEvaluatorDefinitionsData, true>
  ) {
    return (options?.client ?? client).get<
      GetKnowledgeBaseEvaluatorDefinitionsResponses,
      unknown,
      true
    >({
      responseType: "json",
      url: "/evaluator-definitions/knowledge_base",
      ...options,
    });
  }

  /**
   * List Workflow Test Suites
   *
   * List test suites for a workflow with stats.
   */
  public static listWorkflowTestSuites(
    options: Options<ListWorkflowTestSuitesData, true>
  ) {
    return (options.client ?? client).get<
      ListWorkflowTestSuitesResponses,
      ListWorkflowTestSuitesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/test-suites",
      ...options,
    });
  }

  /**
   * Create Workflow Test Suite
   *
   * Create a test suite for a workflow.
   */
  public static createWorkflowTestSuite(
    options: Options<CreateWorkflowTestSuiteData, true>
  ) {
    return (options.client ?? client).post<
      CreateWorkflowTestSuiteResponses,
      CreateWorkflowTestSuiteErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/workflows/{workflow_id}/test-suites",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Test Suite
   *
   * Delete a test suite and all its test cases and evaluators.
   */
  public static deleteTestSuite(options: Options<DeleteTestSuiteData, true>) {
    return (options.client ?? client).delete<
      DeleteTestSuiteResponses,
      DeleteTestSuiteErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-suites/{test_suite_id}",
      ...options,
    });
  }

  /**
   * Get Test Suite
   *
   * Get a test suite by ID with stats.
   */
  public static getTestSuite(options: Options<GetTestSuiteData, true>) {
    return (options.client ?? client).get<
      GetTestSuiteResponses,
      GetTestSuiteErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-suites/{test_suite_id}",
      ...options,
    });
  }

  /**
   * Update Test Suite
   *
   * Update a test suite.
   */
  public static updateTestSuite(options: Options<UpdateTestSuiteData, true>) {
    return (options.client ?? client).patch<
      UpdateTestSuiteResponses,
      UpdateTestSuiteErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-suites/{test_suite_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Agent Test Suites
   *
   * List test suites for an agent with stats.
   */
  public static listAgentTestSuites(
    options: Options<ListAgentTestSuitesData, true>
  ) {
    return (options.client ?? client).get<
      ListAgentTestSuitesResponses,
      ListAgentTestSuitesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/agents/{agent_id}/test-suites",
      ...options,
    });
  }

  /**
   * Create Agent Test Suite
   *
   * Create a test suite for an agent.
   */
  public static createAgentTestSuite(
    options: Options<CreateAgentTestSuiteData, true>
  ) {
    return (options.client ?? client).post<
      CreateAgentTestSuiteResponses,
      CreateAgentTestSuiteErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/agents/{agent_id}/test-suites",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Kb Test Suites
   *
   * List retrieval test suites (datasets) for a knowledge base with stats.
   */
  public static listKbTestSuites(options: Options<ListKbTestSuitesData, true>) {
    return (options.client ?? client).get<
      ListKbTestSuitesResponses,
      ListKbTestSuitesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/knowledge-bases/{knowledge_base_id}/test-suites",
      ...options,
    });
  }

  /**
   * Create Kb Test Suite
   *
   * Create a retrieval test suite (dataset) for a knowledge base.
   */
  public static createKbTestSuite(
    options: Options<CreateKbTestSuiteData, true>
  ) {
    return (options.client ?? client).post<
      CreateKbTestSuiteResponses,
      CreateKbTestSuiteErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/knowledge-bases/{knowledge_base_id}/test-suites",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Start Kb Evaluation Run
   *
   * Launch a retrieval config-sweep run for a KB test suite (async).
   */
  public static startKbEvaluationRun(
    options: Options<StartKbEvaluationRunData, true>
  ) {
    return (options.client ?? client).post<
      StartKbEvaluationRunResponses,
      StartKbEvaluationRunErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-suites/{test_suite_id}/kb-run",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Generate Kb Synthetic Dataset
   *
   * Queue synthetic retrieval-eval dataset generation from a KB's chunks.
   */
  public static generateKbSyntheticDataset(
    options: Options<GenerateKbSyntheticDatasetData, true>
  ) {
    return (options.client ?? client).post<
      GenerateKbSyntheticDatasetResponses,
      GenerateKbSyntheticDatasetErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/knowledge-bases/{knowledge_base_id}/synthetic-datasets",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Kb Evaluation Comparison
   *
   * Get the per-config metric comparison for a KB retrieval evaluation run.
   */
  public static getKbEvaluationComparison(
    options: Options<GetKbEvaluationComparisonData, true>
  ) {
    return (options.client ?? client).get<
      GetKbEvaluationComparisonResponses,
      GetKbEvaluationComparisonErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/kb-evaluation-runs/{evaluation_run_id}/comparison",
      ...options,
    });
  }

  /**
   * Generate Answer Quality Dataset
   *
   * Queue answer-quality QA + refusal dataset generation onto an agent suite.
   */
  public static generateAnswerQualityDataset(
    options: Options<GenerateAnswerQualityDatasetData, true>
  ) {
    return (options.client ?? client).post<
      GenerateAnswerQualityDatasetResponses,
      GenerateAnswerQualityDatasetErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/agents/{agent_id}/answer-quality-datasets",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Answer Quality Summary
   *
   * Quality x latency x cost summary for an agent-suite evaluation run.
   */
  public static getAnswerQualitySummary(
    options: Options<GetAnswerQualitySummaryData, true>
  ) {
    return (options.client ?? client).get<
      GetAnswerQualitySummaryResponses,
      GetAnswerQualitySummaryErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/evaluation-runs/{evaluation_run_id}/answer-quality-summary",
      ...options,
    });
  }

  /**
   * Get Combined Report
   *
   * Per-question retrieval x search-cost x answer-quality join for two runs.
   */
  public static getCombinedReport(
    options: Options<GetCombinedReportData, true>
  ) {
    return (options.client ?? client).get<
      GetCombinedReportResponses,
      GetCombinedReportErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/evaluation-runs/{evaluation_run_id}/combined-report",
      ...options,
    });
  }

  /**
   * Set Test Suite Baseline
   *
   * Designate an evaluation run as the suite's regression baseline.
   */
  public static setTestSuiteBaseline(
    options: Options<SetTestSuiteBaselineData, true>
  ) {
    return (options.client ?? client).post<
      SetTestSuiteBaselineResponses,
      SetTestSuiteBaselineErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-suites/{test_suite_id}/baseline",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Evaluation Runs
   *
   * List batch evaluation runs for a suite (newest first) — baseline picker.
   */
  public static listEvaluationRuns(
    options: Options<ListEvaluationRunsData, true>
  ) {
    return (options.client ?? client).get<
      ListEvaluationRunsResponses,
      ListEvaluationRunsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-suites/{test_suite_id}/evaluation-runs",
      ...options,
    });
  }

  /**
   * Get Evaluation Run Report
   */
  public static getEvaluationRunReport(
    options: Options<GetEvaluationRunReportData, true>
  ) {
    return (options.client ?? client).get<
      GetEvaluationRunReportResponses,
      GetEvaluationRunReportErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-suites/{test_suite_id}/evaluation-runs/{evaluation_run_id}/report",
      ...options,
    });
  }

  /**
   * List Evaluators
   *
   * List evaluators for a test suite, or the checks of one of its agent tests.
   */
  public static listEvaluators(options: Options<ListEvaluatorsData, true>) {
    return (options.client ?? client).get<
      ListEvaluatorsResponses,
      ListEvaluatorsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-suites/{test_suite_id}/evaluators",
      ...options,
    });
  }

  /**
   * Create Evaluator
   *
   * Create an evaluator for a test suite.
   */
  public static createEvaluator(options: Options<CreateEvaluatorData, true>) {
    return (options.client ?? client).post<
      CreateEvaluatorResponses,
      CreateEvaluatorErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-suites/{test_suite_id}/evaluators",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Evaluator
   *
   * Delete an evaluator.
   */
  public static deleteEvaluator(options: Options<DeleteEvaluatorData, true>) {
    return (options.client ?? client).delete<
      DeleteEvaluatorResponses,
      DeleteEvaluatorErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/evaluators/{evaluator_id}",
      ...options,
    });
  }

  /**
   * Get Evaluator
   *
   * Get an evaluator by ID.
   */
  public static getEvaluator(options: Options<GetEvaluatorData, true>) {
    return (options.client ?? client).get<
      GetEvaluatorResponses,
      GetEvaluatorErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/evaluators/{evaluator_id}",
      ...options,
    });
  }

  /**
   * Update Evaluator
   *
   * Update an evaluator.
   */
  public static updateEvaluator(options: Options<UpdateEvaluatorData, true>) {
    return (options.client ?? client).patch<
      UpdateEvaluatorResponses,
      UpdateEvaluatorErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/evaluators/{evaluator_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List Test Cases
   *
   * List test cases in a test suite with evaluation results.
   */
  public static listTestCases(options: Options<ListTestCasesData, true>) {
    return (options.client ?? client).get<
      ListTestCasesResponses,
      ListTestCasesErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-suites/{test_suite_id}/test-cases",
      ...options,
    });
  }

  /**
   * Create Test Case
   *
   * Create a test case in a test suite; an agent test's checks are made with it.
   */
  public static createTestCase(options: Options<CreateTestCaseData, true>) {
    return (options.client ?? client).post<
      CreateTestCaseResponses,
      CreateTestCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-suites/{test_suite_id}/test-cases",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Test Case
   *
   * Delete a test case.
   */
  public static deleteTestCase(options: Options<DeleteTestCaseData, true>) {
    return (options.client ?? client).delete<
      DeleteTestCaseResponses,
      DeleteTestCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-cases/{test_case_id}",
      ...options,
    });
  }

  /**
   * Get Test Case
   *
   * Get a test case by ID.
   */
  public static getTestCase(options: Options<GetTestCaseData, true>) {
    return (options.client ?? client).get<
      GetTestCaseResponses,
      GetTestCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-cases/{test_case_id}",
      ...options,
    });
  }

  /**
   * Update Test Case
   *
   * Update a test case.
   */
  public static updateTestCase(options: Options<UpdateTestCaseData, true>) {
    return (options.client ?? client).patch<
      UpdateTestCaseResponses,
      UpdateTestCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-cases/{test_case_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Duplicate Test Case
   *
   * Duplicate a test case.
   */
  public static duplicateTestCase(
    options: Options<DuplicateTestCaseData, true>
  ) {
    return (options.client ?? client).post<
      DuplicateTestCaseResponses,
      DuplicateTestCaseErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-cases/{test_case_id}/duplicate",
      ...options,
    });
  }

  /**
   * Get Test Case Runs
   *
   * Get previous workflow runs associated with a test case via run.meta.test_case_id.
   */
  public static getTestCaseRuns(options: Options<GetTestCaseRunsData, true>) {
    return (options.client ?? client).get<
      GetTestCaseRunsResponses,
      GetTestCaseRunsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-cases/{test_case_id}/runs",
      ...options,
    });
  }

  /**
   * Create Test Case From Run
   *
   * Create a test case from a completed workflow run.
   */
  public static createTestCaseFromRun(
    options: Options<CreateTestCaseFromRunData, true>
  ) {
    return (options.client ?? client).post<
      CreateTestCaseFromRunResponses,
      CreateTestCaseFromRunErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-suites/{test_suite_id}/test-cases/from-run/{run_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Create Test Case From Message
   *
   * Create a test case from the user message a reply answered, given the reply's message ID.
   */
  public static createTestCaseFromMessage(
    options: Options<CreateTestCaseFromMessageData, true>
  ) {
    return (options.client ?? client).post<
      CreateTestCaseFromMessageResponses,
      CreateTestCaseFromMessageErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-suites/{test_suite_id}/test-cases/from-conversation/{conversation_id}/message/{message_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Evaluation Result
   *
   * Get a single evaluation result by ID.
   */
  public static getEvaluationResult(
    options: Options<GetEvaluationResultData, true>
  ) {
    return (options.client ?? client).get<
      GetEvaluationResultResponses,
      GetEvaluationResultErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/evaluation-results/{evaluation_result_id}",
      ...options,
    });
  }

  /**
   * Get Evaluation Result Detail
   *
   * Get complete evaluation result with all related data.
   *
   * Returns:
   * - Core result (score, feedback, status, timestamps)
   * - Full evaluator with config
   * - Expected output from test case
   * - Actual output from Run or Conversation
   * - Run metadata for navigation (workflow/agent name, run status, etc.)
   *
   * Use this endpoint when displaying individual evaluation result details.
   * For listing multiple results, use /test-cases/{id}/evaluation-results instead.
   */
  public static getEvaluationResultDetail(
    options: Options<GetEvaluationResultDetailData, true>
  ) {
    return (options.client ?? client).get<
      GetEvaluationResultDetailResponses,
      GetEvaluationResultDetailErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/evaluation-results/{evaluation_result_id}/detail",
      ...options,
    });
  }

  /**
   * Get Suite Evaluation Results
   *
   * Get paginated evaluation results for all test cases in a test suite.
   */
  public static getSuiteEvaluationResults(
    options: Options<GetSuiteEvaluationResultsData, true>
  ) {
    return (options.client ?? client).get<
      GetSuiteEvaluationResultsResponses,
      GetSuiteEvaluationResultsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-suites/{test_suite_id}/evaluation-results",
      ...options,
    });
  }

  /**
   * Start Evaluation Run
   *
   * Start evaluation runs for test cases in a test suite.
   *
   * The test suite determines whether this is a workflow or agent evaluation.
   * Returns run/result IDs for tracking.
   */
  public static startEvaluationRun(
    options: Options<StartEvaluationRunData, true>
  ) {
    return (options.client ?? client).post<
      StartEvaluationRunResponses,
      StartEvaluationRunErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-suites/{test_suite_id}/run-evaluation",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Cancel Evaluation Run
   *
   * Cancel pending evaluation results for a test suite.
   *
   * Marks PENDING evaluation results as CANCELLED.
   * If test_case_ids is provided, only cancels results for those test cases.
   */
  public static cancelEvaluationRun(
    options: Options<CancelEvaluationRunData, true>
  ) {
    return (options.client ?? client).post<
      CancelEvaluationRunResponses,
      CancelEvaluationRunErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/test-suites/{test_suite_id}/cancel-evaluation",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class NoxusInboxService {
  /**
   * Receive Email
   */
  public static receiveEmail(options?: Options<ReceiveEmailData, true>) {
    return (options?.client ?? client).post<
      ReceiveEmailResponses,
      ReceiveEmailErrors,
      true
    >({
      ...urlSearchParamsBodySerializer,
      responseType: "json",
      url: "/inbox/webhook",
      ...options,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        ...options?.headers,
      },
    });
  }
}

export class PresetsService {
  /**
   * Get Preset Config Form
   */
  public static getPresetConfigForm(
    options: Options<GetPresetConfigFormData, true>
  ) {
    return (options.client ?? client).get<
      GetPresetConfigFormResponses,
      GetPresetConfigFormErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/presets/config-form",
      ...options,
    });
  }

  /**
   * List Presets
   */
  public static listPresets(options: Options<ListPresetsData, true>) {
    return (options.client ?? client).get<
      ListPresetsResponses,
      ListPresetsErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/presets",
      ...options,
    });
  }

  /**
   * Create Preset
   */
  public static createPreset(options: Options<CreatePresetData, true>) {
    return (options.client ?? client).post<
      CreatePresetResponses,
      CreatePresetErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/presets",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Preset By Handle
   */
  public static getPresetByHandle(
    options: Options<GetPresetByHandleData, true>
  ) {
    return (options.client ?? client).get<
      GetPresetByHandleResponses,
      GetPresetByHandleErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/presets/{handle}",
      ...options,
    });
  }

  /**
   * Delete Preset
   */
  public static deletePreset(options: Options<DeletePresetData, true>) {
    return (options.client ?? client).delete<
      DeletePresetResponses,
      DeletePresetErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/presets/{preset_id}",
      ...options,
    });
  }

  /**
   * Update Preset
   */
  public static updatePreset(options: Options<UpdatePresetData, true>) {
    return (options.client ?? client).put<
      UpdatePresetResponses,
      UpdatePresetErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/presets/{preset_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Reset Preset To Default
   */
  public static resetPresetToDefault(
    options: Options<ResetPresetToDefaultData, true>
  ) {
    return (options.client ?? client).post<
      ResetPresetToDefaultResponses,
      ResetPresetToDefaultErrors,
      true
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/groups/{group_id}/models/presets/{handle}/reset",
      ...options,
    });
  }
}
